import { CSSProperties } from 'react';

interface IconProps {
    width?: string;
    height?: string;
    fill?: string;
    style?: CSSProperties;
    color?: string;
}

export const UnfollowIcon: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.8398 21.5879H3.1798C2.8558 21.5879 2.5918 21.3239 2.5918 20.9999C2.5918 17.7959 4.4038 14.9279 7.2118 13.5359C5.6638 12.3719 4.7038 10.5239 4.7038 8.54392C4.7038 5.11192 7.4998 2.31592 10.9318 2.31592C14.3638 2.31592 17.1598 5.11192 17.1598 8.54392C17.1598 10.5239 16.2118 12.3719 14.6518 13.5359C15.1318 13.7759 15.5998 14.0639 16.0198 14.3999C16.2718 14.6039 16.3198 14.9639 16.1278 15.2279C15.9238 15.4799 15.5638 15.5279 15.2998 15.3359C14.6518 14.8319 13.9318 14.4599 13.1638 14.1959C12.9358 14.1239 12.7798 13.9199 12.7558 13.6799C12.7318 13.4399 12.8758 13.2119 13.0918 13.1159C14.8438 12.2759 15.9718 10.4879 15.9718 8.55592C15.9718 5.77192 13.7038 3.50392 10.9198 3.50392C8.1358 3.50392 5.8678 5.77192 5.8678 8.55592C5.8678 10.4879 6.9958 12.2879 8.7478 13.1159C8.9638 13.2239 9.0958 13.4399 9.0838 13.6799C9.0718 13.9199 8.9038 14.1239 8.6758 14.1959C5.9158 15.1079 4.0078 17.5559 3.7798 20.4119H15.8278C16.1518 20.4119 16.4158 20.6759 16.4158 20.9999C16.4158 21.3239 16.1518 21.5879 15.8278 21.5879H15.8398Z"
                fill={fill}
            />
            <path
                d="M21.1082 18.696H14.4962C14.1722 18.696 13.9082 18.432 13.9082 18.108C13.9082 17.784 14.1722 17.52 14.4962 17.52H21.1082C21.4322 17.52 21.6962 17.784 21.6962 18.108C21.6962 18.432 21.4322 18.696 21.1082 18.696Z"
                fill={fill}
            />
        </svg>
    );
};

export const FollowIcon: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.8398 21.5879H3.1798C2.8558 21.5879 2.5918 21.3239 2.5918 20.9999C2.5918 17.7959 4.4038 14.9279 7.2118 13.5359C5.6638 12.3719 4.7038 10.5239 4.7038 8.54392C4.7038 5.11192 7.4998 2.31592 10.9318 2.31592C14.3638 2.31592 17.1598 5.11192 17.1598 8.54392C17.1598 10.5239 16.2118 12.3719 14.6518 13.5359C15.1318 13.7759 15.5998 14.0639 16.0198 14.3999C16.2718 14.6039 16.3198 14.9639 16.1278 15.2279C15.9238 15.4799 15.5638 15.5279 15.2998 15.3359C14.6518 14.8319 13.9318 14.4599 13.1638 14.1959C12.9358 14.1239 12.7798 13.9199 12.7558 13.6799C12.7318 13.4399 12.8758 13.2119 13.0918 13.1159C14.8438 12.2759 15.9718 10.4879 15.9718 8.55592C15.9718 5.77192 13.7038 3.50392 10.9198 3.50392C8.1358 3.50392 5.8678 5.77192 5.8678 8.55592C5.8678 10.4879 6.9958 12.2879 8.7478 13.1159C8.9638 13.2239 9.0958 13.4399 9.0838 13.6799C9.0718 13.9199 8.9038 14.1239 8.6758 14.1959C5.9158 15.1079 4.0078 17.5559 3.7798 20.4119H15.8278C16.1518 20.4119 16.4158 20.6759 16.4158 20.9999C16.4158 21.3239 16.1518 21.5879 15.8278 21.5879H15.8398Z"
                fill={fill}
            />
            <path
                d="M21.1202 17.52H18.3962V14.796C18.3962 14.472 18.1322 14.208 17.8082 14.208C17.4842 14.208 17.2202 14.472 17.2202 14.796V17.52H14.4962C14.1722 17.52 13.9082 17.784 13.9082 18.108C13.9082 18.432 14.1722 18.696 14.4962 18.696H17.2202V21.42C17.2202 21.744 17.4842 22.008 17.8082 22.008C18.1322 22.008 18.3962 21.744 18.3962 21.42V18.696H21.1202C21.4442 18.696 21.7082 18.432 21.7082 18.108C21.7082 17.784 21.4442 17.52 21.1202 17.52Z"
                fill={fill}
            />
        </svg>
    );
};

export const ZoomIn: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'white' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21 21L16.65 16.65"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11 8V14"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 11H14"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const Home: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="black"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0001 3.41421L4.00006 11.4142V21.0001H10V22.0001H4.00006H3.00006V21.0001V11.0001L3 11.0001L3.0005 10.9996L3.71141 10.2886L11.293 2.70711L12.0001 2L12.7072 2.70711L20.2885 10.2885L20.9996 10.9996L21.0001 11.0001L21.0001 11.0001V21.0001V22.0001H20.0001H12V21.0001H20.0001V11.4142L12.0001 3.41421Z"
                fill={fill}
            />
            <rect
                x="12"
                y="16"
                width="1"
                height="5"
                fill={fill}
            />
        </svg>
    );
};

export const HomeActive: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'black' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.0001 11.0001L12.0001 2L3 11.0001L3.00006 11.0001V22.0001H10V19.0001H11V22.0001H12V16.0001H13V22.0001H21.0001V11.0001L21.0001 11.0001Z"
                fill="#2073f6"
            />
        </svg>
    );
};

export const MyChannel: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'blue' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="3.5"
                y="3.5"
                width="17"
                height="17"
                stroke="black"
            />
            <rect
                x="9"
                y="7"
                width="1"
                height="4"
                fill="black"
            />
            <rect
                x="14"
                y="7"
                width="1"
                height="4"
                fill="black"
            />
            <rect
                x="15"
                y="17"
                width="5"
                height="1"
                fill="black"
            />
            <rect
                x="20"
                y="18"
                width="1"
                height="2"
                fill="white"
            />
        </svg>
    );
};

export const MyChannelActive: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'blue' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="path-1-inside-1_3_9864"
                fill="white"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 3H3V21H21V18H15V17H21V3ZM10 7H9V11H10V7ZM14 7H15V11H14V7Z"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 3H3V21H21V18H15V17H21V3ZM10 7H9V11H10V7ZM14 7H15V11H14V7Z"
                fill="#2073f6"
            />
            <path
                d="M3 3V2H2V3H3ZM21 3H22V2H21V3ZM3 21H2V22H3V21ZM21 21V22H22V21H21ZM21 18H22V17H21V18ZM15 18H14V19H15V18ZM15 17V16H14V17H15ZM21 17V18H22V17H21ZM9 7V6H8V7H9ZM10 7H11V6H10V7ZM9 11H8V12H9V11ZM10 11V12H11V11H10ZM15 7H16V6H15V7ZM14 7V6H13V7H14ZM15 11V12H16V11H15ZM14 11H13V12H14V11ZM3 4H21V2H3V4ZM4 21V3H2V21H4ZM21 20H3V22H21V20ZM20 18V21H22V18H20ZM21 17H15V19H21V17ZM16 18V17H14V18H16ZM15 18H21V16H15V18ZM20 3V17H22V3H20ZM9 8H10V6H9V8ZM10 11V7H8V11H10ZM10 10H9V12H10V10ZM9 7V11H11V7H9ZM15 6H14V8H15V6ZM16 11V7H14V11H16ZM14 12H15V10H14V12ZM13 7V11H15V7H13Z"
                fill="#2073f6"
                mask="url(#path-1-inside-1_3_9864)"
            />
        </svg>
    );
};

export const Community: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="black"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5789 2.99231L17.461 11.3617L20.9328 10.3201L22 10L21.8168 11.099L20 22H12V21H19.1529L20.7497 11.4191L17.7484 12.3195L16.994 12.5458L16.5972 11.8656L12 3.98463L7.40277 11.8656L7.00596 12.5458L6.25164 12.3195L3.25031 11.4191L4.84713 21H10V22H4L2.18316 11.099L2 10L3.06715 10.3201L6.53899 11.3617L11.4211 2.99231L12 2L12.5789 2.99231Z"
                fill={fill}
            />
            <rect
                x="12"
                y="16"
                width="1"
                height="5"
                fill={fill}
            />
        </svg>
    );
};

export const CommunityActive: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'black' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2L16.9646 10.5106L12 12L7.03545 10.5106L12 2ZM12 13L2 10L4 22H10V19H11V22H12V16H13V22H20L22 10L12 13Z"
                fill="#2073F6"
            />
        </svg>
    );
};

export const Writing: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'black' }) => {
    return (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_1357_3247)">
                <circle
                    cx="21"
                    cy="20"
                    r="20"
                    fill="#2073F6"
                />
            </g>
            <rect
                x="13"
                y="19"
                width="16"
                height="2"
                fill="white"
            />
            <path
                d="M20 12H22V28H20V12Z"
                fill="white"
            />
            <defs>
                <filter
                    id="filter0_d_1357_3247"
                    x="0"
                    y="0"
                    width="44"
                    height="44"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset
                        dx="1"
                        dy="2"
                    />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite
                        in2="hardAlpha"
                        operator="out"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.12549 0 0 0 0 0.45098 0 0 0 0 0.964706 0 0 0 0.2 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1357_3247"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1357_3247"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const WritingActive: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'black' }) => {
    return (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_1357_3247)">
                <circle
                    cx="21"
                    cy="20"
                    r="20"
                    fill="#2073F6"
                />
            </g>
            <rect
                x="13"
                y="19"
                width="16"
                height="2"
                fill="white"
            />
            <path
                d="M20 12H22V28H20V12Z"
                fill="white"
            />
            <defs>
                <filter
                    id="filter0_d_1357_3247"
                    x="0"
                    y="0"
                    width="44"
                    height="44"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset
                        dx="1"
                        dy="2"
                    />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite
                        in2="hardAlpha"
                        operator="out"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.12549 0 0 0 0 0.45098 0 0 0 0 0.964706 0 0 0 0.2 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1357_3247"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1357_3247"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const PointDot = ({ width = 14, height = 14 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="7"
                cy="7"
                r="6.5"
                fill="#2073F6"
                stroke="#0357DB"
            />
            <path
                d="M5.2327 10.7002V3.34019H7.4627C9.1027 3.34019 10.2727 3.9002 10.2727 5.5602C10.2727 7.1702 9.1027 7.9102 7.5027 7.9102H6.3927V10.7002H5.2327ZM6.3927 6.9802H7.3927C8.5727 6.9802 9.1327 6.5302 9.1327 5.5602C9.1327 4.5902 8.5227 4.2702 7.3527 4.2702H6.3927V6.9802Z"
                fill="white"
            />
        </svg>
    );
};

export const StoreIcon: React.FC = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 7H20V19H21V7V6H20H4H3V7V21V22H4H20H21V21H20H4V7Z"
                fill="black"
            />
            <path
                d="M8.5 12V3.5L9.40909 2.5H14.5909L15.5 3.5V12"
                stroke="black"
            />
        </svg>
    );
};

export const StoreIconActive: React.FC = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.40909 2H9.18791L9.03912 2.16366L8.13003 3.16366L8 3.3067V3.5V6H3V22H21V6H16V3.5V3.3067L15.87 3.16366L14.9609 2.16366L14.8121 2H14.5909H9.40909ZM15 6H16V12H15V6ZM15 6H9V3.6933L9.63028 3H14.3697L15 3.6933V6ZM9 6V12H8V6H9Z"
                fill="#2073F6"
            />
        </svg>
    );
};

export const UserNullIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <rect
                width="28"
                height="28.0001"
                fill="#F1F1F1"
            />
            <path
                d="M5.25 28.0001C5.25 28.0001 3.5 28.0001 3.5 26.2501C3.5 24.5001 5.25 19.25 14 19.25C22.75 19.25 24.5 24.5001 24.5 26.2501C24.5 28.0001 22.75 28.0001 22.75 28.0001H5.25Z"
                fill="white"
            />
            <path
                d="M14 17.5C16.8995 17.5 19.25 15.1495 19.25 12.25C19.25 9.35051 16.8995 7 14 7C11.1005 7 8.75 9.35051 8.75 12.25C8.75 15.1495 11.1005 17.5 14 17.5Z"
                fill="white"
            />
        </svg>
    );
};

export const GradientBorder = ({ width = 74, height = 74 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 74 74"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="1.5"
                y="1.5"
                width="71"
                height="71"
                rx="31.5"
                stroke="url(#paint0_linear_3_21983)"
                strokeWidth="3"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3_21983"
                    x1="77.5615"
                    y1="-3.13558"
                    x2="-25.1541"
                    y2="24.6128"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE924" />
                    <stop
                        offset="0.255208"
                        stopColor="#FF4A4D"
                    />
                    <stop
                        offset="0.52667"
                        stopColor="#B238FF"
                    />
                    <stop
                        offset="0.729167"
                        stopColor="#3D81FF"
                    />
                    <stop
                        offset="1"
                        stopColor="#41FFD2"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const EclipseImage = ({ width = 34, height = 34 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="17"
                cy="17"
                r="17"
                fill="white"
            />
        </svg>
    );
};

export const HeartIcon = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.32235 10.2385L1.95723 10.5801L2.32235 10.2385ZM2.32235 3.4135L2.68748 3.75508L2.32235 3.4135ZM9.30105 17.6982L9.66618 17.3566L9.30105 17.6982ZM9.99996 18.0005L10.0086 17.5006L9.99996 17.5004L9.99131 17.5006L9.99996 18.0005ZM10.6989 17.6982L10.3337 17.3566L10.6989 17.6982ZM17.6776 10.2385L17.3124 9.89688L17.6776 10.2385ZM17.6776 3.4135L17.3124 3.75508V3.75508L17.6776 3.4135ZM11.2927 3.4135L11.6578 3.75508V3.75508L11.2927 3.4135ZM9.99996 4.79532L9.63483 5.13691L9.99996 5.5272L10.3651 5.13691L9.99996 4.79532ZM8.70724 3.4135L9.07237 3.07191V3.07191L8.70724 3.4135ZM2.68748 9.89688C1.10417 8.20444 1.10417 5.44752 2.68748 3.75508L1.95722 3.07191C0.0142572 5.1488 0.0142599 8.50317 1.95723 10.5801L2.68748 9.89688ZM9.66618 17.3566L2.68748 9.89688L1.95723 10.5801L8.93592 18.0398L9.66618 17.3566ZM9.99131 17.5006C9.87992 17.5025 9.76204 17.459 9.66618 17.3566L8.93592 18.0398C9.22537 18.3492 9.61505 18.5073 10.0086 18.5004L9.99131 17.5006ZM9.99131 18.5004C10.3849 18.5073 10.7746 18.3492 11.064 18.0398L10.3337 17.3566C10.2379 17.459 10.12 17.5025 10.0086 17.5006L9.99131 18.5004ZM11.064 18.0398L18.0427 10.5801L17.3124 9.89688L10.3337 17.3566L11.064 18.0398ZM18.0427 10.5801C19.9857 8.50317 19.9857 5.1488 18.0427 3.07191L17.3124 3.75508C18.8958 5.44752 18.8958 8.20444 17.3124 9.89688L18.0427 10.5801ZM18.0427 3.07191C16.082 0.97603 12.8883 0.976029 10.9276 3.07191L11.6578 3.75508C13.2234 2.08164 15.7469 2.08164 17.3124 3.75508L18.0427 3.07191ZM10.9276 3.07191L9.63483 4.45373L10.3651 5.13691L11.6578 3.75508L10.9276 3.07191ZM8.34211 3.75508L9.63483 5.13691L10.3651 4.45373L9.07237 3.07191L8.34211 3.75508ZM2.68748 3.75508C4.25302 2.08164 6.77657 2.08164 8.34211 3.75508L9.07237 3.07191C7.11163 0.976029 3.91796 0.97603 1.95722 3.07191L2.68748 3.75508Z"
                fill="black"
            />
        </svg>
    );
};

export const HeartIconActiveMyChannel = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                y="12"
                width="8"
                height="8"
                fill="#FDD000"
            />
            <path
                d="M2.32238 10.2384L1.95725 10.58L2.32238 10.2384ZM2.32238 3.41342L2.68751 3.755L2.32238 3.41342ZM9.30107 17.6981L9.6662 17.3565L9.30107 17.6981ZM9.99999 18.0004L10.0086 17.5005L9.99999 17.5004L9.99133 17.5005L9.99999 18.0004ZM10.6989 17.6981L10.3338 17.3565L10.6989 17.6981ZM17.6776 10.2384L17.3125 9.8968L17.6776 10.2384ZM17.6776 3.41342L17.3125 3.755V3.755L17.6776 3.41342ZM11.2927 3.41342L11.6578 3.755V3.755L11.2927 3.41342ZM9.99999 4.79524L9.63486 5.13683L9.99999 5.52712L10.3651 5.13683L9.99999 4.79524ZM8.70727 3.41342L9.0724 3.07183V3.07183L8.70727 3.41342ZM2.68751 9.8968C1.1042 8.20436 1.1042 5.44744 2.68751 3.755L1.95725 3.07183C0.0142821 5.14872 0.0142847 8.50309 1.95725 10.58L2.68751 9.8968ZM9.6662 17.3565L2.68751 9.8968L1.95725 10.58L8.93594 18.0397L9.6662 17.3565ZM9.99133 17.5005C9.87994 17.5024 9.76206 17.459 9.6662 17.3565L8.93594 18.0397C9.2254 18.3491 9.61507 18.5072 10.0086 18.5004L9.99133 17.5005ZM9.99133 18.5004C10.3849 18.5072 10.7746 18.3491 11.064 18.0397L10.3338 17.3565C10.2379 17.459 10.12 17.5024 10.0086 17.5005L9.99133 18.5004ZM11.064 18.0397L18.0427 10.58L17.3125 9.8968L10.3338 17.3565L11.064 18.0397ZM18.0427 10.58C19.9857 8.50309 19.9857 5.14872 18.0427 3.07183L17.3125 3.755C18.8958 5.44744 18.8958 8.20436 17.3125 9.8968L18.0427 10.58ZM18.0427 3.07183C16.082 0.975951 12.8883 0.97595 10.9276 3.07183L11.6578 3.755C13.2234 2.08156 15.7469 2.08156 17.3125 3.755L18.0427 3.07183ZM10.9276 3.07183L9.63486 4.45366L10.3651 5.13683L11.6578 3.755L10.9276 3.07183ZM8.34214 3.755L9.63486 5.13683L10.3651 4.45366L9.0724 3.07183L8.34214 3.755ZM2.68751 3.755C4.25305 2.08156 6.7766 2.08156 8.34214 3.755L9.0724 3.07183C7.11166 0.97595 3.91799 0.975951 1.95725 3.07183L2.68751 3.755Z"
                fill="black"
            />
        </svg>
    );
};

export const HeartIconActive = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.88157 1.94233C0.706146 3.19877 0.706143 5.23585 1.88157 6.49229L6.30629 11.222C6.4976 11.4265 6.74918 11.5273 6.9999 11.5244C7.25063 11.5273 7.50221 11.4265 7.69352 11.222L12.1182 6.49229C13.2937 5.23585 13.2937 3.19877 12.1182 1.94233C10.9428 0.685891 9.03708 0.68589 7.86166 1.94233L6.9999 2.86348L6.13815 1.94233C4.96273 0.68589 3.05699 0.685891 1.88157 1.94233Z"
                fill="#FF2164"
            />
            <path
                d="M1.88157 6.49229L2.24669 6.1507L1.88157 6.49229ZM1.88157 1.94233L1.51644 1.60074L1.88157 1.94233ZM6.30629 11.222L6.67142 10.8804H6.67142L6.30629 11.222ZM6.9999 11.5244L7.00564 11.0243L6.99416 11.0244L6.9999 11.5244ZM7.69352 11.222L7.32839 10.8804L7.69352 11.222ZM12.1182 6.49229L12.4834 6.83388L12.1182 6.49229ZM12.1182 1.94233L12.4834 1.60074L12.1182 1.94233ZM7.86166 1.94233L8.22679 2.28391L7.86166 1.94233ZM6.9999 2.86348L6.63477 3.20507L6.9999 3.59536L7.36503 3.20507L6.9999 2.86348ZM6.13815 1.94233L6.50328 1.60074V1.60074L6.13815 1.94233ZM2.24669 6.1507C1.2511 5.08649 1.2511 3.34813 2.2467 2.28391L1.51644 1.60074C0.161189 3.0494 0.161186 5.38522 1.51644 6.83388L2.24669 6.1507ZM6.67142 10.8804L2.24669 6.1507L1.51644 6.83388L5.94116 11.5636L6.67142 10.8804ZM6.99416 11.0244C6.88354 11.0257 6.76664 10.9822 6.67142 10.8804L5.94116 11.5636C6.22856 11.8708 6.61481 12.0289 7.00564 12.0244L6.99416 11.0244ZM6.99416 12.0244C7.38499 12.0289 7.77124 11.8708 8.05864 11.5636L7.32839 10.8804C7.23317 10.9822 7.11627 11.0257 7.00564 11.0244L6.99416 12.0244ZM8.05864 11.5636L12.4834 6.83388L11.7531 6.1507L7.32839 10.8804L8.05864 11.5636ZM12.4834 6.83388C13.8386 5.38522 13.8386 3.0494 12.4834 1.60074L11.7531 2.28391C12.7487 3.34813 12.7487 5.08649 11.7531 6.1507L12.4834 6.83388ZM12.4834 1.60074C11.1103 0.133086 8.86955 0.133086 7.49653 1.60074L8.22679 2.28391C9.20461 1.2387 10.7753 1.2387 11.7531 2.28391L12.4834 1.60074ZM7.49653 1.60074L6.63477 2.5219L7.36503 3.20507L8.22679 2.28391L7.49653 1.60074ZM5.77302 2.28391L6.63477 3.20507L7.36503 2.5219L6.50328 1.60074L5.77302 2.28391ZM2.2467 2.28391C3.22452 1.2387 4.7952 1.2387 5.77302 2.28391L6.50328 1.60074C5.13026 0.133086 2.88946 0.133086 1.51644 1.60074L2.2467 2.28391Z"
                fill="black"
            />
        </svg>
    );
};

export const CommentIcon = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="path-1-inside-1_3_21904"
                fill="white"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 2C16.6569 2 18 3.34315 18 5V14V16V19L14.25 16H5C3.34315 16 2 14.6569 2 13V5C2 3.34315 3.34315 2 5 2H15Z"
                />
            </mask>
            <path
                d="M18 19H19V21.0806L17.3753 19.7809L18 19ZM14.25 16V15H14.6008L14.8747 15.2191L14.25 16ZM17 5C17 3.89543 16.1046 3 15 3V1C17.2091 1 19 2.79086 19 5H17ZM17 14V5H19V14H17ZM17 16V14H19V16H17ZM17 19V16H19V19H17ZM14.8747 15.2191L18.6247 18.2191L17.3753 19.7809L13.6253 16.7809L14.8747 15.2191ZM5 15H14.25V17H5V15ZM3 13C3 14.1046 3.89543 15 5 15V17C2.79086 17 1 15.2091 1 13H3ZM3 5V13H1V5H3ZM5 3C3.89543 3 3 3.89543 3 5H1C1 2.79086 2.79086 1 5 1V3ZM15 3H5V1H15V3Z"
                fill="black"
                mask="url(#path-1-inside-1_3_21904)"
            />
        </svg>
    );
};

export const CommentIconActiveMyChannel = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                y="12"
                width="8"
                height="8"
                fill="#FDD000"
            />
            <mask
                id="path-2-inside-1_4128_2487"
                fill="white"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 2C16.6569 2 18 3.34315 18 5V14V16V19L14.25 16H5C3.34315 16 2 14.6569 2 13V5C2 3.34315 3.34315 2 5 2H15Z"
                />
            </mask>
            <path
                d="M18 19H19V21.0806L17.3753 19.7809L18 19ZM14.25 16V15H14.6008L14.8747 15.2191L14.25 16ZM17 5C17 3.89543 16.1046 3 15 3V1C17.2091 1 19 2.79086 19 5H17ZM17 14V5H19V14H17ZM17 16V14H19V16H17ZM17 19V16H19V19H17ZM14.8747 15.2191L18.6247 18.2191L17.3753 19.7809L13.6253 16.7809L14.8747 15.2191ZM5 15H14.25V17H5V15ZM3 13C3 14.1046 3.89543 15 5 15V17C2.79086 17 1 15.2091 1 13H3ZM3 5V13H1V5H3ZM5 3C3.89543 3 3 3.89543 3 5H1C1 2.79086 2.79086 1 5 1V3ZM15 3H5V1H15V3Z"
                fill="black"
                mask="url(#path-2-inside-1_4128_2487)"
            />
        </svg>
    );
};

export const BookMarkIcon = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.33325 7.5C3.33325 5.14298 3.33325 3.96447 4.06548 3.23223C4.79772 2.5 5.97623 2.5 8.33325 2.5H11.6666C14.0236 2.5 15.2021 2.5 15.9344 3.23223C16.6666 3.96447 16.6666 5.14298 16.6666 7.5V13.1897C16.6666 15.4257 16.6666 16.5438 15.963 16.8857C15.2594 17.2277 14.3803 16.537 12.622 15.1555L12.0593 14.7133C11.0707 13.9365 10.5764 13.5482 9.99992 13.5482C9.42348 13.5482 8.92916 13.9365 7.94051 14.7133L7.3778 15.1555C5.61954 16.537 4.74041 17.2277 4.03683 16.8857C3.33325 16.5438 3.33325 15.4257 3.33325 13.1897V7.5Z"
                stroke="black"
            />
        </svg>
    );
};

export const BookMarkIconActiveMyChannel = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                y="12"
                width="8"
                height="8"
                fill="#FDD000"
            />
            <path
                d="M3.33337 7.5C3.33337 5.14298 3.33337 3.96447 4.06561 3.23223C4.79784 2.5 5.97635 2.5 8.33337 2.5H11.6667C14.0237 2.5 15.2022 2.5 15.9345 3.23223C16.6667 3.96447 16.6667 5.14298 16.6667 7.5V13.1897C16.6667 15.4257 16.6667 16.5438 15.9631 16.8857C15.2596 17.2277 14.3804 16.537 12.6222 15.1555L12.0594 14.7133C11.0708 13.9365 10.5765 13.5482 10 13.5482C9.4236 13.5482 8.92928 13.9365 7.94063 14.7133L7.37793 15.1555C5.61966 16.537 4.74053 17.2277 4.03695 16.8857C3.33337 16.5438 3.33337 15.4257 3.33337 13.1897V7.5Z"
                stroke="black"
            />
        </svg>
    );
};

export const ShareIcon = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.83333 6.66667L10 2.5M10 2.5L14.1667 6.66667M10 2.5L10 12.8333"
                stroke="black"
            />
            <path
                d="M2.5 9.1665V13.4998C2.5 15.3855 2.5 16.3283 3.08579 16.9141C3.67157 17.4998 4.61438 17.4998 6.5 17.4998H13.5C15.3856 17.4998 16.3284 17.4998 16.9142 16.9141C17.5 16.3283 17.5 15.3855 17.5 13.4998V9.1665"
                stroke="black"
            />
        </svg>
    );
};

export const IsInfluencerIcon = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 14 15"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.881568 4.44233C-0.293854 5.69877 -0.293857 7.73585 0.881565 8.99229L5.30629 13.722C5.4976 13.9265 5.74918 14.0273 5.9999 14.0244C6.25063 14.0273 6.50221 13.9265 6.69352 13.722L11.1182 8.99229C12.2937 7.73585 12.2937 5.69877 11.1182 4.44233C9.94282 3.18589 8.03708 3.18589 6.86166 4.44233L5.9999 5.36348L5.13815 4.44233C3.96273 3.18589 2.05699 3.18589 0.881568 4.44233Z"
                fill="#AF2DFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.58771 0.628214C5.8041 1.46583 5.8041 2.82388 6.58771 3.6615L9.45693 6.72849C9.60672 6.88859 9.80359 6.96769 9.99989 6.96578C10.1962 6.96769 10.3931 6.88859 10.5429 6.72849L13.4121 3.6615C14.1957 2.82388 14.1957 1.46583 13.4121 0.628214C12.6285 -0.209405 11.358 -0.209405 10.5744 0.628214L9.99989 1.2423L9.4254 0.628214C8.64179 -0.209405 7.37131 -0.209405 6.58771 0.628214Z"
                fill="#FFBC11"
                fillOpacity="0.5"
            />
        </svg>
    );
};
export const IsStaff = ({ width = 14, height = 14, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 3.45488C0 1.82623 0 1.01191 0.494257 0.505955C0.988515 0 1.78401 0 3.375 0H5.625C7.21599 0 8.01149 0 8.50574 0.505955C9 1.01191 9 1.82623 9 3.45488V7.3863C9 8.93137 9 9.70391 8.52508 9.9402C8.05017 10.1765 7.45676 9.6992 6.26993 8.74462L5.8901 8.43912C5.22276 7.90238 4.8891 7.634 4.5 7.634C4.1109 7.634 3.77724 7.90238 3.1099 8.43912L2.73007 8.74462C1.54324 9.6992 0.94983 10.1765 0.474915 9.9402C0 9.70391 0 8.93137 0 7.3863V3.45488Z"
                fill="#4C3CFF"
            />
            <path
                d="M4 4.72727C4 4.32561 4.32561 4 4.72727 4H8C10.2091 4 12 5.79086 12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8V4.72727Z"
                fill="#16D7B4"
                fill-opacity="0.5"
            />
        </svg>
    );
};
export const IsExpert = ({ width = '14', height = '14', color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                d="M1 4.45488C1 2.82623 1 2.01191 1.49426 1.50596C1.98851 1 2.78401 1 4.375 1H6.625C8.21599 1 9.01149 1 9.50574 1.50596C10 2.01191 10 2.82623 10 4.45488V8.3863C10 9.93137 10 10.7039 9.52508 10.9402C9.05017 11.1765 8.45676 10.6992 7.26993 9.74462L6.8901 9.43912C6.22276 8.90238 5.8891 8.634 5.5 8.634C5.1109 8.634 4.77724 8.90238 4.1099 9.43912L3.73007 9.74462C2.54324 10.6992 1.94983 11.1765 1.47492 10.9402C1 10.7039 1 9.93137 1 8.3863V4.45488Z"
                fill="#4C3CFF"
            />
            <path
                d="M5 5.72727C5 5.32561 5.32561 5 5.72727 5H9C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9V5.72727Z"
                fill="#16D7B4"
                fillOpacity="0.5"
            />
        </svg>
    );
};

export const MenuUSerSS = ({ width = 14, height = 14, color = 'black' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="7"
                cy="1"
                r="1"
                fill={color}
            />
            <circle
                cx="7"
                cy="7"
                r="1"
                fill={color}
            />
            <circle
                cx="7"
                cy="13"
                r="1"
                fill={color}
            />
        </svg>
    );
};

export const BackIcon: React.FC<IconProps> = ({ width = 19, height = 18, fill = 'none', color = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.29289 0.792892L9.7071 2.20711L3.91421 8H19V10H3.91421L9.7071 15.7929L8.29289 17.2071L0.0857849 9L8.29289 0.792892Z"
                fill="black"
            />
        </svg>
    );
};

export const BadgeNotification: React.FC<IconProps> = ({ width = '16', height = '14', fill = 'none' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 14"
            fill="none"
        >
            <path
                d="M0 7C0 3.13401 3.13401 0 7 0H9C12.866 0 16 3.13401 16 7C16 10.866 12.866 14 9 14H7C3.13401 14 0 10.866 0 7Z"
                fill="#FF2164"
            />
            <path
                d="M5.29813 10.5V3.14H6.48813L8.92813 7.46L9.69813 9.02H9.74813C9.68813 8.26 9.59813 7.37 9.59813 6.57V3.14H10.6981V10.5H9.50813L7.06813 6.16L6.29813 4.62H6.24813C6.30813 5.38 6.39813 6.23 6.39813 7.03V10.5H5.29813Z"
                fill="white"
            />
        </svg>
    );
};

export const BadgeChallenge: React.FC<IconProps> = ({ width = '100%', height = '46' }) => {
    return (
        <svg
            width={width}
            height={'50%'}
            viewBox="0 0 335 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="path-1-inside-1_3_17935"
                fill="white"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M170.032 1.12078C168.832 -0.373593 166.556 -0.373594 165.356 1.12078L161.434 6.00011H10C4.47715 6.00011 0 10.4773 0 16.0001V36.0001C0 41.523 4.47714 46.0001 9.99999 46.0001H325C330.523 46.0001 335 41.523 335 36.0001V16.0001C335 10.4773 330.523 6.00011 325 6.00011H173.954L170.032 1.12078Z"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M170.032 1.12078C168.832 -0.373593 166.556 -0.373594 165.356 1.12078L161.434 6.00011H10C4.47715 6.00011 0 10.4773 0 16.0001V36.0001C0 41.523 4.47714 46.0001 9.99999 46.0001H325C330.523 46.0001 335 41.523 335 36.0001V16.0001C335 10.4773 330.523 6.00011 325 6.00011H173.954L170.032 1.12078Z"
                fill="white"
            />
            <path
                d="M165.356 1.12078L166.135 1.74719V1.74719L165.356 1.12078ZM170.032 1.12078L169.253 1.74719V1.74719L170.032 1.12078ZM161.434 6.00011V7.00011H161.914L162.214 6.62652L161.434 6.00011ZM173.954 6.00011L173.174 6.62652L173.474 7.00011H173.954V6.00011ZM166.135 1.74719C166.936 0.750938 168.452 0.750938 169.253 1.74719L170.812 0.494376C169.211 -1.49812 166.177 -1.49813 164.576 0.494375L166.135 1.74719ZM162.214 6.62652L166.135 1.74719L164.576 0.494374L160.655 5.37371L162.214 6.62652ZM10 7.00011H161.434V5.00011H10V7.00011ZM1 16.0001C1 11.0296 5.02944 7.00011 10 7.00011V5.00011C3.92487 5.00011 -1 9.92498 -1 16.0001H1ZM1 36.0001V16.0001H-1V36.0001H1ZM9.99999 45.0001C5.02943 45.0001 1 40.9707 1 36.0001H-1C-1 42.0752 3.92486 47.0001 9.99999 47.0001V45.0001ZM325 45.0001H9.99999V47.0001H325V45.0001ZM334 36.0001C334 40.9707 329.971 45.0001 325 45.0001V47.0001C331.075 47.0001 336 42.0752 336 36.0001H334ZM334 16.0001V36.0001H336V16.0001H334ZM325 7.00011C329.971 7.00011 334 11.0296 334 16.0001H336C336 9.92498 331.075 5.00011 325 5.00011V7.00011ZM173.954 7.00011H325V5.00011H173.954V7.00011ZM169.253 1.74719L173.174 6.62652L174.733 5.37371L170.812 0.494375L169.253 1.74719Z"
                fill="url(#paint0_linear_3_17935)"
                mask="url(#path-1-inside-1_3_17935)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3_17935"
                    x1="351.123"
                    y1="-1.94915"
                    x2="248.685"
                    y2="199.585"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE924" />
                    <stop
                        offset="0.255208"
                        stopColor="#FF4A4D"
                    />
                    <stop
                        offset="0.52667"
                        stopColor="#B238FF"
                    />
                    <stop
                        offset="0.729167"
                        stopColor="#3D81FF"
                    />
                    <stop
                        offset="1"
                        stopColor="#41FFD2"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const BannerLogin: React.FC<IconProps> = ({ width = '100%', height = '46' }) => {
    return (
        <svg
            width="355"
            height="377"
            viewBox="0 0 355 377"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M71.3777 80.5906C98.8751 57.1495 134.535 43 173.5 43C197.683 43 220.592 48.4501 241.068 58.189M19.427 167.668C17.1814 178.258 16 189.241 16 200.5C16 235.403 27.3534 267.655 46.5686 293.763M126.869 350.982C141.604 355.544 157.265 358 173.5 358C196.565 358 218.472 353.042 238.213 344.134M309.234 280.44C323.065 257.007 331 229.68 331 200.5C331 164.313 318.796 130.977 298.28 104.382"
                stroke="#2073F6"
                strokeDasharray="2 2"
            />
            <path
                d="M66.3777 74.5906C93.8751 51.1495 129.535 37 168.5 37C192.683 37 215.592 42.4501 236.068 52.189M14.427 161.668C12.1814 172.258 11 183.241 11 194.5C11 229.403 22.3534 261.655 41.5686 287.763M121.869 344.982C136.604 349.544 152.265 352 168.5 352C191.565 352 213.472 347.042 233.213 338.134M304.234 274.44C318.065 251.007 326 223.68 326 194.5C326 158.313 313.796 124.977 293.28 98.3822"
                stroke="#EB4290"
                strokeDasharray="2 2"
            />
            <path
                d="M76.3777 86.5906C103.875 63.1495 139.535 49 178.5 49C202.683 49 225.592 54.4501 246.068 64.189M24.427 173.668C22.1814 184.258 21 195.241 21 206.5C21 241.403 32.3534 273.655 51.5686 299.763M131.869 356.982C146.604 361.544 162.265 364 178.5 364C201.565 364 223.472 359.042 243.213 350.134M314.234 286.44C328.065 263.007 336 235.68 336 206.5C336 170.313 323.796 136.977 303.28 110.382"
                stroke="#FDD000"
                strokeDasharray="2 2"
            />
            <path
                d="M28.9778 146.652C25.1723 145.632 21.605 143.873 18.4795 141.475C15.354 139.076 12.7314 136.086 10.7616 132.674C8.79174 129.262 7.51322 125.496 6.99899 121.59C6.48476 117.684 6.7449 113.715 7.76456 109.91C8.78422 106.104 10.5434 102.537 12.9417 99.4113C15.34 96.2858 18.3305 93.6632 21.7423 91.6934C25.1542 89.7235 28.9206 88.445 32.8266 87.9308C36.7325 87.4166 40.7015 87.6767 44.5069 88.6964L36.7423 117.674L28.9778 146.652Z"
                fill="#2073F6"
                fillOpacity="0.7"
            />
            <path
                d="M44.5069 88.6973L73.4847 96.4618C69.1964 112.466 52.7463 121.963 36.7423 117.675L44.5069 88.6973Z"
                fill="#FF4A6B"
                fillOpacity="0.7"
            />
            <path
                d="M15.5291 80.9316L44.5069 88.6962L36.7423 117.674L7.76454 109.909L15.5291 80.9316Z"
                fill="#7E2CF5"
                fillOpacity="0.7"
            />
            <circle
                cx="48.7495"
                cy="96.0452"
                r="2"
                transform="rotate(15 48.7495 96.0452)"
                fill="black"
            />
            <circle
                cx="73.4846"
                cy="96.4612"
                r="2"
                transform="rotate(15 73.4846 96.4612)"
                fill="black"
            />
            <path
                d="M248.713 43.9994C255.603 40.0212 263.792 38.9431 271.477 41.0024C279.163 43.0617 285.715 48.0896 289.694 54.9802C293.672 61.8707 294.75 70.0594 292.691 77.7447C290.631 85.4301 285.603 91.9827 278.713 95.9609L263.713 69.9802L248.713 43.9994Z"
                fill="#FDD000"
            />
            <path
                d="M297.21 15.9994C290.32 19.9777 285.292 26.5302 283.232 34.2156C281.173 41.901 282.251 50.0896 286.229 56.9802C290.208 63.8707 296.76 68.8987 304.446 70.9579C312.131 73.0172 320.32 71.9392 327.21 67.9609L312.21 41.9802L297.21 15.9994Z"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <circle
                cx="271.997"
                cy="36.3297"
                r="2"
                transform="rotate(-30 271.997 36.3297)"
                fill="black"
            />
            <circle
                cx="278.926"
                cy="32.3297"
                r="2"
                transform="rotate(-30 278.926 32.3297)"
                fill="black"
            />
            <path
                d="M313.962 319.713C315.931 323.125 317.21 326.891 317.724 330.797C318.238 334.703 317.978 338.672 316.959 342.478C315.939 346.283 314.18 349.85 311.781 352.976C309.383 356.102 306.393 358.724 302.981 360.694C299.569 362.664 295.802 363.942 291.897 364.457C287.991 364.971 284.022 364.711 280.216 363.691C276.411 362.671 272.843 360.912 269.718 358.514C266.592 356.115 263.97 353.125 262 349.713L287.981 334.713L313.962 319.713Z"
                fill="#EB4290"
                fillOpacity="0.7"
            />
            <path
                d="M287.981 334.713C279.697 320.364 284.613 302.017 298.962 293.732L313.962 319.713L287.981 334.713Z"
                fill="#EB4290"
            />
            <path
                d="M287.981 334.713C279.697 320.364 261.349 315.448 247 323.732L262 349.713L287.981 334.713Z"
                fill="#EB4290"
            />
            <circle
                cx="288.553"
                cy="351.703"
                r="2"
                transform="rotate(-30 288.553 351.703)"
                fill="black"
            />
            <circle
                cx="298.981"
                cy="353.765"
                r="2"
                transform="rotate(-30 298.981 353.765)"
                fill="black"
            />
            <circle
                cx="302.409"
                cy="343.703"
                r="2"
                transform="rotate(-30 302.409 343.703)"
                fill="black"
            />
            <path
                d="M92.5253 326.712C91.0943 323.042 88.9544 319.689 86.2276 316.845C83.5009 314.002 80.2408 311.723 76.6334 310.14C73.026 308.556 69.1421 307.698 65.2033 307.616C61.2645 307.533 57.348 308.227 53.6774 309.658C50.0069 311.089 46.6541 313.229 43.8105 315.956C40.967 318.683 38.6884 321.943 37.1047 325.55C35.5211 329.157 34.6635 333.041 34.5809 336.98C34.4983 340.919 35.1923 344.835 36.6233 348.506L64.5743 337.609L92.5253 326.712Z"
                fill="#8DCC21"
            />
            <path
                d="M64.5743 337.61C70.5925 353.046 87.9853 360.682 103.422 354.664L92.5253 326.713L64.5743 337.61Z"
                fill="#FDD000"
            />
            <path
                d="M64.5743 337.61C70.5925 353.046 62.9571 370.439 47.5202 376.457L36.6233 348.506L64.5743 337.61Z"
                fill="#FDD000"
            />
            <rect
                x="25.7264"
                y="320.555"
                width="30"
                height="30"
                transform="rotate(-21.2986 25.7264 320.555)"
                fill="#FF2164"
                fillOpacity="0.7"
            />
            <path
                d="M92.5253 326.713C86.5071 311.276 94.1425 293.883 109.579 287.865L120.476 315.816L92.5253 326.713Z"
                fill="#8DCC21"
            />
            <circle
                cx="107.258"
                cy="298.428"
                r="2"
                transform="rotate(-21.2986 107.258 298.428)"
                fill="black"
            />
        </svg>
    );
};

export const BannerLoginInside: React.FC<IconProps> = ({ width = '100%', height = '46' }) => {
    return (
        <svg
            width="273"
            height="268"
            viewBox="0 0 273 268"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M239 74C239 86.7316 219.092 97.8755 189.325 104C219.092 110.124 239 121.268 239 134C239 146.732 219.092 157.876 189.325 164C219.092 170.124 239 181.268 239 194C239 213.33 193.109 229 136.5 229C79.8908 229 34 213.33 34 194C34 181.268 53.9082 170.124 83.6746 164C53.9082 157.876 34 146.732 34 134C34 121.268 53.9082 110.124 83.6746 104C53.9082 97.8755 34 86.7316 34 74C34 54.67 79.8908 39 136.5 39C193.109 39 239 54.67 239 74Z"
                fill="#16D7B4"
                fillOpacity="0.1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M255.268 133.289C248.902 144.315 226.089 144.012 197.248 134.433C219.964 154.62 231.633 174.225 225.268 185.251C218.902 196.277 196.089 195.974 167.248 186.394C189.964 206.582 201.633 226.187 195.268 237.212C185.603 253.953 138.025 244.578 89 216.273C39.975 187.969 8.06744 151.453 17.7324 134.712C24.0982 123.687 46.9112 123.99 75.7519 133.569C53.0356 113.382 41.3666 93.7768 47.7324 82.7509C54.0982 71.725 76.9112 72.0282 105.752 81.6075C83.0356 61.4203 71.3666 41.8153 77.7324 30.7894C87.3974 14.0492 134.975 23.4239 184 51.7285C233.025 80.0331 264.933 116.549 255.268 133.289Z"
                fill="#FDD000"
                fillOpacity="0.1"
            />
            <path
                d="M114 77H98C98 81.4183 101.582 85 106 85C110.418 85 114 81.4183 114 77Z"
                fill="#FF2164"
            />
            <path
                d="M106 61H114V77C114 81.4183 110.418 85 106 85V61Z"
                fill="#4C3CFF"
                fillOpacity="0.7"
            />
            <circle
                cx="133"
                cy="73"
                r="12"
                fill="#8DCC21"
            />
            <circle
                cx="133"
                cy="75"
                r="3"
                fill="#FDD000"
            />
            <circle
                cx="133"
                cy="71"
                r="3"
                fill="#FF2164"
                fillOpacity="0.7"
            />
            <path
                d="M162.69 80.5L169.973 61H149.385L162.69 80.5Z"
                fill="#11395D"
            />
            <path
                d="M162 61H170L161 85H153L162 61Z"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <path
                d="M106.66 203.59C105.637 202.999 103.874 201.713 103.154 200.775C102.435 199.837 101.907 198.767 101.601 197.626C101.295 196.484 101.217 195.293 101.371 194.121C101.525 192.95 101.909 191.82 102.5 190.796C103.091 189.773 103.878 188.875 104.815 188.156C105.753 187.437 106.823 186.909 107.965 186.603C109.106 186.297 110.297 186.219 111.469 186.373C112.641 186.527 114.637 187.411 115.66 188.002L111.16 195.796L106.66 203.59Z"
                fill="#FDD000"
            />
            <path
                d="M101.928 207.786C102.952 208.377 104.948 209.26 106.119 209.415C107.291 209.569 108.482 209.491 109.624 209.185C110.765 208.879 111.835 208.351 112.773 207.632C113.711 206.912 114.497 206.015 115.088 204.991C115.679 203.968 116.063 202.838 116.217 201.666C116.371 200.494 116.293 199.304 115.988 198.162C115.682 197.02 115.154 195.95 114.434 195.013C113.715 194.075 111.952 192.788 110.928 192.197L106.428 199.991L101.928 207.786Z"
                fill="#16D7B4"
                fillOpacity="0.7"
            />
            <path
                d="M132.66 203.588C131.637 202.998 129.874 201.711 129.154 200.773C128.435 199.835 127.907 198.765 127.601 197.624C127.295 196.482 127.217 195.291 127.371 194.119C127.525 192.948 127.909 191.818 128.5 190.794C129.091 189.771 129.878 188.874 130.815 188.154C131.753 187.435 132.823 186.907 133.965 186.601C135.106 186.295 136.297 186.217 137.469 186.371C138.641 186.525 140.637 187.409 141.66 188L137.16 195.794L132.66 203.588Z"
                fill="#FF2164"
            />
            <path
                d="M127.928 207.784C128.952 208.375 130.948 209.258 132.119 209.413C133.291 209.567 134.482 209.489 135.624 209.183C136.765 208.877 137.835 208.349 138.773 207.63C139.711 206.91 140.497 206.013 141.088 204.99C141.679 203.966 142.063 202.836 142.217 201.664C142.371 200.492 142.293 199.302 141.988 198.16C141.682 197.019 141.154 195.948 140.434 195.011C139.715 194.073 137.952 192.786 136.928 192.195L132.428 199.99L127.928 207.784Z"
                fill="#2073F6"
                fillOpacity="0.7"
            />
            <path
                d="M149.794 185.893L161.794 197.893L173.794 209.893H149.794V185.893Z"
                fill="#FF5E18"
            />
            <path
                d="M173.794 185.893L161.794 197.893L149.794 209.893H173.794V185.893Z"
                fill="#7E2CF5"
                fillOpacity="0.7"
            />
            <path
                d="M109.045 114.186L107.821 116.682C104.125 116.082 101.461 114.474 100.093 112.218C98.725 114.474 96.085 116.106 92.389 116.682L91.189 114.186C96.109 113.514 98.485 110.85 98.485 108.258V107.61H101.725V108.258C101.725 110.97 104.053 113.538 109.045 114.186ZM95.749 122.298V126.162H107.893V128.682H92.581V122.298H95.749ZM101.701 118.434H110.149V120.954H90.157V118.434H98.533V115.338H101.701V118.434ZM123.289 125.034V126.45H135.505V128.826H120.097V119.106H135.337V121.434H123.289V122.778H134.809V125.034H123.289ZM134.785 115.074H137.665V117.594H117.673V115.074H122.881C123.529 113.034 123.697 111.45 123.745 110.202H119.545V107.706H126.841V108.906C126.841 110.322 126.841 112.362 126.073 115.074H131.617C132.169 113.058 132.289 111.522 132.313 110.202H128.113V107.706H135.385V109.218C135.385 110.778 135.385 112.674 134.785 115.074ZM144.719 121.602C145.943 121.602 146.639 119.946 146.639 116.538C146.639 113.154 145.943 111.498 144.719 111.498C143.519 111.498 142.799 113.154 142.799 116.538C142.799 119.946 143.519 121.602 144.719 121.602ZM151.223 115.098V107.322H154.175V128.082H151.223V117.666H149.495C149.207 121.986 147.407 124.578 144.719 124.578C141.791 124.578 139.943 121.554 139.943 116.538C139.943 111.546 141.791 108.522 144.719 108.522C147.335 108.522 149.111 110.97 149.471 115.098H151.223ZM155.711 106.938H158.711V129.042H155.711V106.938ZM170.133 108.666V111.858C170.133 116.034 171.741 120.09 175.389 121.722L173.517 124.242C171.093 123.066 169.485 120.906 168.573 118.242C167.613 121.074 165.957 123.378 163.485 124.626L161.517 122.082C165.261 120.354 166.941 116.058 166.941 111.858V108.666H170.133ZM177.213 106.938H180.381V129.114H177.213V116.418H172.965V113.874H177.213V106.938ZM76.1428 150.946V145.282H71.8228V150.946H76.1428ZM79.2628 142.786V153.442H68.7268V142.786H79.2628ZM74.3908 155.506V160.162H86.2708V162.682H71.2228V155.506H74.3908ZM85.4788 147.346H88.4068V149.938H85.4788V157.09H82.3108V140.962H85.4788V147.346ZM93.997 143.05V155.002C96.781 154.93 99.781 154.69 102.877 154.09L103.189 156.682C99.517 157.45 95.965 157.642 92.749 157.642H90.829V143.05H93.997ZM110.557 149.29V151.906H107.461V163.018H104.293V140.938H107.461V149.29H110.557ZM130.043 146.938V149.458H114.707V141.754H117.875V146.938H130.043ZM117.683 156.01V160.066H130.163V162.61H114.491V156.01H117.683ZM112.235 151.714H132.251V154.258H112.235V151.714ZM141.623 149.338L140.639 146.938C144.767 146.674 146.975 145.426 147.647 144.106H141.575V141.634H157.919V144.106H151.847C152.495 145.45 154.679 146.65 158.831 146.938L157.871 149.338C153.791 149.05 151.055 147.754 149.759 145.93C148.439 147.754 145.679 149.05 141.623 149.338ZM145.199 159.274V160.546H157.871V162.898H142.055V157.114H154.175V155.914H142.031V153.61H157.295V159.274H145.199ZM139.751 149.938H159.719V152.41H139.751V149.938ZM162.621 143.242H173.013C173.013 149.914 170.877 155.434 163.245 159.25L161.565 156.802C167.085 154.018 169.365 150.586 169.797 145.762H162.621V143.242ZM177.141 140.962H180.309V163.066H177.141V152.002H172.869V149.434H177.141V140.962ZM193.891 143.698C190.891 143.698 189.163 144.298 189.163 145.546C189.163 146.77 190.891 147.394 193.891 147.394C196.915 147.394 198.643 146.77 198.643 145.546C198.643 144.298 196.915 143.698 193.891 143.698ZM193.891 149.77C189.019 149.77 185.899 148.186 185.899 145.546C185.899 142.882 189.019 141.298 193.891 141.298C198.763 141.298 201.907 142.882 201.907 145.546C201.907 148.186 198.763 149.77 193.891 149.77ZM198.379 160.33V157.786H189.331V160.33H198.379ZM203.875 153.418H195.475V155.314H201.499V162.802H186.235V155.314H192.307V153.418H183.907V150.898H203.875V153.418Z"
                fill="black"
            />
        </svg>
    );
};

export const JoysamLogo: React.FC<IconProps> = ({ width = '140', height = '90' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 140 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.14997 14H64.7545V23.0702H42.5134V23.5906C42.5134 25.3749 42.3898 27.0849 42.1427 28.7205C41.8955 30.3561 41.5496 31.9422 41.1048 33.4787L66.7562 47.7531L61.0476 55.9312L36.5083 42.3258C33.8393 45.6962 30.3055 48.5709 25.9067 50.95C21.5573 53.2795 16.2935 55.1877 10.1155 56.6746L5.74137 48.1248C10.1896 47.2327 13.9953 46.0679 17.1585 44.6306C20.3217 43.1436 22.9165 41.3841 24.9429 39.352C26.9693 37.2703 28.452 34.916 29.3911 32.2891C30.3302 29.6622 30.7997 26.738 30.7997 23.5163V23.0702H7.14997V14ZM5 65.5961H30.1325V51.9165H41.772V65.5961H66.9045V74.6664H5V65.5961Z"
                fill="#7651F1"
            />
            <path
                d="M30.1325 65.5961V51.9165H41.772V65.5961H30.1325Z"
                fill="#E23F8F"
            />
            <path
                d="M100.173 42.5086V24.5149H75.5718V15.481H111.807V75.164H100.173V51.5425H75.5718V42.5086H100.173ZM135 75.9044H123.366V46.9515L114.03 50.1356V40.8796L123.366 37.6955V14H135V75.9044Z"
                fill="#7651F1"
            />
            <path
                d="M123.366 46.9515L114.03 50.1356V40.8796L123.366 37.6955V46.9515Z"
                fill="#E23F8F"
            />
        </svg>
    );
};

export const NaverIcon: React.FC<IconProps> = ({ width = '28', height = '27' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 28 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.3637 4V14.2544L10.3437 4H3.21601H3V23.7725H10.3437V13.9619L17.3637 23.7725H23.8793H24.7075V4H17.3637Z"
                fill="white"
            />
        </svg>
    );
};

export const KakaoTalkIcon: React.FC<IconProps> = ({ width = '28', height = '27' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 28 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.0582 2.04015C1.71435 1.97751 -4.00913 14.5441 7.21663 20.1266C7.01923 20.7825 5.94907 24.3467 5.90623 24.6267C5.87571 24.8457 6.04875 25.0293 6.32931 24.9353C6.73475 24.8805 11.0277 21.9726 11.7708 21.4677C29.5713 23.5222 33.0763 2.82855 14.0582 2.04015Z"
                fill="#3D1D1C"
            />
            <path
                d="M7.68093 14.5646C7.65685 15.4645 6.22045 15.4681 6.19497 14.5646V10.3086H5.03577C4.07565 10.2851 4.07369 8.92973 5.03577 8.9057H8.84013C9.80081 8.93027 9.80193 10.2841 8.84013 10.3086H7.68093V14.5646Z"
                fill="#FFE812"
            />
            <path
                d="M13.9251 15.1406C13.5916 15.3101 12.9465 15.2688 12.8345 14.9229L12.4666 13.9941H10.2011L9.83292 14.9235C9.72148 15.2688 9.07608 15.3104 8.74288 15.1406C8.53792 15.0496 8.34108 14.799 8.56676 14.1232L10.3439 9.61285C10.7076 8.68783 11.9584 8.68378 12.3244 9.61366L14.1007 14.1221C14.3266 14.7993 14.1298 15.0498 13.9251 15.1406Z"
                fill="#FFE812"
            />
            <path
                d="M17.6802 15.1443H15.2965C14.904 15.1443 14.5845 14.8497 14.5845 14.4877V9.622C14.61 8.67916 16.0752 8.67619 16.1012 9.622V13.8308H17.6802C18.6179 13.8532 18.6198 15.1214 17.6802 15.1443Z"
                fill="#FFE812"
            />
            <path
                d="M23.496 14.6049C23.43 15.2191 22.5348 15.4454 22.1674 14.9372L20.4253 12.7111L20.1674 12.9598V14.5228C20.143 15.4656 18.7069 15.4691 18.6812 14.5231V9.62202C18.7069 8.67837 20.1408 8.67648 20.1671 9.62202V11.1618L22.24 9.16302C22.4886 8.91975 22.9209 8.97213 23.1634 9.21513C23.4157 9.44625 23.4703 9.86799 23.218 10.1056L21.5248 11.738L23.3535 14.0743C23.4725 14.2255 23.5238 14.4167 23.496 14.6049Z"
                fill="#FFE812"
            />
            <path
                d="M10.5918 12.7254H12.0758L11.3338 10.6926L10.5918 12.7254Z"
                fill="#3D1D1C"
            />
        </svg>
    );
};

export const LoginCheckIcon: React.FC<IconProps> = ({ width = '14', height = '14' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 7L5 11L13 3"
                stroke="#2073F6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const AppleIcon: React.FC<IconProps> = ({ width = '22', height = '22' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.1974 12.1179C16.1737 9.45107 18.3537 8.17067 18.4475 8.11133C17.2224 6.29933 15.3111 6.04679 14.6349 6.01649C13.0098 5.85107 11.461 6.98499 10.6347 6.98499C9.80844 6.98499 8.53715 6.04427 7.19211 6.07078C5.41705 6.09604 3.78699 7.11252 2.87321 8.71111C1.0344 11.9361 2.4007 16.7167 4.19826 19.3318C5.07329 20.6122 6.11582 22.0504 7.48712 21.9986C8.81091 21.9469 9.31093 21.1362 10.9085 21.1362C12.506 21.1362 12.956 21.9986 14.3548 21.9772C15.7749 21.9469 16.6774 20.6665 17.545 19.3861C18.1699 18.4617 18.66 17.4513 19 16.3859C18.9662 16.3745 16.2249 15.3113 16.1974 12.1179Z"
                fill="white"
            />
            <path
                d="M13.9512 3.45687C14.6416 2.54204 15.1074 1.26778 14.9786 0C13.9867 0.041524 12.7844 0.72667 12.0739 1.6389C11.4343 2.45251 10.8728 3.75143 11.0253 4.99196C12.1306 5.08409 13.2644 4.37299 13.9512 3.45687Z"
                fill="white"
            />
        </svg>
    );
};

export const GoogleIcon: React.FC<IconProps> = ({ width = '22', height = '22' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.9998 11.227C21.0006 10.5409 20.9385 9.85608 20.8142 9.18085H11.2012V13.049H16.6931C16.5791 13.6602 16.34 14.2424 15.99 14.7605C15.6401 15.2786 15.1866 15.7219 14.6571 16.0636V18.5732H17.9544C19.8837 16.8323 20.9969 14.268 20.9969 11.2251L20.9998 11.227Z"
                fill="#3E82F1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2044 20.999C13.9595 20.999 16.2695 20.1041 17.9576 18.577L14.6603 16.0673C13.7461 16.6674 12.5772 17.0226 11.2044 17.0226C8.5464 17.0226 6.29694 15.2628 5.49521 12.8992H2.08545V15.4908C2.93484 17.1472 4.23748 18.5395 5.84781 19.5122C7.45815 20.485 9.31275 20.9997 11.2044 20.999Z"
                fill="#32A753"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.49502 12.8992C5.06819 11.6673 5.06819 10.3318 5.49502 9.09986V6.50824H2.08526C1.37162 7.90211 1 9.44004 1 10.9995C1 12.559 1.37162 14.0969 2.08526 15.4908L5.49502 12.8992Z"
                fill="#F9BB00"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2044 4.97645C12.7031 4.97645 14.048 5.48139 15.1054 6.47244L18.0316 3.60386C16.2648 1.99011 13.9547 1 11.2064 1C9.3147 0.999311 7.4601 1.51408 5.84977 2.48679C4.23943 3.4595 2.9368 4.85184 2.0874 6.50824L5.49716 9.09986C6.29889 6.73622 8.54835 4.97645 11.2064 4.97645H11.2044Z"
                fill="#E74133"
            />
        </svg>
    );
};

export const CheckIcon: React.FC<IconProps> = ({ width = '8', height = '8' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.75 2.25L4.81871 4.56755C4.16314 5.35423 3.83535 5.74758 3.39478 5.76756C2.95421 5.78755 2.59216 5.42549 1.86806 4.70139L1.41667 4.25"
                stroke="#FF4A4D"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const EclipseAvatar: React.FC<IconProps> = ({ width = '100', height = '100' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="50"
                cy="50"
                r="48.5"
                stroke="url(#paint0_linear_3_9548)"
                strokeWidth="3"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3_9548"
                    x1="104.813"
                    y1="-4.23727"
                    x2="-33.992"
                    y2="33.2606"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE924" />
                    <stop
                        offset="0.255208"
                        stopColor="#FF4A4D"
                    />
                    <stop
                        offset="0.52667"
                        stopColor="#B238FF"
                    />
                    <stop
                        offset="0.729167"
                        stopColor="#3D81FF"
                    />
                    <stop
                        offset="1"
                        stopColor="#41FFD2"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const PhotoPlusM: React.FC<IconProps> = ({ width = '100', height = '100' }) => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="13"
                cy="13"
                r="13"
                fill="url(#paint0_linear_3_9550)"
            />
            <mask
                id="mask0_3_9550"
                maskUnits="userSpaceOnUse"
                x="6"
                y="6"
                width="14"
                height="14"
            >
                <path
                    d="M6.25 13C6.25 10.4287 6.25 9.14305 6.81909 8.19359C7.15726 7.62937 7.62937 7.15726 8.19359 6.81909C9.14305 6.25 10.4287 6.25 13 6.25C15.5713 6.25 16.8569 6.25 17.8064 6.81909C18.3706 7.15726 18.8427 7.62937 19.1809 8.19359C19.75 9.14305 19.75 10.4287 19.75 13C19.75 15.5713 19.75 16.8569 19.1809 17.8064C18.8427 18.3706 18.3706 18.8427 17.8064 19.1809C16.8569 19.75 15.5713 19.75 13 19.75C10.4287 19.75 9.14305 19.75 8.19359 19.1809C7.62937 18.8427 7.15726 18.3706 6.81909 17.8064C6.25 16.8569 6.25 15.5713 6.25 13Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_3_9550)">
                <path
                    d="M8.05742 13.4426L7.94285 13.5571C7.51799 13.982 7.30556 14.1944 7.13287 14.4258C6.69151 15.0169 6.42224 15.7186 6.35483 16.4533C6.32846 16.7407 6.34425 17.0407 6.37583 17.6407L6.625 22.375H19.75V18.818C19.75 18.1691 19.75 17.8446 19.7017 17.5366C19.5922 16.8386 19.2998 16.1821 18.8543 15.6338C18.6576 15.3919 18.4165 15.1748 17.9341 14.7407L17.7732 14.5959C17.4343 14.2908 17.2648 14.1383 17.0965 14.038C16.4331 13.6426 15.6013 13.6644 14.9596 14.0942C14.7968 14.2032 14.6356 14.3644 14.3131 14.6869L14.3131 14.6869C14.0745 14.9255 13.9552 15.0448 13.8466 15.109C13.4117 15.3665 12.853 15.2589 12.5448 14.8583C12.4679 14.7583 12.3994 14.5986 12.2624 14.279L12.2624 14.279C11.9554 13.5625 11.8018 13.2043 11.6218 12.9848C11.0106 12.2395 9.95482 12.0362 9.11055 12.5012C8.86189 12.6381 8.59373 12.9063 8.05742 13.4426Z"
                    stroke="white"
                    strokeWidth="1.5"
                />
            </g>
            <path
                d="M6.25 13C6.25 10.4287 6.25 9.14305 6.81909 8.19359C7.15726 7.62937 7.62937 7.15726 8.19359 6.81909C9.14305 6.25 10.4287 6.25 13 6.25V6.25C15.5713 6.25 16.8569 6.25 17.8064 6.81909C18.3706 7.15726 18.8427 7.62937 19.1809 8.19359C19.75 9.14305 19.75 10.4287 19.75 13V13C19.75 15.5713 19.75 16.8569 19.1809 17.8064C18.8427 18.3706 18.3706 18.8427 17.8064 19.1809C16.8569 19.75 15.5713 19.75 13 19.75V19.75C10.4287 19.75 9.14305 19.75 8.19359 19.1809C7.62937 18.8427 7.15726 18.3706 6.81909 17.8064C6.25 16.8569 6.25 15.5713 6.25 13V13Z"
                stroke="white"
                strokeWidth="1.5"
            />
            <circle
                cx="17"
                cy="10"
                r="1"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3_9550"
                    x1="27.2513"
                    y1="-1.10169"
                    x2="-8.83792"
                    y2="8.64775"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE924" />
                    <stop
                        offset="0.255208"
                        stopColor="#FF4A4D"
                    />
                    <stop
                        offset="0.52667"
                        stopColor="#B238FF"
                    />
                    <stop
                        offset="0.729167"
                        stopColor="#3D81FF"
                    />
                    <stop
                        offset="1"
                        stopColor="#41FFD2"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const ProfileImgSelect: React.FC<IconProps> = ({ width = '26', height = '26' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="1"
                y="1"
                width="24"
                height="24"
                stroke="black"
                strokeWidth="2"
            />
            <rect
                x="9"
                y="6"
                width="2"
                height="6"
                fill="black"
            />
            <rect
                x="15"
                y="6"
                width="2"
                height="6"
                fill="black"
            />
            <rect
                x="17"
                y="20"
                width="8"
                height="2"
                fill="black"
            />
            <rect
                x="24"
                y="22"
                width="2"
                height="2"
                fill="white"
            />
        </svg>
    );
};

export const ImageIcon: React.FC<IconProps> = ({ width = '100', height = '100' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_785_11683"
                maskUnits="userSpaceOnUse"
                x="3"
                y="3"
                width="18"
                height="18"
            >
                <path
                    d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_785_11683)">
                <path
                    d="M5.40989 12.5901L5.25713 12.7429C4.27646 13.7235 3.78613 14.2139 3.49264 14.8158C3.39066 15.025 3.30712 15.2427 3.24299 15.4664C3.05843 16.1102 3.09488 16.8027 3.16777 18.1877L3.5 24.5H21V19.7573C21 18.3059 21 17.5802 20.7614 16.9207C20.6962 16.7404 20.6181 16.565 20.5277 16.3959C20.1971 15.7774 19.6577 15.2919 18.5789 14.321L18.3643 14.1279C17.4682 13.3214 17.0202 12.9182 16.5078 12.8039C16.1864 12.7322 15.8523 12.741 15.5352 12.8295C15.0295 12.9705 14.6033 13.3967 13.7508 14.2492C13.1184 14.8816 12.8023 15.1977 12.4625 15.2406C12.2519 15.2672 12.0383 15.226 11.8526 15.1231C11.5531 14.9572 11.3742 14.5399 11.0166 13.7053C10.2559 11.9304 9.87554 11.0429 9.22167 10.7151C8.89249 10.5501 8.52413 10.4792 8.1572 10.5101C7.42836 10.5716 6.75554 11.2445 5.40989 12.5901L5.40989 12.5901Z"
                    stroke="black"
                />
            </g>
            <path
                d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11Z"
                stroke="black"
            />
            <circle
                cx="17"
                cy="8"
                r="1"
                fill="black"
            />
        </svg>
    );
};
export const SendIconActive: React.FC<IconProps> = ({ width = '100', height = '100' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5476 6.94015L9.26466 13.4255L9.82837 20.6759C9.90083 21.6079 11.0986 21.9398 11.6403 21.1779L21.3608 7.50722C21.4875 7.32907 21.5458 7.13243 21.5476 6.94015ZM8.8786 12.4985L3.13113 7.70517C2.41321 7.10643 2.83622 5.93773 3.77105 5.9372L20.5453 5.92773C20.7384 5.92763 20.9124 5.97937 21.0591 6.06722L8.8786 12.4985Z"
                fill="#2073F6"
            />
        </svg>
    );
};

export const SendIconDisabled: React.FC<IconProps> = ({ width = '100', height = '100' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8254 20.5986L20.5459 6.92786L3.77164 6.93733L9.53105 11.7407C9.94516 12.086 10.2023 12.584 10.2441 13.1216L10.8254 20.5986ZM9.8284 20.6761C9.90086 21.6081 11.0986 21.9399 11.6404 21.178L21.3609 7.50735C21.8318 6.84506 21.358 5.92741 20.5453 5.92786L3.77108 5.93733C2.83626 5.93785 2.41324 7.10656 3.13116 7.7053L8.89057 12.5086C9.09762 12.6813 9.22618 12.9303 9.24708 13.1991L9.8284 20.6761Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.2282 7.14486L9.7282 13.0449L9.27173 12.1551L20.7717 6.25513L21.2282 7.14486Z"
                fill="black"
            />
        </svg>
    );
};

export const DropDownIcon: React.FC<IconProps> = ({ width = '8', height = '8' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 2.5L4 5.5L7 2.5"
                stroke="#666666"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const DropUpIcon: React.FC<IconProps> = ({ width = '100', height = '100' }) => {
    return (
        <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 5.5L4 2.5L7 5.5"
                stroke="#999999"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const UserGroup: React.FC<IconProps> = ({ width = '100', height = '100' }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="icon/20px/Cham-yeo_S">
                <circle
                    id="Ellipse 50"
                    cx="7.82971"
                    cy="5.5"
                    r="3"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    id="Ellipse 51"
                    d="M12.0977 6.5C12.3629 6.04063 12.7997 5.70543 13.3121 5.56815C13.8244 5.43086 14.3703 5.50273 14.8297 5.76795C15.2891 6.03317 15.6243 6.47 15.7616 6.98236C15.8988 7.49472 15.827 8.04063 15.5618 8.5C15.2965 8.95937 14.8597 9.29457 14.3474 9.43185C13.835 9.56914 13.2891 9.49727 12.8297 9.23205C12.3703 8.96683 12.0351 8.53 11.8979 8.01764C11.7606 7.50528 11.8324 6.95937 12.0977 6.5L12.0977 6.5Z"
                    stroke="black"
                />
                <path
                    id="Subtract"
                    d="M12.8367 16H2.92002V17H12.8367V16ZM2.50434 15.58C2.63564 14.7071 2.96324 13.4255 3.76278 12.3723C4.54381 11.3435 5.79728 10.5 7.87836 10.5V9.5C5.4733 9.5 3.92948 10.4989 2.96629 11.7677C2.02161 13.012 1.65805 14.4833 1.51546 15.4313L2.50434 15.58ZM7.87836 10.5C9.95943 10.5 11.2129 11.3435 11.9939 12.3723C12.7935 13.4255 13.1211 14.7071 13.2524 15.58L14.2413 15.4313C14.0987 14.4833 13.7351 13.012 12.7904 11.7677C11.8272 10.4989 10.2834 9.5 7.87836 9.5V10.5ZM2.92002 16C2.63032 16 2.47387 15.7826 2.50434 15.58L1.51546 15.4313C1.38164 16.321 2.10516 17 2.92002 17V16ZM12.8367 17C13.6516 17 14.3751 16.321 14.2413 15.4313L13.2524 15.58C13.2828 15.7826 13.1264 16 12.8367 16V17Z"
                    fill="black"
                />
                <path
                    id="Subtract_2"
                    d="M18.2019 15.4143L18.6882 15.2978L18.2019 15.4143ZM12.13 11.5288L11.8621 11.1067L11.3469 11.4336L11.7687 11.8745L12.13 11.5288ZM13.9107 15.5061L13.4162 15.5796L13.9107 15.5061ZM17.2946 16H12.9996V17H17.2946V16ZM17.7157 15.5308C17.7688 15.7524 17.6046 16 17.2946 16V17C18.1679 17 18.9107 16.2268 18.6882 15.2978L17.7157 15.5308ZM13.9996 11.5C15.1745 11.5 15.9931 12.0887 16.585 12.9007C17.1872 13.7267 17.5303 14.7567 17.7157 15.5308L18.6882 15.2978C18.4897 14.4692 18.1079 13.2921 17.3931 12.3116C16.6681 11.3171 15.5774 10.5 13.9996 10.5V11.5ZM12.3979 11.951C12.8345 11.6739 13.3587 11.5 13.9996 11.5V10.5C13.1645 10.5 12.4552 10.7303 11.8621 11.1067L12.3979 11.951ZM11.7687 11.8745C12.8548 13.0098 13.2653 14.565 13.4162 15.5796L14.4053 15.4325C14.2432 14.3421 13.7898 12.5405 12.4913 11.1832L11.7687 11.8745ZM13.4162 15.5796C13.4464 15.7827 13.2895 16 12.9996 16V17C13.8143 17 14.5375 16.322 14.4053 15.4325L13.4162 15.5796Z"
                    fill="black"
                />
            </g>
        </svg>
    );
};

export const NoContent: React.FC<IconProps> = ({ style }) => {
    return (
        <svg
            width="121"
            height="120"
            viewBox="0 0 121 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M98.9141 21.1172C98.6094 20.625 98.8203 20.0156 99.0078 19.5234C99.8516 17.3906 101 15.375 102.406 13.5703C102.828 12.9609 103.602 12.9141 104.281 12.8672C104.68 13.3828 104.984 14.1562 104.492 14.7187C103.531 16.0547 102.594 17.4375 101.961 18.9844C101.656 19.6875 101.445 20.4609 101.07 21.1406C100.672 21.9844 99.336 21.9141 98.9141 21.1172ZM103.203 24.3984C102.992 25.3828 104.281 26.25 105.078 25.6172C107.516 24.0703 109.953 22.5 112.391 20.9766C113.023 20.5312 113.984 20.1328 113.938 19.2187C114.031 18.3281 112.883 17.5781 112.133 18.0937C109.531 19.7109 106.977 21.4219 104.375 23.0391C103.906 23.3672 103.25 23.7187 103.203 24.3984ZM106.672 44.0625C108.055 45.5859 108.711 47.6719 108.477 49.7109C106.977 65.0859 105.453 80.4844 103.953 95.8594C103.766 97.9688 102.688 99.8906 101.094 101.273C102.852 101.484 104.727 101.25 106.391 102C107.328 102.375 107.914 103.477 107.516 104.438C106.977 105.891 105.336 106.57 103.859 106.57C76.6719 107.109 49.461 107.273 22.2969 106.008C19.3906 105.867 16.4375 105.797 13.6485 104.977C11.9141 104.461 10.2031 103.477 9.24221 101.883C8.02346 99.8438 7.85939 97.4062 7.67189 95.1094C6.50002 80.625 5.18752 66.1406 3.87502 51.6562C3.59377 48.2812 3.10158 44.8828 3.61721 41.5312C3.87502 39.6094 4.55471 37.7344 5.65627 36.1406C6.38283 35.1328 6.82814 33.9375 7.74221 33.0937C8.56252 32.2734 9.66408 31.8281 10.7188 31.3828C10.7656 29.4375 10.5313 27.4453 11.2813 25.5937C12.4766 22.2656 15.9453 19.9687 19.4844 20.1797C42.9922 20.4844 66.5235 20.8359 90.0313 21.1641C92.1406 21.2578 94.3672 20.9766 96.3594 21.8203C99.3828 22.9922 101.516 26.0859 101.586 29.3203C101.656 33.4688 101.563 37.6406 101.633 41.7891C103.508 41.9297 105.406 42.6094 106.672 44.0625ZM13.3906 31.4062C27.3828 31.4297 41.3516 31.4063 55.3438 31.4297C58.4141 31.4297 61.3906 32.7656 63.5 34.9687C64.9063 36.4687 66.1953 38.0391 67.6016 39.5625C69.0781 41.1562 71.211 42.0938 73.3906 42.0234C81.9219 42 90.4297 42.0469 98.9375 42C99.0078 38.25 98.9375 34.4766 98.961 30.7266C98.961 29.6484 99.0313 28.5469 98.6094 27.5391C97.7891 25.4297 95.586 23.9531 93.3125 24.0234C68.5391 23.6719 43.7656 23.3203 18.9922 22.9688C16.9297 22.8984 14.9141 24.0937 14 25.9453C13.1094 27.6094 13.4141 29.5781 13.3906 31.4062ZM103.508 45.1172C102.383 44.5078 101.094 44.6484 99.875 44.6484C90.9688 44.6484 82.0625 44.6484 73.1563 44.6484C71.1641 44.6719 69.1485 44.0625 67.5313 42.8906C66.336 42.0703 65.4688 40.8984 64.5078 39.8438C63.5 38.7188 62.5391 37.5937 61.5078 36.4922C59.8672 34.7578 57.4766 33.8438 55.1094 33.8906C41.4453 33.8906 27.7578 33.8906 14.0938 33.8906C13.1094 33.9141 12.1016 33.8203 11.1172 34.0781C9.40627 34.5703 8.11721 36.2109 8.09377 37.9922C8.09377 39.0938 8.25783 40.1953 8.32814 41.2969C9.89846 58.9453 11.4688 76.5938 13.0391 94.2422C13.1563 95.2969 13.1094 96.375 13.5313 97.3594C14.211 98.9297 15.8985 99.9609 17.586 99.8906C44 99.8906 70.4141 99.8906 96.8281 99.8906C99.0547 99.9844 101.141 98.1094 101.258 95.8828C102.781 80.3203 104.305 64.7812 105.828 49.2188C106.109 47.4844 105.008 45.8438 103.508 45.1172ZM117.406 28.6641C116.82 27.75 115.625 28.1484 114.734 28.1484C112.297 28.3359 109.836 28.5234 107.398 28.7109C106.953 28.7578 106.414 28.7578 106.086 29.1562C105.617 29.6719 105.523 30.5859 106.109 31.0312C106.648 31.5234 107.445 31.3828 108.102 31.3359C110.914 31.1016 113.703 30.9375 116.516 30.6797C117.43 30.6328 118.039 29.3906 117.406 28.6641ZM78.5469 59.6016C79.7188 58.4062 80.9141 57.2344 82.1094 56.0625C82.4844 55.6875 82.8594 55.2188 82.7656 54.6328C82.6953 53.6719 81.4297 53.0625 80.6563 53.6719C79.1797 54.8906 78.0078 56.4609 76.5078 57.6562C75.125 56.2734 73.7422 54.8906 72.3828 53.5078C71.8438 52.9688 71.2344 52.1953 70.3672 52.3828C69.4531 52.5234 68.961 53.7188 69.5235 54.4453C71.1172 56.2734 73.0156 57.8203 74.586 59.6719C73.1328 61.1484 71.6563 62.5781 70.2031 64.0547C69.7578 64.4766 69.4766 65.1328 69.7578 65.7188C70.086 66.5391 71.2578 66.8203 71.8906 66.2109C73.5313 64.7344 74.9375 63.0234 76.625 61.6172C78.0547 63.0234 79.461 64.4531 80.8672 65.8828C81.3828 66.375 81.9453 67.0781 82.7422 66.8906C83.75 66.75 84.1953 65.3906 83.4922 64.6641C81.9219 62.9062 80.0703 61.4062 78.5469 59.6016ZM37.9297 68.4375C38.7735 68.1562 39.125 66.9609 38.5156 66.3047C37.1563 64.7812 35.6094 63.4453 34.2266 61.9453C35.9375 60.1875 37.6953 58.4766 39.4063 56.7422C39.7813 56.3672 40.1328 55.8984 40.0391 55.3359C39.9688 54.4453 38.9141 53.8594 38.1406 54.2578C37.5078 54.6328 37.0625 55.2188 36.5235 55.7344C35.1172 57.1406 33.711 58.5703 32.2813 59.9766C30.5469 58.3828 28.9766 56.625 27.2422 55.0312C26.6328 54.3984 25.4844 54.6328 25.1094 55.3828C24.8047 55.9453 24.9922 56.6484 25.4375 57.0703C27.0313 58.7109 28.6719 60.2813 30.2656 61.9219C28.6719 63.6797 26.8672 65.25 25.2735 67.0078C24.5938 67.7344 25.086 69.0469 26.0469 69.1875C27.0313 69.3984 27.6406 68.4375 28.2735 67.875C29.6328 66.5859 30.8516 65.1328 32.3047 63.9609C33.6172 65.25 34.9063 66.5625 36.2188 67.8516C36.6641 68.2969 37.2969 68.6719 37.9297 68.4375ZM73.0391 84.0234C67.7422 79.1016 60.2422 76.7578 53.0938 77.6719C47.2813 78.375 41.75 81.2344 37.8828 85.6406C36.9453 86.5781 38.1875 88.1953 39.336 87.8438C39.8047 87.6562 40.1563 87.2109 40.5078 86.8594C44.6563 82.4531 50.75 80.0156 56.7735 80.2031C61.8125 80.3203 66.8281 82.1719 70.6016 85.5C71.1875 86.0156 71.7031 86.625 72.3594 87.0469C73.1563 87.4922 74.2813 86.8828 74.3281 85.9453C74.375 85.1016 73.5781 84.5625 73.0391 84.0234Z"
                fill="black"
            />
        </svg>
    );
};

export const StaffIcon = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.48328 3.02722C5.06466 1.00141 7.93534 1.00141 8.51672 3.02722C8.78234 3.95277 9.64387 4.5787 10.6062 4.54531C12.7125 4.47223 13.5996 7.20241 11.8526 8.38134C11.0544 8.91997 10.7254 9.93276 11.0545 10.8377C11.7749 12.8183 9.45245 14.5056 7.79137 13.2085C7.03245 12.6158 5.96755 12.6158 5.20863 13.2085C3.54755 14.5056 1.22512 12.8183 1.94551 10.8377C2.27464 9.93276 1.94557 8.91997 1.1474 8.38134C-0.599596 7.20241 0.287492 4.47223 2.3938 4.54531C3.35613 4.5787 4.21766 3.95277 4.48328 3.02722Z"
                fill="#FDD000"
            />
            <path
                d="M8.54894 0.927052C8.8483 0.00574112 10.1517 0.00573993 10.4511 0.927051L10.7348 1.80041C10.8687 2.21243 11.2527 2.49139 11.6859 2.49139H12.6042C13.5729 2.49139 13.9757 3.73101 13.192 4.30041L12.449 4.84017C12.0986 5.09481 11.9519 5.54618 12.0858 5.9582L12.3695 6.83156C12.6689 7.75287 11.6144 8.519 10.8307 7.94959L10.0878 7.40983C9.7373 7.15519 9.2627 7.15519 8.91221 7.40983L8.16929 7.94959C7.38558 8.51899 6.3311 7.75287 6.63045 6.83156L6.91422 5.9582C7.0481 5.54618 6.90144 5.09481 6.55095 4.84017L5.80803 4.30041C5.02432 3.73101 5.42709 2.49139 6.39582 2.49139H7.31412C7.74734 2.49139 8.1313 2.21243 8.26517 1.80041L8.54894 0.927052Z"
                fill="#E42044"
                fillOpacity="0.5"
            />
        </svg>
    );
};

export const BellIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="12"
                cy="21"
                r="1"
                fill="black"
            />
            <path
                d="M6.44784 8.96942C6.76219 6.14032 9.15349 4 12 4V4C14.8465 4 17.2378 6.14032 17.5522 8.96942L17.804 11.2356C17.8072 11.2645 17.8088 11.279 17.8104 11.2933C17.9394 12.4169 18.3051 13.5005 18.8836 14.4725C18.8909 14.4849 18.8984 14.4973 18.9133 14.5222L19.4914 15.4856C20.0159 16.3599 20.2782 16.797 20.2216 17.1559C20.1839 17.3946 20.061 17.6117 19.8757 17.7668C19.5971 18 19.0873 18 18.0678 18H5.93223C4.91268 18 4.40291 18 4.12434 17.7668C3.93897 17.6117 3.81609 17.3946 3.77841 17.1559C3.72179 16.797 3.98407 16.3599 4.50862 15.4856L5.08665 14.5222C5.10161 14.4973 5.10909 14.4849 5.11644 14.4725C5.69488 13.5005 6.06064 12.4169 6.18959 11.2933C6.19123 11.279 6.19283 11.2645 6.19604 11.2356L6.44784 8.96942Z"
                stroke="black"
            />
        </svg>
    );
};

export const ArrowRightIcon = ({ color = '#666666' }: { color?: any }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
        >
            <path
                d="M2.5 1L5.5 4L2.5 7"
                stroke={color}
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const ArrowRightBlack = ({ stroke = 'black' }: { stroke?: 'black' | '#999999' }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.72729 1.54492L10.1818 6.99947L4.72729 12.454"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const PointNotification = () => {
    return (
        <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="3"
                cy="3"
                r="3"
                fill="#FF2164"
            />
        </svg>
    );
};

export const PostIconActive = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                y="12"
                width="8"
                height="8"
                fill="#FDD000"
            />
            <rect
                x="4"
                y="3"
                width="13"
                height="15"
                rx="2"
                stroke="black"
            />
            <path
                d="M11.5 8.33398V6.66732"
                stroke="black"
                strokeLinecap="round"
            />
            <path
                d="M2.33325 7.5H5.66659"
                stroke="black"
                strokeLinecap="round"
            />
            <path
                d="M2.33325 10.834H5.66659"
                stroke="black"
                strokeLinecap="round"
            />
            <path
                d="M2.33325 14.166H5.66659"
                stroke="black"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const PostIconNotActive = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="4"
                y="3"
                width="13"
                height="15"
                rx="2"
                stroke="black"
            />
            <path
                d="M11.5 8.33398V6.66732"
                stroke="black"
                strokeLinecap="round"
            />
            <path
                d="M2.33325 7.5H5.66659"
                stroke="black"
                strokeLinecap="round"
            />
            <path
                d="M2.33325 10.834H5.66659"
                stroke="black"
                strokeLinecap="round"
            />
            <path
                d="M2.33325 14.166H5.66659"
                stroke="black"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const CloseIconForBottomSheet = ({ width = '24', height = '24' }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 11L7.02469 7L11 3M3 11L6.97531 7L3 3"
                stroke="black"
                strokeWidth="2"
            />
        </svg>
    );
};
export const CloseIcon = ({ width = '24', height = '24' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 5L19 19"
                stroke="black"
                strokeWidth="2"
            />
            <path
                d="M19 5L5 19"
                stroke="black"
                strokeWidth="2"
            />
        </svg>
    );
};
export const CloseIconWhite = ({ width = '24', height = '24' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M5 5L19 19"
                stroke="white"
                strokeWidth="2"
            />
            <path
                d="M19 5L5 19"
                stroke="white"
                strokeWidth="2"
            />
        </svg>
    );
};
export const PlusIcon = () => {
    return (
        <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                y="3"
                width="8"
                height="2"
                fill="black"
            />
            <rect
                x="3"
                width="2"
                height="8"
                fill="black"
            />
        </svg>
    );
};

export const MinusIcon = () => {
    return (
        <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                y="3"
                width="8"
                height="2"
                fill="black"
            />
        </svg>
    );
};

export const CopyIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M18.5 6.375V6.375C20.0878 6.375 21.375 7.66218 21.375 9.25V18.375C21.375 20.0319 20.0319 21.375 18.375 21.375H9.25C7.66218 21.375 6.375 20.0878 6.375 18.5V18.5"
                stroke="black"
            />
            <path
                d="M3 6C3 4.34315 4.34315 3 6 3H16C17.6569 3 19 4.34315 19 6V16C19 17.6569 17.6569 19 16 19H6C4.34315 19 3 17.6569 3 16V6Z"
                stroke="black"
            />
        </svg>
    );
};

export const CheckedRadioButton = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
        >
            <rect
                width="26"
                height="26"
                rx="13"
                fill="black"
            />
            <rect
                x="9.00024"
                y="9"
                width="8"
                height="8"
                rx="4"
                fill="white"
            />
        </svg>
    );
};

export const UnCheckedRadioButton = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
        >
            <rect
                width="26"
                height="26"
                rx="13"
                fill="#EEEEEE"
            />
            <rect
                x="9.00024"
                y="9"
                width="8"
                height="8"
                rx="4"
                fill="white"
            />
        </svg>
    );
};
export const ImgEmpty: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <rect
                x="3.5"
                y="3.5"
                width="17"
                height="17"
                stroke="black"
            />
            <rect
                x="9"
                y="7"
                width="1"
                height="4"
                fill="black"
            />
            <rect
                x="14"
                y="7"
                width="1"
                height="4"
                fill="black"
            />
            <rect
                x="15"
                y="17"
                width="5"
                height="1"
                fill="black"
            />
            <rect
                x="20"
                y="18"
                width="1"
                height="2"
                fill="white"
            />
        </svg>
    );
};

export const Circle: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
        >
            <circle
                cx="18"
                cy="18"
                r="17.5"
                fill="white"
                stroke="black"
            />
        </svg>
    );
};
export const DownloadIconFile: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M5.83325 8.66683L9.99992 12.8335M9.99992 12.8335L14.1666 8.66683M9.99992 12.8335L9.99992 2.50016"
                stroke="black"
            />
            <path
                d="M2.5 12.1665V17.4998H17.5V12.1665"
                stroke="black"
            />
        </svg>
    );
};

export const DeleteFileAttachIcon: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="10"
                cy="10"
                r="9.5"
                fill="white"
                stroke="black"
            />
            <path
                d="M14 14L10.0247 10L14 6M6 14L9.97531 10L6 6"
                stroke="black"
                strokeWidth="2"
            />
        </svg>
    );
};

export const DeclarationIcon: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 14.5C5 10.634 8.13401 7.5 12 7.5C15.866 7.5 19 10.634 19 14.5V21.5H5V14.5Z"
                stroke="black"
            />
            <mask
                id="path-2-inside-1_3_21505"
                fill="white"
            >
                <path d="M2 21H22V22H2V21Z" />
            </mask>
            <path
                d="M2 21V19.6H0.6V21H2ZM22 21H23.4V19.6H22V21ZM22 22V23.4H23.4V22H22ZM2 22H0.6V23.4H2V22ZM2 22.4H22V19.6H2V22.4ZM20.6 21V22H23.4V21H20.6ZM22 20.6H2V23.4H22V20.6ZM3.4 22V21H0.6V22H3.4Z"
                fill="black"
                mask="url(#path-2-inside-1_3_21505)"
            />
            <path
                d="M11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V5.5H11V3Z"
                fill="black"
            />
            <path
                d="M19.2929 4.20711C19.6834 3.81658 20.3166 3.81658 20.7071 4.20711C21.0976 4.59763 21.0976 5.2308 20.7071 5.62132L18.9393 7.38909L17.5251 5.97487L19.2929 4.20711Z"
                fill="black"
            />
            <path
                d="M5.20711 4.20711C4.81658 3.81658 4.18342 3.81658 3.79289 4.20711C3.40237 4.59763 3.40237 5.2308 3.79289 5.62132L5.56066 7.38909L6.97487 5.97487L5.20711 4.20711Z"
                fill="black"
            />
        </svg>
    );
};

export const CorrectionIcon: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Edit_light">
                <path
                    id="Rectangle 1"
                    d="M15.6612 1.64645L15.3077 1.29289L14.9541 1.64645L4.26893 12.3317C4.25791 12.3427 4.24696 12.3536 4.2361 12.3644C4.07363 12.5266 3.9298 12.6701 3.82843 12.8491C3.72707 13.0282 3.678 13.2253 3.62256 13.4481C3.61886 13.463 3.61512 13.478 3.61134 13.4931L2.71704 17.0703C2.71483 17.0791 2.7126 17.088 2.71036 17.097C2.67112 17.2537 2.62921 17.421 2.61546 17.5615C2.60032 17.7163 2.60385 17.9773 2.81326 18.1867C3.02267 18.3961 3.28373 18.3997 3.43846 18.3845C3.579 18.3708 3.74635 18.3289 3.90305 18.2896C3.91198 18.2874 3.92087 18.2852 3.92972 18.283L7.50692 17.3887C7.52204 17.3849 7.53705 17.3811 7.55194 17.3774C7.77467 17.322 7.97185 17.2729 8.15088 17.1716C8.32991 17.0702 8.47343 16.9264 8.63557 16.7639C8.6464 16.753 8.65733 16.7421 8.66835 16.7311L19.3536 6.04586L19.7071 5.69231L19.3536 5.33875L15.6612 1.64645Z"
                    stroke="black"
                />
                <path
                    id="Vector 107"
                    d="M12 5L16 9"
                    stroke="black"
                    strokeWidth="2"
                />
            </g>
        </svg>
    );
};

export const DeleteIcon: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 19C5 19.8284 5.67157 20.5 6.5 20.5H17.5C18.3284 20.5 19 19.8284 19 19V6.5H5V19Z"
                stroke="black"
            />
            <mask
                id="path-2-inside-1_3_21513"
                fill="white"
            >
                <path d="M2 7H22V6H2V7Z" />
            </mask>
            <path
                d="M2 7V8.4H0.6V7H2ZM22 7H23.4V8.4H22V7ZM22 6V4.6H23.4V6H22ZM2 6H0.6V4.6H2V6ZM2 5.6H22V8.4H2V5.6ZM20.6 7V6H23.4V7H20.6ZM22 7.4H2V4.6H22V7.4ZM3.4 6V7H0.6V6H3.4Z"
                fill="black"
                mask="url(#path-2-inside-1_3_21513)"
            />
            <path
                d="M11 6H13V4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V6Z"
                fill="black"
            />
            <path
                d="M13 12C13 11.4477 13.4477 11 14 11C14.5523 11 15 11.4477 15 12V15H13V12Z"
                fill="black"
            />
            <path
                d="M9 12C9 11.4477 9.44772 11 10 11C10.5523 11 11 11.4477 11 12V15H9V12Z"
                fill="black"
            />
        </svg>
    );
};

export const LockOpenIcon: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.14307 13.3818C4.14307 11.4962 4.14307 10.5534 4.72885 9.96762C5.31464 9.38184 6.25745 9.38184 8.14307 9.38184H15.8574C17.743 9.38184 18.6858 9.38184 19.2716 9.96762C19.8574 10.5534 19.8574 11.4962 19.8574 13.3818V16.9056C19.8574 18.7913 19.8574 19.7341 19.2716 20.3199C18.6858 20.9056 17.743 20.9056 15.8574 20.9056H8.14306C6.25745 20.9056 5.31464 20.9056 4.72885 20.3199C4.14307 19.7341 4.14307 18.7913 4.14307 16.9056V13.3818Z"
                stroke="black"
            />
            <path
                d="M16.7145 9.38142V7.80999C16.7145 5.20636 14.6038 3.0957 12.0002 3.0957V3.0957C9.39655 3.0957 7.28589 5.20636 7.28589 7.80999V9.38142"
                stroke="black"
                strokeLinecap="round"
            />
            <path
                d="M11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14V17H11V14Z"
                fill="black"
            />
        </svg>
    );
};

export const ChangeStateIcon: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.3536 8.35355C20.5488 8.15829 20.5488 7.84171 20.3536 7.64645L17.1716 4.46447C16.9763 4.2692 16.6597 4.2692 16.4645 4.46447C16.2692 4.65973 16.2692 4.97631 16.4645 5.17157L19.2929 8L16.4645 10.8284C16.2692 11.0237 16.2692 11.3403 16.4645 11.5355C16.6597 11.7308 16.9763 11.7308 17.1716 11.5355L20.3536 8.35355ZM4 8V8.5H20V8V7.5H4V8Z"
                fill="black"
            />
            <path
                d="M2.64645 15.6464C2.45119 15.8417 2.45119 16.1583 2.64645 16.3536L5.82843 19.5355C6.02369 19.7308 6.34027 19.7308 6.53553 19.5355C6.7308 19.3403 6.7308 19.0237 6.53553 18.8284L3.70711 16L6.53553 13.1716C6.7308 12.9763 6.7308 12.6597 6.53553 12.4645C6.34027 12.2692 6.02369 12.2692 5.82843 12.4645L2.64645 15.6464ZM19 16L19 15.5L3 15.5L3 16L3 16.5L19 16.5L19 16Z"
                fill="black"
            />
        </svg>
    );
};

export const EyesIcon: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M22 11.6295C22 11.6295 17.4639 16.4749 12 16.4749C6.53608 16.4749 2 11.6295 2 11.6295C2 11.6295 6.43299 6.78418 12 6.78418C17.567 6.78418 22 11.6295 22 11.6295Z"
                stroke="black"
                strokeMiterlimit="10"
            />
            <path
                d="M11.9996 14.1027C13.3661 14.1027 14.4738 12.995 14.4738 11.6285C14.4738 10.262 13.3661 9.1543 11.9996 9.1543C10.6331 9.1543 9.52539 10.262 9.52539 11.6285C9.52539 12.995 10.6331 14.1027 11.9996 14.1027Z"
                stroke="black"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M19.2172 4.41309L4.78418 18.8461"
                stroke="black"
                strokeMiterlimit="10"
            />
            <path
                d="M18.9072 4L4.37109 18.5361"
                stroke="black"
                strokeMiterlimit="10"
            />
            <path
                d="M19.6289 4.72168L5.09277 19.2578"
                stroke="white"
                strokeMiterlimit="10"
            />
        </svg>
    );
};

export const BlockUserIcon: React.FC<IconProps> = ({ width = '24', height = '24', fill = 'none', color = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 25 25"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.1569 6.84315C21.281 9.96734 21.281 15.0327 18.1569 18.1569C15.0327 21.281 9.96734 21.281 6.84314 18.1569C3.71895 15.0327 3.71895 9.96734 6.84314 6.84315C9.96734 3.71895 15.0327 3.71895 18.1569 6.84315ZM6.84314 6.84315L18.1569 18.1569"
                stroke={color}
                strokeWidth="1.2"
            />
        </svg>
    );
};

export const UnLockOpenIcon: React.FC<IconProps> = ({ width = '24', height = '24' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.14307 13.3809C4.14307 11.4952 4.14307 10.5524 4.72885 9.96665C5.31464 9.38086 6.25745 9.38086 8.14307 9.38086H15.8574C17.743 9.38086 18.6858 9.38086 19.2716 9.96665C19.8574 10.5524 19.8574 11.4952 19.8574 13.3809V16.9047C19.8574 18.7903 19.8574 19.7331 19.2716 20.3189C18.6858 20.9047 17.743 20.9047 15.8574 20.9047H8.14306C6.25745 20.9047 5.31464 20.9047 4.72885 20.3189C4.14307 19.7331 4.14307 18.7903 4.14307 16.9047V13.3809Z"
                stroke="black"
            />
            <path
                d="M16.8313 9.15545L16.9025 8.58632C17.1399 6.68652 16.2851 4.81535 14.6935 3.75118V3.75118C12.7984 2.4841 10.2902 2.64027 8.56692 4.13264L7.81645 4.78256"
                stroke="black"
                strokeLinecap="round"
            />
            <path
                d="M11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14V17H11V14Z"
                fill="black"
            />
        </svg>
    );
};

export const Ellipse = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="2"
            height="2"
            viewBox="0 0 2 2"
            fill="none"
        >
            <circle
                cx="1"
                cy="1"
                r="1"
                fill="#BBBBBB"
            />
        </svg>
    );
};

export const EllipseRed = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="4"
            viewBox="0 0 4 4"
            fill="none"
        >
            <circle
                cx="2"
                cy="2"
                r="2"
                fill="#FF2164"
            />
        </svg>
    );
};

export const PublicPostIcon = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.14307 13.3809C4.14307 11.4952 4.14307 10.5524 4.72885 9.96665C5.31464 9.38086 6.25745 9.38086 8.14307 9.38086H15.8574C17.743 9.38086 18.6858 9.38086 19.2716 9.96665C19.8574 10.5524 19.8574 11.4952 19.8574 13.3809V16.9047C19.8574 18.7903 19.8574 19.7331 19.2716 20.3189C18.6858 20.9047 17.743 20.9047 15.8574 20.9047H8.14306C6.25745 20.9047 5.31464 20.9047 4.72885 20.3189C4.14307 19.7331 4.14307 18.7903 4.14307 16.9047V13.3809Z"
                stroke="black"
            />
            <path
                d="M16.8313 9.15545L16.9025 8.58632C17.1399 6.68652 16.2851 4.81535 14.6935 3.75118V3.75118C12.7984 2.4841 10.2902 2.64027 8.56692 4.13264L7.81645 4.78256"
                stroke="black"
                strokeLinecap="round"
            />
            <path
                d="M11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14V17H11V14Z"
                fill="black"
            />
        </svg>
    );
};
export const PrivacyPostIcon = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2 9.00016C2 7.43645 2 6.65459 2.41329 6.11597C2.51969 5.97731 2.64381 5.85319 2.78248 5.74679C3.32109 5.3335 4.10295 5.3335 5.66667 5.3335H8.33333C9.89705 5.3335 10.6789 5.3335 11.2175 5.74679C11.3562 5.85319 11.4803 5.97731 11.5867 6.11597C12 6.65459 12 7.43645 12 9.00016V9.00016C12 10.5639 12 11.3457 11.5867 11.8844C11.4803 12.023 11.3562 12.1471 11.2175 12.2535C10.6789 12.6668 9.89705 12.6668 8.33333 12.6668H5.66667C4.10295 12.6668 3.32109 12.6668 2.78248 12.2535C2.64381 12.1471 2.51969 12.023 2.41329 11.8844C2 11.3457 2 10.5639 2 9.00016V9.00016Z"
                stroke="black"
            />
            <path
                d="M10 5.3335V4.3335C10 2.67664 8.65685 1.3335 7 1.3335V1.3335C5.34315 1.3335 4 2.67664 4 4.3335V5.3335"
                stroke="black"
                strokeLinecap="round"
            />
            <circle
                cx="7"
                cy="9"
                r="1"
                fill="black"
            />
        </svg>
    );
};
export const AddImage = () => {
    return (
        <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="79"
                height="79"
                rx="9.5"
                fill="white"
                stroke="url(#paint0_linear_3_12859)"
                strokeDasharray="2 2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41 31H39V39L31 39V41H39V49H41V41H49V39L41 39V31Z"
                fill="url(#paint1_linear_3_12859)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3_12859"
                    x1="83.8503"
                    y1="-3.38982"
                    x2="-27.1936"
                    y2="26.6085"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE924" />
                    <stop
                        offset="0.255208"
                        stopColor="#FF4A4D"
                    />
                    <stop
                        offset="0.52667"
                        stopColor="#B238FF"
                    />
                    <stop
                        offset="0.729167"
                        stopColor="#3D81FF"
                    />
                    <stop
                        offset="1"
                        stopColor="#41FFD2"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_3_12859"
                    x1="49.8663"
                    y1="30.2373"
                    x2="24.8814"
                    y2="36.9869"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE924" />
                    <stop
                        offset="0.255208"
                        stopColor="#FF4A4D"
                    />
                    <stop
                        offset="0.52667"
                        stopColor="#B238FF"
                    />
                    <stop
                        offset="0.729167"
                        stopColor="#3D81FF"
                    />
                    <stop
                        offset="1"
                        stopColor="#41FFD2"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const BookMarkIconActive = ({ width = 20, height = 20, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.33325 7.5C3.33325 5.14298 3.33325 3.96447 4.06548 3.23223C4.79772 2.5 5.97623 2.5 8.33325 2.5H11.6666C14.0236 2.5 15.2021 2.5 15.9344 3.23223C16.6666 3.96447 16.6666 5.14298 16.6666 7.5V13.1897C16.6666 15.4257 16.6666 16.5438 15.963 16.8857C15.2594 17.2277 14.3803 16.537 12.622 15.1555L12.0593 14.7133C11.0707 13.9365 10.5764 13.5482 9.99992 13.5482C9.42348 13.5482 8.92916 13.9365 7.94051 14.7133L7.3778 15.1555C5.61954 16.537 4.74041 17.2277 4.03683 16.8857C3.33325 16.5438 3.33325 15.4257 3.33325 13.1897V7.5Z"
                fill="#FF2164"
                stroke="black"
            />
        </svg>
    );
};

export const NextImageIcon = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="17.5"
                transform="matrix(-1 0 0 1 36 -0.00195312)"
                fill="white"
                stroke="black"
            />
            <path
                d="M15.9999 11.9971L21.9999 17.9971L15.9999 23.9971"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const PreviousImageIcon = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="17.998"
                r="17.5"
                fill="white"
                stroke="black"
            />
            <path
                d="M20.0001 11.9971L14.0001 17.9971L20.0001 23.9971"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const NextImageIconDisabled = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="17.5"
                transform="matrix(-1 0 0 1 36 -0.00195312)"
                fill="#F9F9F9"
                stroke="#EEEEEE"
            />
            <path
                d="M15.9999 11.9971L21.9999 17.9971L15.9999 23.9971"
                stroke="#BBBBBB"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const PreviousImageIconDisabled = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="17.998"
                r="17.5"
                fill="#F9F9F9"
                stroke="#EEEEEE"
            />
            <path
                d="M20.0001 11.9971L14.0001 17.9971L20.0001 23.9971"
                stroke="#BBBBBB"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const BannerDemo = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="375"
            height="370"
            viewBox="0 0 375 370"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3_23190)">
                <rect
                    width="375"
                    height="370"
                    fill="#FDD000"
                />
                <rect
                    width="375"
                    height="370"
                    fill="#FDD000"
                />
                <mask
                    id="mask0_3_23190"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="375"
                    height="350"
                >
                    <path
                        d="M0 0H375V350H0L0 0Z"
                        fill="#FDD000"
                    />
                </mask>
                <g mask="url(#mask0_3_23190)">
                    <circle
                        cx="81"
                        cy="81"
                        r="81"
                        fill="white"
                        fillOpacity="0.2"
                    />
                    <circle
                        cx="126"
                        cy="146"
                        r="70"
                        fill="white"
                        fillOpacity="0.2"
                    />
                    <circle
                        cx="154"
                        cy="309"
                        r="54"
                        fill="white"
                        fillOpacity="0.2"
                    />
                    <circle
                        cx="335.5"
                        cy="39.5"
                        r="39.5"
                        fill="white"
                        fillOpacity="0.2"
                    />
                    <path
                        d="M245.504 116.763C239.923 137.59 218.516 149.949 197.689 144.369C176.862 138.788 164.503 117.381 170.083 96.554C175.664 75.7272 197.071 63.3677 217.898 68.9482C238.725 74.5287 251.084 95.9361 245.504 116.763Z"
                        fill="white"
                    />
                    <path
                        d="M302.069 131.92C296.489 152.746 275.081 165.106 254.255 159.525C233.428 153.945 221.068 132.537 226.649 111.711C232.229 90.8839 253.637 78.5243 274.464 84.1048C295.29 89.6854 307.65 111.093 302.069 131.92Z"
                        fill="white"
                    />
                    <path
                        d="M358.635 147.076C353.054 167.903 331.647 180.263 310.82 174.682C289.993 169.101 277.634 147.694 283.214 126.867C288.795 106.041 310.202 93.681 331.029 99.2615C351.856 104.842 364.215 126.249 358.635 147.076Z"
                        fill="white"
                    />
                    <path
                        d="M230.347 173.328C224.767 194.155 203.359 206.515 182.533 200.934C161.706 195.354 149.346 173.946 154.927 153.119C160.507 132.293 181.915 119.933 202.741 125.514C223.568 131.094 235.928 152.501 230.347 173.328Z"
                        fill="white"
                    />
                    <path
                        d="M286.913 188.485C281.332 209.312 259.925 221.671 239.098 216.091C218.271 210.51 205.912 189.103 211.492 168.276C217.073 147.449 238.48 135.09 259.307 140.67C280.134 146.251 292.493 167.658 286.913 188.485Z"
                        fill="white"
                    />
                    <path
                        d="M343.478 203.642C337.898 224.468 316.49 236.828 295.663 231.247C274.837 225.667 262.477 204.26 268.058 183.433C273.638 162.606 295.045 150.246 315.872 155.827C336.699 161.407 349.059 182.815 343.478 203.642Z"
                        fill="white"
                    />
                    <path
                        d="M215.191 229.894C209.61 250.72 188.203 263.08 167.376 257.499C146.549 251.919 134.19 230.512 139.77 209.685C145.351 188.858 166.758 176.498 187.585 182.079C208.412 187.659 220.771 209.067 215.191 229.894Z"
                        fill="white"
                    />
                    <path
                        d="M271.756 245.05C266.176 265.877 244.768 278.237 223.941 272.656C203.115 267.076 190.755 245.668 196.336 224.841C201.916 204.015 223.323 191.655 244.15 197.236C264.977 202.816 277.337 224.224 271.756 245.05Z"
                        fill="white"
                    />
                    <path
                        d="M328.321 260.207C322.741 281.034 301.334 293.393 280.507 287.813C259.68 282.232 247.32 260.825 252.901 239.998C258.481 219.171 279.889 206.812 300.716 212.392C321.542 217.973 333.902 239.38 328.321 260.207Z"
                        fill="white"
                    />
                    <rect
                        x="184.906"
                        y="44.249"
                        width="195.203"
                        height="11.7122"
                        transform="rotate(20 184.906 44.249)"
                        fill="black"
                    />
                    <path
                        d="M244.614 45.2588L274.54 80.0398L319.821 72.6317"
                        stroke="black"
                        strokeWidth="10"
                    />
                    <path
                        d="M202.922 185.18L212.651 197.891L231.845 182.825"
                        stroke="black"
                        strokeWidth="8"
                    />
                    <path
                        d="M289.542 129.81C290.167 129.398 291.012 129.624 291.347 130.293L293.887 135.359C294.333 136.248 295.225 136.827 296.219 136.873L301.88 137.133C302.628 137.168 303.178 137.847 303.056 138.586L302.134 144.177C301.972 145.159 302.353 146.151 303.13 146.773L307.557 150.31C308.141 150.778 308.187 151.651 307.654 152.176L303.622 156.158C302.914 156.857 302.639 157.884 302.902 158.843L304.404 164.308C304.602 165.029 304.126 165.762 303.386 165.875L297.784 166.725C296.8 166.875 295.974 167.544 295.623 168.475L293.626 173.778C293.362 174.479 292.546 174.792 291.882 174.448L286.849 171.843C285.965 171.386 284.903 171.441 284.072 171.989L279.34 175.105C278.715 175.517 277.87 175.291 277.535 174.622L274.995 169.556C274.549 168.667 273.657 168.088 272.663 168.042L267.002 167.782C266.254 167.747 265.704 167.068 265.826 166.329L266.748 160.738C266.91 159.756 266.529 158.764 265.752 158.142L261.325 154.604C260.741 154.137 260.695 153.264 261.227 152.739L265.26 148.757C265.968 148.058 266.243 147.031 265.98 146.072L264.478 140.607C264.28 139.886 264.756 139.153 265.496 139.04L265.383 138.299L265.496 139.04L271.098 138.19C272.082 138.04 272.908 137.371 273.259 136.44L275.256 131.137C275.52 130.436 276.336 130.123 277 130.467L282.033 133.072C282.917 133.529 283.978 133.474 284.81 132.926L289.542 129.81Z"
                        fill="#FDD000"
                        stroke="black"
                        strokeWidth="1.5"
                    />
                    <circle
                        cx="279.357"
                        cy="145.032"
                        r="1.95203"
                        transform="rotate(15 279.357 145.032)"
                        fill="black"
                    />
                    <ellipse
                        cx="292.556"
                        cy="148.569"
                        rx="1.95203"
                        ry="1.95203"
                        transform="rotate(15 292.556 148.569)"
                        fill="black"
                    />
                    <path
                        d="M289.155 153.721C286.971 154.799 282.666 155.546 279.727 151.195"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M177.098 96.0354C178.198 95.4191 179.415 96.636 178.799 97.7368L172.432 109.108C172.055 109.781 171.978 110.581 172.22 111.314L175.087 119.991C175.409 120.966 174.483 121.892 173.508 121.57L164.831 118.703C164.098 118.461 163.298 118.538 162.625 118.915L151.254 125.282C150.153 125.898 148.936 124.681 149.553 123.581L155.934 112.184C156.299 111.532 156.383 110.758 156.166 110.042L153.625 101.667C153.335 100.711 154.228 99.8179 155.184 100.108L163.559 102.649C164.275 102.866 165.049 102.782 165.701 102.417L177.098 96.0354Z"
                        fill="#63FFF6"
                        stroke="black"
                        strokeWidth="1.5"
                    />
                </g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M120.464 92.7324L127.392 96.7324L128.258 97.2324C132.563 99.7177 134.038 105.222 131.553 109.527C129.067 113.831 123.563 115.306 119.258 112.821C118.966 112.652 118.686 112.469 118.42 112.273L116.392 115.785L109.464 111.785L115.964 100.527L120.464 92.7324ZM123.009 106.325C123.726 106.739 124.643 106.494 125.058 105.776C125.472 105.059 125.226 104.141 124.509 103.727C123.791 103.313 122.874 103.559 122.46 104.276C122.045 104.994 122.291 105.911 123.009 106.325Z"
                    fill="white"
                    fillOpacity="0.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M351.464 64.7324L358.392 68.7324L359.258 69.2324C363.563 71.7177 365.038 77.222 362.553 81.5266C360.067 85.8313 354.563 87.3062 350.258 84.8209C349.966 84.6519 349.686 84.4689 349.42 84.2733L347.392 87.785L340.464 83.785L346.964 72.5266L351.464 64.7324ZM354.009 78.3252C354.726 78.7394 355.643 78.4936 356.058 77.7761C356.472 77.0587 356.226 76.1413 355.509 75.7271C354.791 75.3129 353.874 75.5587 353.46 76.2761C353.045 76.9936 353.291 77.9109 354.009 78.3252Z"
                    fill="white"
                    fillOpacity="0.3"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M81.4641 271.732L88.3923 267.732L89.2583 267.232C93.563 264.747 99.0673 266.222 101.553 270.527C104.038 274.831 102.563 280.336 98.2583 282.821C97.9656 282.99 97.6673 283.141 97.3648 283.273L99.3923 286.785L92.4641 290.785L85.9641 279.527L81.4641 271.732ZM94.508 276.325C95.2255 275.911 95.4713 274.994 95.0571 274.276C94.6428 273.559 93.7255 273.313 93.008 273.727C92.2906 274.141 92.0448 275.059 92.459 275.776C92.8732 276.494 93.7906 276.739 94.508 276.325Z"
                    fill="white"
                    fillOpacity="0.5"
                />
                <path
                    d="M28.736 160.304V166.568H33.248V160.304H28.736ZM32.576 173.024H41.048V175.568H21.032V173.024H29.408V169.088H22.712V166.568H25.592V160.304H22.592V157.784H39.392V160.304H36.392V166.568H39.32V169.088H32.576V173.024ZM61.4701 155.984V171.848H58.2781V155.984H61.4701ZM46.5181 162.992C46.5181 164.768 47.8141 165.848 49.4461 165.848C51.1021 165.848 52.3501 164.768 52.3501 162.992C52.3501 161.168 51.1021 160.112 49.4461 160.112C47.8141 160.112 46.5181 161.168 46.5181 162.992ZM55.4461 162.992C55.4461 166.208 52.8301 168.584 49.4461 168.584C46.0621 168.584 43.4221 166.208 43.4221 162.992C43.4221 159.728 46.0621 157.376 49.4461 157.376C52.8301 157.376 55.4461 159.728 55.4461 162.992ZM49.9261 175.16H62.0221V177.68H46.7581V170.288H49.9261V175.16ZM83.0683 167.36V169.856H67.5403V157.568H82.9003V160.112H70.7563V162.44H82.3963V164.888H70.7563V167.36H83.0683ZM65.1883 172.952H85.2043V175.52H65.1883V172.952ZM29.144 196.296V193.464H24.8V196.296H29.144ZM32.264 188.256V198.768H21.68V188.256H24.8V191.04H29.144V188.256H32.264ZM27.224 203.328V206.28H38.984V208.8H24.08V200.808H38.576V203.328H27.224ZM38.432 191.976H41.36V194.592H38.432V199.848H35.264V186.96H38.432V191.976ZM53.0941 188.064C57.7501 188.064 61.3501 190.608 61.3501 194.472C61.3501 198.312 57.7501 200.856 53.0941 200.856C48.4621 200.856 44.8621 198.312 44.8621 194.472C44.8621 190.608 48.4621 188.064 53.0941 188.064ZM53.0941 190.656C50.0941 190.656 47.9581 192.072 47.9581 194.472C47.9581 196.824 50.0941 198.264 53.0941 198.264C56.1181 198.264 58.2541 196.824 58.2541 194.472C58.2541 192.072 56.1181 190.656 53.0941 190.656ZM43.1101 203.832H63.1261V206.424H43.1101V203.832ZM72.2443 188.88V192.48C72.2443 196.056 73.2043 199.728 76.2043 201.72L74.4763 204.168C72.6043 203.016 71.4283 201.144 70.7323 198.912C69.9643 201.36 68.6683 203.472 66.6763 204.672L64.7803 202.296C68.0203 200.328 69.1963 196.368 69.1963 192.6V188.88H72.2443ZM76.6603 194.424V187.32H79.6123V208.08H76.6603V196.992H73.9003V194.424H76.6603ZM81.1483 186.96H84.1483V209.064H81.1483V186.96ZM94.8264 199.704V203.928H99.6984V199.704C98.9304 199.848 98.1144 199.92 97.2504 199.92C96.3864 199.92 95.5944 199.848 94.8264 199.704ZM97.2504 190.536C94.1784 190.536 92.1384 191.784 92.1384 193.992C92.1384 196.176 94.1784 197.448 97.2504 197.448C100.322 197.448 102.386 196.176 102.386 193.992C102.386 191.784 100.322 190.536 97.2504 190.536ZM102.842 203.928H107.282V206.496H87.2664V203.928H91.6824V198.528C90.0024 197.496 88.9944 195.912 89.0184 193.992C89.0184 190.368 92.4984 188.04 97.2504 188.04C102.026 188.04 105.506 190.368 105.506 193.992C105.506 195.912 104.498 197.496 102.842 198.528V203.928ZM111.601 200.952L111.097 192.096L110.977 188.76H114.529L114.409 192.096L113.905 200.952H111.601ZM112.753 207.336C111.505 207.336 110.569 206.328 110.569 205.032C110.569 203.736 111.505 202.728 112.753 202.728C114.001 202.728 114.961 203.736 114.961 205.032C114.961 206.328 114.001 207.336 112.753 207.336Z"
                    fill="black"
                />
                <path
                    d="M22.592 100.536V107.288H25.6V100.536H22.592ZM21.36 108.328V99.496H26.816V108.328H21.36ZM31.792 97.832H33.04V112.168H31.792V104.584H29.856V111.464H28.624V98.152H29.856V103.512H31.792V97.832ZM47.3428 97.832V105.192H46.0308V97.832H47.3428ZM37.1668 101.544C37.1668 102.776 38.2068 103.656 39.5988 103.656C41.0068 103.656 42.0308 102.776 42.0308 101.544C42.0308 100.296 41.0068 99.416 39.5988 99.416C38.2068 99.416 37.1668 100.296 37.1668 101.544ZM43.3108 101.544C43.3108 103.432 41.7428 104.712 39.5988 104.712C37.4548 104.712 35.9028 103.432 35.9028 101.544C35.9028 99.64 37.4548 98.344 39.5988 98.344C41.7428 98.344 43.3108 99.64 43.3108 101.544ZM39.3748 110.952H47.8228V111.992H38.0788V108.392H46.0468V106.936H38.0468V105.896H47.3428V109.368H39.3748V110.952ZM52.0295 100.536V107.288H55.0375V100.536H52.0295ZM50.7975 108.328V99.496H56.2535V108.328H50.7975ZM61.2295 97.832H62.4775V112.168H61.2295V104.584H59.2935V111.464H58.0615V98.152H59.2935V103.512H61.2295V97.832ZM76.7803 97.832V105.192H75.4683V97.832H76.7803ZM66.6043 101.544C66.6043 102.776 67.6443 103.656 69.0363 103.656C70.4443 103.656 71.4683 102.776 71.4683 101.544C71.4683 100.296 70.4443 99.416 69.0363 99.416C67.6443 99.416 66.6043 100.296 66.6043 101.544ZM72.7483 101.544C72.7483 103.432 71.1803 104.712 69.0363 104.712C66.8923 104.712 65.3403 103.432 65.3403 101.544C65.3403 99.64 66.8923 98.344 69.0363 98.344C71.1803 98.344 72.7483 99.64 72.7483 101.544ZM68.8123 110.952H77.2603V111.992H67.5163V108.392H75.4843V106.936H67.4843V105.896H76.7803V109.368H68.8123V110.952ZM21.92 125.56L21.536 124.568C24.192 124.392 26.384 123.512 26.608 122.088H22.176V121.096H26.688V119.736H28V121.096H32.496V122.088H28.08C28.304 123.512 30.464 124.392 33.136 124.568L32.736 125.56C30.336 125.368 28.224 124.632 27.344 123.304C26.464 124.632 24.336 125.368 21.92 125.56ZM33.808 127.208H28V128.536H32.16V131.672H23.728V133.032H32.592V134.024H22.448V130.728H30.864V129.512H22.4V128.536H26.672V127.208H20.864V126.2H33.808V127.208ZM43.9508 126.664L43.2468 127.704C41.6788 127.096 40.4468 125.896 39.8228 124.392C39.2148 126.072 37.9508 127.352 36.2708 128.024L35.5828 126.968C37.7588 126.184 39.1348 124.248 39.1348 122.072V120.552H40.4468V122.12C40.4468 124.088 41.8708 125.928 43.9508 126.664ZM37.7748 130.168V129.112H47.3908V134.2H46.0628V130.168H37.7748ZM46.0628 119.848H47.3908V128.312H46.0628V123.912H42.9427V122.84H46.0628V119.848ZM54.4615 123.56V124.248C54.4615 126.536 55.6135 128.904 57.5495 129.944L56.7975 130.936C55.4055 130.152 54.3815 128.696 53.8535 126.968C53.3575 128.792 52.3495 130.392 50.9415 131.24L50.1735 130.264C52.1095 129.112 53.2135 126.6 53.2135 124.248V123.56H50.5575V122.472H53.2135V120.344H54.4775V122.472H57.1175V123.56H54.4615ZM58.3335 125.496V120.168H59.5815V133.432H58.3335V126.584H56.1415V125.496H58.3335ZM61.2135 119.832H62.4775V134.168H61.2135V119.832ZM66.1883 125.656L75.0843 125.272C75.1163 124.52 75.1163 123.784 75.1163 123.048V122.36H66.5563V121.288H76.3963V123.048C76.3963 125.176 76.3963 127.112 75.7723 130.056L74.4923 129.928C74.7963 128.552 74.9563 127.368 75.0363 126.264L66.3803 126.744L66.1883 125.656ZM65.0203 131.112H77.9963V132.184H65.0203V131.112ZM87.5091 129.896C88.8211 129.896 89.7651 128.968 89.7651 127.688C89.7651 126.392 88.8211 125.464 87.5091 125.464C86.2131 125.464 85.2691 126.392 85.2691 127.688C85.2691 128.968 86.2131 129.896 87.5091 129.896ZM87.5091 124.376C89.5571 124.376 91.0131 125.752 91.0131 127.688C91.0131 129.64 89.5571 130.984 87.5091 130.984C85.4931 130.984 84.0371 129.64 84.0371 127.688C84.0371 125.752 85.4931 124.376 87.5091 124.376ZM88.1491 120.008V122.136H91.6851V123.192H83.2211V122.136H86.8371V120.008H88.1491ZM96.7091 125.736V126.84H94.3571V134.184H93.0451V119.848H94.3571V125.736H96.7091ZM108.148 122.696V122.344H99.3959V121.272H109.46V122.696C109.46 124.472 109.46 126.44 108.916 129.336L107.604 129.192C108.148 126.44 108.148 124.424 108.148 122.696ZM104.388 131.096H111.012V132.168H98.0359V131.096H103.076V125.96H104.388V131.096Z"
                    fill="black"
                />
                <path
                    d="M20 113.4H78.8763V114.2H20V113.4ZM20 135.4H111.892V136.2H20V135.4Z"
                    fill="black"
                />
                <rect
                    x="323"
                    y="15"
                    width="32"
                    height="24"
                    rx="12"
                    fill="black"
                    fillOpacity="0.5"
                />
                <path
                    d="M331.86 31V30.05H333.47V24.93H332.15V24.2C332.84 24.07 333.33 23.9 333.75 23.64H334.62V30.05H336.06V31H331.86ZM336.823 32.8L339.603 23.02H340.403L337.623 32.8H336.823ZM343.28 31.13C342.12 31.13 341.39 30.66 340.87 30.15L341.42 29.4C341.84 29.82 342.37 30.19 343.14 30.19C343.97 30.19 344.6 29.6 344.6 28.62C344.6 27.64 344.04 27.08 343.2 27.08C342.73 27.08 342.45 27.22 342.02 27.5L341.46 27.13L341.68 23.64H345.41V24.61H342.68L342.51 26.5C342.82 26.34 343.12 26.24 343.52 26.24C344.75 26.24 345.76 26.97 345.76 28.58C345.76 30.21 344.57 31.13 343.28 31.13Z"
                    fill="white"
                />
                <circle
                    cx="159"
                    cy="309"
                    r="4"
                    fill="white"
                />
                <circle
                    cx="173"
                    cy="309"
                    r="3.5"
                    stroke="white"
                />
                <circle
                    cx="187"
                    cy="309"
                    r="3.5"
                    stroke="white"
                />
                <circle
                    cx="201"
                    cy="309"
                    r="3.5"
                    stroke="white"
                />
                <circle
                    cx="215"
                    cy="309"
                    r="3.5"
                    stroke="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_3_23190">
                    <rect
                        width="375"
                        height="370"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const AttendanceCheck = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="33"
            height="34"
            viewBox="0 0 33 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 3.12207V29.9999H32.8923V3.12207H0ZM31.8892 29.0013H1.00266V8.61789H31.8892V29.0013Z"
                fill="#333333"
            />
            <path
                d="M8.65256 0.499023H4.44092V6.7439H8.65256V0.499023Z"
                fill="#C4C4C4"
            />
            <path
                d="M9.15277 7.2439H3.93848V0H9.15318L9.15277 7.2439ZM4.94114 6.24488H8.15012V0.99902H4.94114V6.24488Z"
                fill="#333333"
            />
            <path
                d="M28.4508 0.499023H24.2388V6.7439H28.4508V0.499023Z"
                fill="#C4C4C4"
            />
            <path
                d="M28.952 7.2439H23.7373V0H28.952V7.2439ZM24.7404 6.24488H27.9493V0.99902H24.7404V6.24488Z"
                fill="#333333"
            />
            <path
                d="M14.6309 23.9889C14.622 23.9889 14.6127 23.9885 14.6034 23.9885C14.2646 23.9809 13.9436 23.8375 13.7126 23.5904L8.431 17.9282C7.95967 17.423 7.98885 16.6328 8.49585 16.1632C9.00285 15.6935 9.79598 15.7226 10.2673 16.2278L14.6702 20.9479L22.8435 12.9242C23.3363 12.44 24.1302 12.4461 24.6157 12.9371C25.1017 13.4286 25.096 14.2192 24.6028 14.7038L15.5108 23.63C15.2761 23.8597 14.9596 23.9889 14.6309 23.9889Z"
                fill="#F7506F"
            />
        </svg>
    );
};

export const MissionParticipation = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="30"
            height="34"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.8048 30H0V3.07422H29.8045V30H29.8048ZM0.967903 29.019H28.8372V4.05488H0.967903V29.019Z"
                fill="#333333"
            />
            <path
                d="M24.8208 1.14637H22.551C22.4051 0.490977 21.8258 0 21.1351 0H8.66985C7.97945 0 7.40018 0.490977 7.25392 1.14637H4.98441C4.18416 1.14637 3.53271 1.80629 3.53271 2.61768V5.16999C3.53271 5.44088 3.74922 5.66032 4.01651 5.66032H25.7884C26.0554 5.66032 26.2722 5.44088 26.2722 5.16999V2.61768C26.2719 1.80629 25.6208 1.14637 24.8208 1.14637Z"
                fill="#333333"
            />
            <path
                d="M25.7884 11.1177H10.9457C10.6787 11.1177 10.4619 10.8983 10.4619 10.6274C10.4619 10.3565 10.6787 10.1367 10.9457 10.1367H25.7884C26.0557 10.1367 26.2722 10.3565 26.2722 10.6274C26.2722 10.8983 26.0557 11.1177 25.7884 11.1177Z"
                fill="#333333"
            />
            <path
                d="M25.7884 17.2404H10.9457C10.6787 17.2404 10.4619 17.021 10.4619 16.7498C10.4619 16.4792 10.6787 16.2598 10.9457 16.2598H25.7884C26.0557 16.2598 26.2722 16.4792 26.2722 16.7498C26.2719 17.021 26.0557 17.2404 25.7884 17.2404Z"
                fill="#333333"
            />
            <path
                d="M25.7884 23.3644H10.9457C10.6787 23.3644 10.4619 23.145 10.4619 22.8738C10.4619 22.6032 10.6787 22.3838 10.9457 22.3838H25.7884C26.0557 22.3838 26.2722 22.6032 26.2722 22.8738C26.2719 23.145 26.0557 23.3644 25.7884 23.3644Z"
                fill="#333333"
            />
            <path
                d="M6.19306 24.0985C6.86059 24.0985 7.40174 23.55 7.40174 22.8735C7.40174 22.1969 6.86059 21.6484 6.19306 21.6484C5.52552 21.6484 4.98438 22.1969 4.98438 22.8735C4.98438 23.55 5.52552 24.0985 6.19306 24.0985Z"
                fill="#15C9E2"
            />
            <path
                d="M5.4686 12.5625C5.45487 12.5625 5.44114 12.5618 5.42708 12.5608C5.27093 12.5469 5.13106 12.4576 5.05155 12.3207L4.08396 10.6536C3.94856 10.4202 4.0252 10.1199 4.25576 9.98233C4.48632 9.8451 4.78267 9.92278 4.91806 10.1565L5.54045 11.2287L7.51745 8.86574C7.69021 8.65892 7.99581 8.63368 8.19923 8.80877C8.40297 8.98387 8.42819 9.29328 8.25543 9.50009L5.83775 12.3896C5.74514 12.4997 5.60974 12.5625 5.4686 12.5625Z"
                fill="#F7506F"
            />
            <path
                d="M5.4686 18.6849C5.45487 18.6849 5.44114 18.6842 5.42708 18.6829C5.27093 18.669 5.13106 18.58 5.05155 18.4428L4.08396 16.776C3.94856 16.5426 4.0252 16.2419 4.25576 16.1047C4.48632 15.9668 4.78267 16.0452 4.91806 16.2785L5.54045 17.3508L7.51745 14.9878C7.69021 14.781 7.99581 14.7557 8.19923 14.9308C8.40297 15.1059 8.42819 15.4157 8.25543 15.6225L5.83775 18.512C5.74514 18.6217 5.60974 18.6849 5.4686 18.6849Z"
                fill="#F7506F"
            />
        </svg>
    );
};

export const SubmitYourWork = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="31"
            height="34"
            viewBox="0 0 31 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M30.1042 6.07137C30.1042 6.07107 30.1036 6.07077 30.1036 6.07046L24.8754 2.49416L21.2295 0H0V30H30.3171V6.21704L30.1042 6.07137ZM21.5691 1.42203L25.8363 4.34103L28.2384 5.98458H21.5694L21.5691 1.42203ZM0.984358 29.0195V0.980791H20.5847V6.47468C20.5847 6.74567 20.8049 6.96507 21.0766 6.96507H29.3324V29.0195H0.984358Z"
                fill="#333333"
            />
            <path
                d="M22.3011 11.9815C20.9698 9.39932 18.2723 7.63135 15.159 7.63135C10.7254 7.63135 7.13184 11.2125 7.13184 15.6291C7.13184 20.0457 10.7257 23.6269 15.159 23.6269C18.2723 23.6269 20.9698 21.8589 22.3011 19.2767L15.1587 15.6291L22.3011 11.9815ZM12.9932 14.2881C12.3953 14.2881 11.9105 13.805 11.9105 13.2093C11.9105 12.6133 12.395 12.1305 12.9932 12.1305C13.5914 12.1305 14.0759 12.6133 14.0759 13.2093C14.0759 13.8053 13.5914 14.2881 12.9932 14.2881Z"
                fill="#15C9E2"
            />
        </svg>
    );
};

export const FreeTrial = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="45"
            height="34"
            viewBox="0 0 45 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.2673 21.2799C20.0463 18.903 17.5721 17.2754 14.7169 17.2754C10.6506 17.2754 7.35449 20.5721 7.35449 24.6378C7.35449 28.7034 10.6506 32.0002 14.7169 32.0002C17.5724 32.0002 20.0466 30.3725 21.2673 27.9956L14.7163 24.6378L21.2673 21.2799ZM12.7304 23.4033C12.1819 23.4033 11.7373 22.9587 11.7373 22.4102C11.7373 21.8615 12.1819 21.4168 12.7304 21.4168C13.2788 21.4168 13.7235 21.8615 13.7235 22.4102C13.7232 22.959 13.2788 23.4033 12.7304 23.4033Z"
                fill="#333333"
            />
            <path
                d="M6.4515 23.6192C6.39319 23.6192 6.33457 23.6083 6.27876 23.5849C6.11007 23.515 6 23.3504 6 23.168V16.2113C6 15.9618 6.20205 15.7598 6.4515 15.7598H13.4079C13.5903 15.7598 13.7553 15.8701 13.8248 16.0388C13.8946 16.2075 13.8563 16.4015 13.7269 16.5306L6.77048 23.4873C6.68442 23.5733 6.56874 23.6192 6.4515 23.6192ZM6.903 16.6624V22.0779L12.3182 16.6624H6.903Z"
                fill="#333333"
            />
            <path
                d="M10.3687 16.0379C10.2989 15.8692 10.1343 15.7588 9.95185 15.7588H6.4515C6.20205 15.7588 6 15.9608 6 16.2103V19.7106C6 19.8934 6.11007 20.0577 6.27876 20.1278C6.33457 20.1509 6.39319 20.1618 6.4515 20.1618C6.56905 20.1618 6.68442 20.1163 6.77079 20.0296L10.2711 16.5293C10.4002 16.4005 10.4386 16.2065 10.3687 16.0379Z"
                fill="#333333"
            />
            <path
                d="M30.2386 24.6375L23.6875 27.9953C24.9082 30.3722 27.3827 31.9999 30.2383 31.9999C34.3045 31.9999 37.6007 28.7034 37.6007 24.6378C37.6007 20.5721 34.3045 17.2754 30.2383 17.2754C27.3827 17.2754 24.9085 18.903 23.6875 21.2799L30.2386 24.6375ZM31.2314 22.4102C31.2314 21.8615 31.676 21.4168 32.2248 21.4168C32.7733 21.4168 33.2179 21.8615 33.2179 22.4102C33.2179 22.9587 32.7733 23.4033 32.2248 23.4033C31.676 23.403 31.2314 22.9587 31.2314 22.4102Z"
                fill="#333333"
            />
            <path
                d="M38.5032 23.6185C38.3856 23.6185 38.2703 23.573 38.1839 23.4863L31.2275 16.5296C31.0984 16.4005 31.0597 16.2065 31.1296 16.0379C31.1997 15.8692 31.364 15.7588 31.5468 15.7588H38.5035C38.7526 15.7588 38.9547 15.9608 38.9547 16.2103V23.167C38.9547 23.3494 38.8446 23.5141 38.6759 23.5839C38.6198 23.6076 38.5615 23.6185 38.5032 23.6185ZM32.6365 16.6618L38.0517 22.0773V16.6618H32.6365Z"
                fill="#333333"
            />
            <path
                d="M38.5034 15.7603H35.003C34.8203 15.7603 34.6557 15.8706 34.5858 16.0393C34.5157 16.208 34.5543 16.402 34.6834 16.531L38.1838 20.0314C38.2702 20.1178 38.3855 20.1636 38.5031 20.1636C38.5614 20.1636 38.6197 20.1527 38.6758 20.1296C38.8445 20.0595 38.9546 19.8951 38.9546 19.7124V16.2118C38.9549 15.9623 38.7525 15.7603 38.5034 15.7603Z"
                fill="#333333"
            />
            <path
                d="M25.7191 12.8824C25.6474 12.8824 25.5751 12.8649 25.509 12.8303L22.4767 11.236L19.4443 12.8303C19.2919 12.9105 19.1076 12.897 18.9688 12.796C18.8298 12.6953 18.7602 12.5241 18.7892 12.3545L19.3682 8.97794L16.9146 6.58669C16.7918 6.46664 16.7472 6.28735 16.8005 6.12396C16.8535 5.96058 16.9948 5.84147 17.1647 5.81683L20.555 5.32418L22.0713 2.25163C22.1474 2.0976 22.3042 2 22.476 2C22.6478 2 22.8047 2.0976 22.8808 2.25163L24.3971 5.32418L27.7874 5.81683C27.9573 5.84147 28.0985 5.96058 28.1519 6.12396C28.2049 6.28735 28.1603 6.46695 28.0377 6.58669L25.5841 8.97794L26.1631 12.3545C26.1925 12.5241 26.1226 12.6953 25.9835 12.796C25.9059 12.8534 25.8127 12.8824 25.7191 12.8824ZM22.4767 10.2747C22.5487 10.2747 22.621 10.2922 22.6868 10.3265L25.1195 11.6058L24.6549 8.89687C24.63 8.75032 24.6783 8.60096 24.785 8.49744L26.7534 6.57889L24.0332 6.18352C23.886 6.16232 23.7591 6.07002 23.6933 5.93657L22.4767 3.47142L21.2603 5.93626C21.1945 6.06971 21.0673 6.162 20.9204 6.18321L18.2005 6.57858L20.169 8.49713C20.2753 8.60065 20.3239 8.75032 20.2987 8.89655L19.8341 11.6055L22.2671 10.3262C22.3326 10.2922 22.4046 10.2747 22.4767 10.2747Z"
                fill="#F7506F"
            />
            <path
                d="M10.0732 14.2893C10.037 14.2893 10.0008 14.285 9.96467 14.2762C9.79785 14.2348 9.66908 14.1025 9.63228 13.9348L9.17206 11.8376L7.18397 11.0278C7.02495 10.963 6.91644 10.8133 6.90397 10.6421C6.89181 10.4706 6.97787 10.3072 7.12598 10.2202L8.97811 9.13483L9.13402 6.99365C9.14649 6.82247 9.25531 6.67311 9.41433 6.60826C9.57335 6.54371 9.75576 6.57521 9.88391 6.68933L11.4888 8.11522L13.5732 7.60199C13.7407 7.56114 13.9159 7.6182 14.0266 7.74947C14.1373 7.88105 14.1638 8.06377 14.0949 8.22124L13.2346 10.1881L14.3671 12.0122C14.4578 12.1581 14.4578 12.343 14.3668 12.4886C14.276 12.6346 14.1101 12.7172 13.9393 12.6994L11.8031 12.4889L10.4187 14.1297C10.3314 14.2319 10.2045 14.2893 10.0732 14.2893ZM8.37165 10.537L9.73237 11.0911C9.86988 11.1472 9.97122 11.2673 10.003 11.4123L10.3179 12.8478L11.2655 11.7247C11.3616 11.6112 11.5069 11.552 11.655 11.5666L13.117 11.7107L12.3419 10.4622C12.2636 10.3362 12.2521 10.1794 12.3116 10.0431L12.9006 8.69705L11.4741 9.04846C11.3298 9.08432 11.1773 9.04628 11.0663 8.94775L9.96779 7.97148L9.86115 9.43728C9.85024 9.58539 9.7673 9.71854 9.63914 9.79399L8.37165 10.537Z"
                fill="#15C9E2"
            />
            <path
                d="M34.8815 14.289C34.7502 14.289 34.6233 14.2316 34.5366 14.1287L33.1522 12.488L31.0157 12.6984C30.8452 12.7156 30.679 12.6336 30.5882 12.4877C30.4975 12.3417 30.4972 12.1568 30.5879 12.0112L31.7204 10.1871L30.8598 8.22026C30.7909 8.0628 30.8174 7.88008 30.9284 7.74849C31.0388 7.61722 31.2143 7.55985 31.3815 7.60101L33.4662 8.11425L35.0708 6.68835C35.1989 6.57423 35.3813 6.54274 35.5407 6.60728C35.6997 6.67214 35.8082 6.8218 35.8207 6.99267L35.9766 9.13386L37.8284 10.2193C37.9768 10.3059 38.0629 10.4696 38.0504 10.6411C38.0382 10.8126 37.9294 10.962 37.7707 11.0268L35.7826 11.8366L35.3224 13.9338C35.2853 14.1016 35.1565 14.2338 34.9897 14.2752C34.9542 14.2846 34.9174 14.289 34.8815 14.289ZM33.344 11.5644C33.4762 11.5644 33.6028 11.6227 33.6888 11.7247L34.6364 12.8478L34.9517 11.4122C34.9835 11.2672 35.0848 11.1469 35.2223 11.0911L36.5827 10.537L35.3152 9.79395C35.1871 9.71881 35.1041 9.58535 35.0935 9.43724L34.9866 7.97144L33.8884 8.94771C33.7774 9.04624 33.6249 9.08428 33.4802 9.04842L32.0537 8.69701L32.6427 10.0431C32.702 10.1793 32.6911 10.3359 32.6125 10.4622L31.8373 11.7106L33.2997 11.5666C33.3144 11.565 33.3293 11.5644 33.344 11.5644Z"
                fill="#15C9E2"
            />
        </svg>
    );
};

export const QualificationTest = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="45"
            height="34"
            viewBox="0 0 45 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.66356 9.40363C9.62914 9.40363 9.59439 9.39935 9.55998 9.39081C9.40034 9.35102 9.27709 9.2241 9.24169 9.06299L8.80147 7.05039L6.8993 6.2731C6.74687 6.21095 6.64296 6.06759 6.63149 5.90319C6.61969 5.73879 6.70197 5.58162 6.8439 5.49844L8.61594 4.45679L8.76508 2.40177C8.77688 2.23737 8.88112 2.09368 9.03322 2.03187C9.18564 1.96972 9.36002 1.99997 9.48262 2.10946L11.0183 3.47827L13.0126 2.9854C13.1726 2.94594 13.3404 3.00085 13.4463 3.12711C13.5521 3.25337 13.5774 3.42862 13.5115 3.57987L12.6884 5.46753L13.7721 7.21808C13.859 7.35815 13.8586 7.53537 13.7718 7.67544C13.6849 7.81551 13.5263 7.89442 13.3627 7.87765L11.3186 7.67577L9.99365 9.25041C9.91039 9.34872 9.78877 9.40363 9.66356 9.40363ZM8.03542 5.80192L9.33741 6.33392C9.46918 6.38785 9.56588 6.50326 9.59669 6.64234L9.89793 8.02003L10.8046 6.94221C10.8964 6.83305 11.0357 6.77616 11.177 6.79063L12.5763 6.92873L11.8345 5.73057C11.7595 5.60924 11.7486 5.45898 11.8057 5.32845L12.3691 4.03625L11.0039 4.3736C10.8656 4.4078 10.72 4.37163 10.6138 4.27693L9.5626 3.33985L9.46033 4.74679C9.45017 4.88884 9.37084 5.01674 9.24825 5.08908L8.03542 5.80192Z"
                fill="#15C9E2"
            />
            <path
                d="M19.3985 9.51059C19.3261 9.51059 19.2536 9.4925 19.1881 9.45568L18.2162 8.91118L17.2181 9.40537C17.0705 9.47836 16.8949 9.46094 16.7641 9.36098C16.6336 9.2607 16.5713 9.09465 16.6031 8.93288L16.8188 7.83731L16.0416 7.03799C15.9269 6.91995 15.8889 6.74667 15.9436 6.59115C15.9983 6.43562 16.1363 6.32482 16.2996 6.30509L17.4049 6.17258L17.9228 5.18387C17.9992 5.03788 18.1532 4.9468 18.3162 4.95239C18.4804 4.95667 18.6282 5.05399 18.6974 5.2036L19.1645 6.2173L20.2616 6.4057C20.4239 6.43365 20.556 6.55136 20.6028 6.70919C20.6497 6.86734 20.6028 7.03832 20.4822 7.15044L19.6657 7.90932L19.826 9.01409C19.8496 9.17718 19.7788 9.33994 19.6434 9.43332C19.57 9.48527 19.4844 9.51059 19.3985 9.51059ZM18.2286 7.98856C18.3014 7.98856 18.3738 8.00697 18.4391 8.04347L18.8452 8.271L18.7783 7.80936C18.7577 7.6683 18.8078 7.52593 18.9124 7.42894L19.2533 7.1123L18.7951 7.03339C18.6551 7.00938 18.5354 6.91765 18.4758 6.7881L18.2804 6.3646L18.0641 6.77758C17.9979 6.90384 17.8743 6.98933 17.733 7.00609L17.2715 7.06133L17.596 7.39507C17.6953 7.49733 17.7383 7.64167 17.7107 7.78174L17.6206 8.23943L18.0375 8.03295C18.0975 8.00368 18.1631 7.98856 18.2286 7.98856Z"
                fill="#F7506F"
            />
            <path
                d="M35.5554 29.7855L34.692 12.1465C34.6818 11.627 34.0823 11.3827 32.3345 11.1821C31.0456 11.0342 29.3355 10.9526 27.5189 10.9526C25.7026 10.9526 23.9922 11.0342 22.7037 11.1821C21.7501 11.2916 21.1388 11.4143 20.7779 11.5872C20.417 11.4143 19.806 11.2916 18.8521 11.1821C17.5632 11.0342 15.8528 10.9526 14.0365 10.9526C12.2202 10.9526 10.5098 11.0342 9.22095 11.1821C7.47317 11.3827 6.87364 11.627 6.8638 12.1465L6.0004 29.7855C5.99909 29.8141 6.00106 29.842 6.00532 29.87H6.00466L6.26395 31.6297C6.2823 31.7544 6.35343 31.8645 6.45931 31.9322C6.52946 31.977 6.60977 32 6.69139 32C6.73269 32 6.77464 31.9937 6.81496 31.9816C7.69541 31.7179 9.64478 31.4038 13.9352 31.4038C13.9454 31.4038 13.9556 31.4038 13.9654 31.4038H14.0372H14.109C14.1172 31.4038 14.1257 31.4038 14.1342 31.4038C17.1814 31.4038 19.3753 31.5982 20.655 31.9816L20.6556 31.9796C20.695 31.9914 20.7356 32 20.7785 32C20.8215 32 20.8621 31.9917 20.9015 31.9796L20.9021 31.9816C22.1818 31.5982 24.3751 31.4038 27.4229 31.4038C27.4307 31.4038 27.4396 31.4038 27.4478 31.4038H27.5196H27.5917C27.6018 31.4038 27.6117 31.4038 27.6218 31.4038C31.9116 31.4038 33.862 31.7179 34.7425 31.9816C34.7828 31.9937 34.8247 32 34.866 32C34.9473 32 35.028 31.977 35.0981 31.9322C35.2037 31.8645 35.2751 31.7544 35.2935 31.6297L35.5524 29.87H35.5518C35.5547 29.842 35.5567 29.8141 35.5554 29.7855ZM20.3459 31.0076C18.2562 30.5361 15.1802 30.5381 14.108 30.5371H14.0365H13.9651C13.9546 30.5371 13.9444 30.5371 13.9343 30.5371C10.7875 30.5371 8.47555 30.7015 7.04769 31.0261L6.91527 30.1274C8.26314 29.8147 10.7016 29.6441 13.8684 29.6441H14.1988C16.9742 29.6441 19.0386 29.8101 20.3459 30.1376V31.0076ZM20.3459 29.2472C18.9609 28.9355 16.8981 28.7774 14.1988 28.7774H13.8684C10.7291 28.7774 8.34149 28.9382 6.89134 29.2449L7.71868 12.3428C8.27265 12.1097 10.6062 11.819 14.0365 11.819C17.4498 11.819 19.7768 12.1067 20.3459 12.3395V29.2472ZM21.2096 12.3395C21.7786 12.1071 24.1056 11.819 27.5189 11.819C30.9496 11.819 33.2828 12.1097 33.8368 12.3428L34.6641 29.2449C33.214 28.9382 30.8263 28.7774 27.6871 28.7774H27.3567C24.6573 28.7774 22.5945 28.9352 21.2096 29.2472V12.3395ZM27.6215 30.5371C27.6114 30.5371 27.6005 30.5371 27.5904 30.5371H27.5186H27.4471C26.3769 30.5361 23.2989 30.5361 21.2093 31.0076V30.1376C22.5165 29.8101 24.5812 29.6441 27.3563 29.6441H27.6867C30.8535 29.6441 33.292 29.8147 34.6399 30.1274L34.5078 31.0261C33.0799 30.7015 30.7683 30.5371 27.6215 30.5371Z"
                fill="#333333"
            />
            <path
                d="M35.0039 3.75439L36.9844 5.28432L28.2602 16.6514L25.8677 17.7131L26.2794 15.1218L35.0039 3.75439Z"
                fill="#C4C4C4"
            />
            <path
                d="M25.8677 18.1459C25.774 18.1459 25.6812 18.1153 25.6039 18.0561C25.4786 17.9591 25.416 17.8016 25.4409 17.6445L25.8526 15.0532C25.8638 14.9818 25.893 14.9144 25.9369 14.8572L34.6614 3.49016C34.8066 3.30076 35.078 3.26525 35.2671 3.41124L37.248 4.94083C37.3385 5.01087 37.3978 5.11444 37.4125 5.22854C37.4276 5.3423 37.3965 5.45771 37.3267 5.54879L28.6022 16.9162C28.5582 16.9734 28.5005 17.0188 28.4347 17.0477L26.0421 18.1094C25.9867 18.1337 25.9267 18.1459 25.8677 18.1459ZM26.6885 15.2985L26.4191 16.9944L27.9846 16.2997L36.3784 5.36302L35.0823 4.36214L26.6885 15.2985Z"
                fill="#333333"
            />
            <path
                d="M35.7552 6.8855L33.7744 5.35596L33.2475 6.04249L35.2283 7.57203L35.7552 6.8855Z"
                fill="#333333"
            />
        </svg>
    );
};

export const WayToCome = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="45"
            height="34"
            viewBox="0 0 45 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.643 22.0955C19.972 22.9034 19.5863 23.8252 18.7812 24.1552L16.3578 25.1488C15.5527 25.4789 14.6335 25.0922 14.3042 24.2843L13.3543 21.9535C13.0252 21.1462 13.4113 20.2238 14.2161 19.8938L16.6395 18.9002C17.4443 18.5699 18.3638 18.9571 18.6928 19.7644L19.643 22.0955Z"
                fill="white"
            />
            <path
                d="M15.7622 25.7231C14.9337 25.7231 14.1961 25.2262 13.8826 24.4573L12.9326 22.1265C12.7276 21.6228 12.7303 21.0692 12.94 20.5679C13.1499 20.0665 13.5418 19.6769 14.0437 19.4713L16.467 18.4776C16.7127 18.3767 16.9709 18.3257 17.2347 18.3257C18.063 18.3257 18.8006 18.8223 19.1141 19.5918L20.064 21.9226C20.2693 22.426 20.2667 22.9793 20.057 23.481C19.8473 23.9826 19.4551 24.3719 18.9532 24.5778L16.5299 25.5715C16.284 25.6724 16.026 25.7231 15.7622 25.7231ZM17.2344 19.2389C17.0894 19.2389 16.9473 19.2674 16.8113 19.3228L14.3879 20.3164C14.1113 20.43 13.8948 20.6447 13.779 20.9217C13.6632 21.198 13.662 21.5031 13.7749 21.7812L14.7246 24.112C14.8977 24.5359 15.3045 24.8105 15.7616 24.8105C15.9064 24.8105 16.0488 24.7823 16.1845 24.7266L18.6078 23.733C18.8845 23.6194 19.1009 23.4047 19.2167 23.128C19.3326 22.8514 19.3337 22.546 19.2208 22.2685L18.2709 19.9374C18.0984 19.5129 17.6916 19.2389 17.2344 19.2389Z"
                fill="#333333"
            />
            <path
                d="M12.1143 21.3254L14.1799 31.5427C14.1799 31.5427 17.936 30.7788 17.1846 27.063C16.8091 25.2055 15.8703 20.5615 15.8703 20.5615L12.1143 21.3254Z"
                fill="#C4C4C4"
            />
            <path
                d="M14.1797 31.9999C14.0908 31.9999 14.0034 31.9738 13.9282 31.9236C13.8276 31.8567 13.7577 31.7526 13.7334 31.6341L11.6678 21.4168C11.6181 21.1695 11.7772 20.929 12.0234 20.8785L15.7795 20.1146C15.8982 20.0905 16.0211 20.1146 16.1214 20.1815C16.222 20.2483 16.2919 20.3525 16.3162 20.4713L17.6305 26.9731C18.0651 29.1223 17.1152 30.3805 16.2419 31.0579C15.3233 31.7705 14.3125 31.982 14.2698 31.9908C14.2403 31.997 14.2099 31.9999 14.1797 31.9999ZM12.6507 21.6829L14.5275 30.9667C15.4078 30.6513 17.2485 29.6776 16.7385 27.155L15.5148 21.1003L12.6507 21.6829Z"
                fill="#333333"
            />
            <path
                d="M37.4685 15.8666C37.391 15.8666 37.3138 15.8469 37.2439 15.8073L35.3604 14.7377L33.4141 15.6879C33.2585 15.7639 33.0731 15.7446 32.9359 15.6384C32.7991 15.5319 32.7344 15.3567 32.7692 15.1863L33.2012 13.0585L31.6988 11.4955C31.5786 11.3702 31.5394 11.1877 31.5982 11.024C31.6567 10.8603 31.8026 10.7445 31.9752 10.7248L34.126 10.4796L35.1437 8.56331C35.223 8.41429 35.3777 8.32129 35.5453 8.32129C35.5502 8.32129 35.5549 8.32129 35.5596 8.32158C35.7327 8.32716 35.888 8.43042 35.9597 8.58884L36.8567 10.5649L38.9878 10.944C39.1586 10.9745 39.2972 11.0991 39.3455 11.2661C39.394 11.433 39.3437 11.6128 39.2162 11.7305L37.62 13.1967L37.9192 15.3473C37.9432 15.5193 37.8677 15.6903 37.7244 15.788C37.6475 15.8399 37.558 15.8666 37.4685 15.8666ZM35.3765 13.7655C35.454 13.7655 35.5315 13.7852 35.6008 13.8248L36.89 14.557L36.6853 13.0849C36.6645 12.9362 36.718 12.7866 36.8286 12.6851L37.9209 11.6815L36.4624 11.4221C36.3147 11.396 36.1896 11.2986 36.1273 11.1619L35.5131 9.80923L34.8165 11.1211C34.746 11.2537 34.6152 11.3429 34.4661 11.3599L32.9941 11.528L34.0224 12.5976C34.1262 12.7059 34.1707 12.8584 34.1406 13.0057L33.8449 14.4623L35.1774 13.8119C35.2402 13.7808 35.3087 13.7655 35.3765 13.7655Z"
                fill="#15C9E2"
            />
            <path
                d="M33.1524 7.74919C33.0761 7.74919 32.9998 7.73012 32.9304 7.6914L31.9062 7.11758L30.8543 7.6386C30.6993 7.71546 30.5138 7.69727 30.3761 7.59166C30.2383 7.48605 30.1728 7.3112 30.2065 7.14076L30.4337 5.98637L29.6148 5.14413C29.4937 5.01974 29.4537 4.83727 29.5113 4.67328C29.5689 4.50929 29.7143 4.39253 29.8862 4.372L31.0508 4.23235L31.5962 3.19062C31.6767 3.0369 31.8361 2.94068 32.0109 2.94654C32.1841 2.95094 32.3397 3.05362 32.4125 3.21116L32.905 4.27929L34.0611 4.4779C34.2319 4.50753 34.3714 4.63133 34.4205 4.79796C34.4702 4.9643 34.4208 5.14471 34.2936 5.26265L33.4335 6.06235L33.6022 7.22671C33.6271 7.39862 33.5528 7.56995 33.4101 7.66852C33.3329 7.7222 33.2425 7.74919 33.1524 7.74919ZM31.9191 6.14538C31.996 6.14538 32.0721 6.16474 32.1414 6.20317L32.5693 6.44285L32.4985 5.95616C32.4771 5.80742 32.5298 5.65751 32.6397 5.55542L32.9992 5.22128L32.5163 5.13826C32.3686 5.11303 32.2426 5.01622 32.18 4.87981L31.9744 4.4336L31.7466 4.86895C31.677 5.00185 31.5462 5.09191 31.3977 5.1098L30.9113 5.16818L31.2532 5.51993C31.3579 5.62759 31.4032 5.77985 31.374 5.92711L31.2789 6.4097L31.7185 6.19202C31.7814 6.16122 31.8504 6.14538 31.9191 6.14538Z"
                fill="#F7506F"
            />
            <path
                d="M8.70013 13.0219C6.03143 14.1161 4.7522 17.1732 5.84308 19.8505C6.93367 22.5274 9.98169 23.8103 12.6501 22.716L14.9129 21.7884L10.9629 12.0942L8.70013 13.0219Z"
                fill="#C4C4C4"
            />
            <path
                d="M10.6774 23.5633C10.6772 23.5633 10.6772 23.5633 10.6774 23.5633C8.36086 23.5633 6.29814 22.1737 5.42193 20.023C4.23805 17.1176 5.63133 13.7873 8.52815 12.5995L10.7909 11.6719C11.0237 11.5762 11.2896 11.6883 11.3843 11.9218L15.3346 21.6157C15.4299 21.8492 15.3182 22.1156 15.0854 22.2109L12.8226 23.1388C12.1354 23.4208 11.4136 23.5633 10.6774 23.5633ZM10.7137 12.6895L8.87209 13.4444C6.44028 14.4418 5.27014 17.2378 6.26421 19.6774C7.00005 21.4834 8.732 22.6501 10.6769 22.6501C11.2942 22.6501 11.9005 22.5304 12.4778 22.2937L14.3195 21.5385L10.7137 12.6895Z"
                fill="#333333"
            />
            <path
                d="M10.9629 12.094L12.9382 16.9409L14.9132 21.7879C22.363 19.372 28.2318 19.3104 28.2318 19.3104L25.2154 11.9074L22.1986 4.50439C22.1986 4.50439 17.9667 8.5839 10.9629 12.094Z"
                fill="white"
            />
            <path
                d="M14.9131 22.2452C14.733 22.2452 14.5633 22.1369 14.492 21.9612L10.5417 12.2673C10.4516 12.0464 10.5467 11.7929 10.7596 11.6861C17.6222 8.24674 21.8412 4.21622 21.8831 4.17574C21.9918 4.07101 22.1454 4.02671 22.2925 4.05839C22.4399 4.08949 22.5624 4.19246 22.6195 4.3324L28.6526 19.1384C28.7094 19.2787 28.6942 19.4377 28.6105 19.5635C28.5269 19.6894 28.3868 19.7659 28.2362 19.7677C28.1783 19.7683 22.3428 19.8589 15.0529 22.2229C15.0067 22.2378 14.9596 22.2452 14.9131 22.2452ZM11.5434 12.3122L15.1755 21.2254C20.9937 19.3907 25.8503 18.9739 27.5644 18.8809L22.0226 5.28084C20.734 6.4188 16.977 9.53373 11.5434 12.3122Z"
                fill="#333333"
            />
            <path
                d="M30.9919 18.1586C31.3039 18.9251 30.9375 19.8008 30.1736 20.1138C29.4097 20.4271 28.5367 20.0596 28.2243 19.2933L22.2058 4.52332C21.8934 3.75676 22.2596 2.88137 23.0238 2.56806C23.7877 2.25445 24.6607 2.62204 24.9727 3.3883L30.9919 18.1586Z"
                fill="#C4C4C4"
            />
            <path
                d="M29.6077 20.6825C28.812 20.6825 28.1033 20.205 27.8024 19.4663L21.7838 4.6963C21.5867 4.21284 21.5891 3.68097 21.7906 3.19927C21.9921 2.71727 22.3688 2.34324 22.8507 2.1458C23.0867 2.04899 23.3348 2 23.588 2C24.3838 2 25.0927 2.4773 25.3937 3.21628L31.4119 17.9865C31.6091 18.47 31.6067 19.0016 31.4052 19.4836C31.2037 19.9653 30.827 20.3393 30.345 20.537C30.1093 20.6333 29.8613 20.6825 29.6077 20.6825ZM23.5883 2.91295C23.4538 2.91295 23.3216 2.93906 23.1955 2.99098C22.9382 3.0963 22.7378 3.29579 22.6302 3.55277C22.5229 3.80946 22.5214 4.09315 22.6267 4.35101L28.6453 19.121C28.8058 19.5153 29.1834 19.7696 29.6077 19.7696C29.7426 19.7696 29.8745 19.7432 30.0008 19.6916C30.2579 19.5862 30.4582 19.3868 30.5661 19.1301C30.6738 18.8728 30.6749 18.5897 30.5699 18.3318L24.5517 3.56157C24.3908 3.16759 24.013 2.91295 23.5883 2.91295Z"
                fill="#333333"
            />
        </svg>
    );
};

export const RouletteIcon = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="45"
            height="34"
            viewBox="0 0 45 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M37.1042 8.07137C37.1042 8.07107 37.1036 8.07077 37.1036 8.07046L31.8754 4.49416L28.2295 2H7V32H37.3171V8.21704L37.1042 8.07137ZM28.5691 3.42203L32.8363 6.34103L35.2384 7.98458H28.5694L28.5691 3.42203ZM7.98436 31.0195V2.98079H27.5847V8.47468C27.5847 8.74567 27.8049 8.96507 28.0766 8.96507H36.3324V31.0195H7.98436Z"
                fill="#333333"
            />
            <circle
                cx="21.9999"
                cy="19.0009"
                r="8.78454"
                fill="#C7FBFF"
            />
            <path
                d="M21.9999 10.2158C23.5419 10.2158 25.0567 10.6217 26.3921 11.3927C27.7276 12.1637 28.8365 13.2727 29.6075 14.6081L21.9999 19.0004V10.2158Z"
                fill="#15C9E2"
            />
            <path
                d="M29.6077 23.3923C28.8367 24.7277 27.7278 25.8367 26.3924 26.6077C25.0569 27.3787 23.5421 27.7846 22.0001 27.7846L22.0001 19L29.6077 23.3923Z"
                fill="#15C9E2"
            />
            <path
                d="M14.3919 23.3924C13.6209 22.0569 13.215 20.5421 13.215 19.0001C13.215 17.4581 13.6209 15.9432 14.3919 14.6078L21.9995 19.0001L14.3919 23.3924Z"
                fill="#15C9E2"
            />
            <g filter="url(#filter0_d_4406_10877)">
                <path
                    d="M24.9403 9.04566C24.9403 10.8514 23.2506 12.1363 22.433 12.6524C22.166 12.821 21.8339 12.821 21.5669 12.6524C20.7492 12.1363 19.0596 10.8514 19.0596 9.04566C19.0596 7.21826 20.4843 6 21.9999 6C23.5681 6 24.9403 7.21826 24.9403 9.04566Z"
                    fill="#F7506F"
                />
            </g>
            <circle
                cx="22"
                cy="8.30172"
                r="0.767055"
                fill="white"
            />
            <defs>
                <filter
                    id="filter0_d_4406_10877"
                    x="16.0596"
                    y="3"
                    width="13.8809"
                    height="14.7788"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset
                        dx="1"
                        dy="1"
                    />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                        in2="hardAlpha"
                        operator="out"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_4406_10877"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_4406_10877"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const CuriousCommon = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="18"
                fill="#15C9E2"
                fillOpacity="0.1"
            />
            <path
                d="M8 8L16.8235 17.1176L28 28H8V8Z"
                fill="#7E2CF5"
            />
            <path
                d="M28 8L19.1765 17.1176L8 28H28V8Z"
                fill="#16D7B4"
                fillOpacity="0.7"
            />
        </svg>
    );
};

export const CuriousLogin = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="18"
                fill="#FFBC11"
                fillOpacity="0.1"
            />
            <path
                d="M8 8C14.6274 8 20 13.3726 20 20V28H8V8Z"
                fill="#FF4A6B"
            />
            <path
                d="M16 8H28V28C21.3726 28 16 22.6274 16 16V8Z"
                fill="#7E2CF5"
                fillOpacity="0.7"
            />
        </svg>
    );
};

export const CuriousChallenges = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="18"
                fill="#FF4A6B"
                fillOpacity="0.1"
            />
            <path
                d="M26.6603 23C26.0036 24.1373 25.1295 25.1341 24.0876 25.9335C23.0458 26.733 21.8567 27.3194 20.5882 27.6593C19.3197 27.9991 17.9967 28.0859 16.6947 27.9144C15.3928 27.743 14.1373 27.3169 13 26.6603C11.8627 26.0036 10.8659 25.1295 10.0665 24.0876C9.26703 23.0458 8.68063 21.8567 8.34074 20.5882C8.00086 19.3197 7.91414 17.9967 8.08555 16.6947C8.25696 15.3928 8.68314 14.1373 9.33975 13L18 18L26.6603 23Z"
                fill="#16D7B4"
            />
            <path
                d="M9.33975 23C8.01366 20.7032 7.65431 17.9736 8.34074 15.4118C9.02717 12.85 10.7032 10.6658 13 9.33975C15.2968 8.01366 18.0264 7.65431 20.5882 8.34074C23.15 9.02717 25.3342 10.7032 26.6603 13L18 18L9.33975 23Z"
                fill="#E42044"
                fillOpacity="0.7"
            />
        </svg>
    );
};

export const CuriousCancellation = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="18"
                fill="#7E2CF5"
                fillOpacity="0.1"
            />
            <path
                d="M21 21H28V28H21V21Z"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <path
                d="M23 21L23 28L8 28L8 21L23 21Z"
                fill="#FF5E18"
                fillOpacity="0.7"
            />
            <path
                d="M8 8H15V23H8V8Z"
                fill="#E42044"
                fillOpacity="0.7"
            />
            <path
                d="M28 8L28 15L15 15L15 8L28 8Z"
                fill="#FFBC11"
            />
            <path
                d="M21 13H28V21H21V13Z"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <rect
                x="13"
                y="8"
                width="2"
                height="7"
                fill="#FFBC11"
                fillOpacity="0.7"
            />
        </svg>
    );
};

export const CuriousExchange = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="18"
                fill="#FF5E18"
                fillOpacity="0.1"
            />
            <circle
                cx="15.5"
                cy="15.5"
                r="7.5"
                fill="#FFBC11"
            />
            <circle
                cx="20.5"
                cy="20.5"
                r="7.5"
                fill="#AF2DFF"
                fillOpacity="0.7"
            />
        </svg>
    );
};

export const WrapperUSerIconType = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <circle
                cx="10"
                cy="10"
                r="10"
                fill="white"
            />
        </svg>
    );
};
export const AttendanceIconSmile = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.3789 2.01386C12.9756 1.34258 14.0244 1.34258 14.6211 2.01386L15.441 2.93627C16.042 3.61238 16.9614 3.91109 17.845 3.71736L19.0505 3.45305C19.9278 3.2607 20.7763 3.8772 20.8645 4.771L20.9856 5.99919C21.0744 6.89942 21.6426 7.68146 22.4714 8.0441L23.602 8.53885C24.4248 8.8989 24.7489 9.89642 24.2949 10.6713L23.671 11.7362C23.2137 12.5167 23.2137 13.4833 23.671 14.2638L24.2949 15.3287C24.7489 16.1036 24.4248 17.1011 23.602 17.4611L22.4714 17.9559C21.6426 18.3185 21.0744 19.1006 20.9856 20.0008L20.8645 21.229C20.7763 22.1228 19.9278 22.7393 19.0505 22.5469L17.845 22.2826C16.9614 22.0889 16.042 22.3876 15.441 23.0637L14.6211 23.9861C14.0244 24.6574 12.9756 24.6574 12.3789 23.9861L11.559 23.0637C10.958 22.3876 10.0386 22.0889 9.15503 22.2826L7.94951 22.5469C7.07221 22.7393 6.22367 22.1228 6.13551 21.229L6.01436 20.0008C5.92556 19.1006 5.35737 18.3185 4.52864 17.9559L3.398 17.4611C2.5752 17.1011 2.25108 16.1036 2.70511 15.3287L3.32901 14.2638C3.78632 13.4833 3.78632 12.5167 3.32901 11.7362L2.70511 10.6713C2.25108 9.89642 2.5752 8.8989 3.398 8.53885L4.52864 8.0441C5.35737 7.68146 5.92556 6.89942 6.01436 5.99919L6.13551 4.771C6.22367 3.8772 7.07221 3.2607 7.94951 3.45305L9.15502 3.71736C10.0386 3.91109 10.958 3.61238 11.559 2.93627L12.3789 2.01386Z"
                fill="#FDD000"
                stroke="black"
            />
            <circle
                cx="10"
                cy="10"
                r="1"
                fill="black"
            />
            <circle
                cx="17"
                cy="10"
                r="1"
                fill="black"
            />
            <path
                d="M16 13C15.0625 13.8229 13.0312 14.7633 11 13"
                stroke="black"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const AttendanceIconSmileWithOutChecked = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.3789 2.01386C12.9756 1.34258 14.0244 1.34258 14.6211 2.01386L15.441 2.93627C16.042 3.61238 16.9614 3.91109 17.845 3.71736L19.0505 3.45305C19.9278 3.2607 20.7763 3.8772 20.8645 4.771L20.9856 5.99919C21.0744 6.89942 21.6426 7.68146 22.4714 8.0441L23.602 8.53885C24.4248 8.8989 24.7489 9.89642 24.2949 10.6713L23.671 11.7362C23.2137 12.5167 23.2137 13.4833 23.671 14.2638L24.2949 15.3287C24.7489 16.1036 24.4248 17.1011 23.602 17.4611L22.4714 17.9559C21.6426 18.3185 21.0744 19.1006 20.9856 20.0008L20.8645 21.229C20.7763 22.1228 19.9278 22.7393 19.0505 22.5469L17.845 22.2826C16.9614 22.0889 16.042 22.3876 15.441 23.0637L14.6211 23.9861C14.0244 24.6574 12.9756 24.6574 12.3789 23.9861L11.559 23.0637C10.958 22.3876 10.0386 22.0889 9.15503 22.2826L7.94951 22.5469C7.07221 22.7393 6.22367 22.1228 6.13551 21.229L6.01436 20.0008C5.92556 19.1006 5.35737 18.3185 4.52864 17.9559L3.398 17.4611C2.5752 17.1011 2.25108 16.1036 2.70511 15.3287L3.32901 14.2638C3.78632 13.4833 3.78632 12.5167 3.32901 11.7362L2.70511 10.6713C2.25108 9.89642 2.5752 8.8989 3.398 8.53885L4.52864 8.0441C5.35737 7.68146 5.92556 6.89942 6.01436 5.99919L6.13551 4.771C6.22367 3.8772 7.07221 3.2607 7.94951 3.45305L9.15502 3.71736C10.0386 3.91109 10.958 3.61238 11.559 2.93627L12.3789 2.01386Z"
                fill="#EEEEEE"
                stroke="#BBBBBB"
            />
            <circle
                cx="10"
                cy="10"
                r="1"
                fill="#BBBBBB"
            />
            <circle
                cx="17"
                cy="10"
                r="1"
                fill="#BBBBBB"
            />
            <path
                d="M16 13C15.0625 13.8229 13.0312 14.7633 11 13"
                stroke="#BBBBBB"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const AttendanceIconSad = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.3789 2.01386C12.9756 1.34258 14.0244 1.34258 14.6211 2.01386L15.441 2.93627C16.042 3.61238 16.9614 3.91109 17.845 3.71736L19.0505 3.45305C19.9278 3.2607 20.7763 3.8772 20.8645 4.771L20.9856 5.99919C21.0744 6.89942 21.6426 7.68146 22.4714 8.0441L23.602 8.53885C24.4248 8.8989 24.7489 9.89642 24.2949 10.6713L23.671 11.7362C23.2137 12.5167 23.2137 13.4833 23.671 14.2638L24.2949 15.3287C24.7489 16.1036 24.4248 17.1011 23.602 17.4611L22.4714 17.9559C21.6426 18.3185 21.0744 19.1006 20.9856 20.0008L20.8645 21.229C20.7763 22.1228 19.9278 22.7393 19.0505 22.5469L17.845 22.2826C16.9614 22.0889 16.042 22.3876 15.441 23.0637L14.6211 23.9861C14.0244 24.6574 12.9756 24.6574 12.3789 23.9861L11.559 23.0637C10.958 22.3876 10.0386 22.0889 9.15503 22.2826L7.94951 22.5469C7.07221 22.7393 6.22367 22.1228 6.13551 21.229L6.01436 20.0008C5.92556 19.1006 5.35737 18.3185 4.52864 17.9559L3.398 17.4611C2.5752 17.1011 2.25108 16.1036 2.70511 15.3287L3.32901 14.2638C3.78632 13.4833 3.78632 12.5167 3.32901 11.7362L2.70511 10.6713C2.25108 9.89642 2.5752 8.8989 3.398 8.53885L4.52864 8.0441C5.35737 7.68146 5.92556 6.89942 6.01436 5.99919L6.13551 4.771C6.22367 3.8772 7.07221 3.2607 7.94951 3.45305L9.15502 3.71736C10.0386 3.91109 10.958 3.61238 11.559 2.93627L12.3789 2.01386Z"
                fill="#EEEEEE"
                stroke="#BBBBBB"
            />
            <circle
                cx="10"
                cy="10"
                r="1"
                fill="#BBBBBB"
            />
            <circle
                cx="17"
                cy="10"
                r="1"
                fill="#BBBBBB"
            />
            <path
                d="M16 14C15.0625 13.1771 13.0312 12.2367 11 14"
                stroke="#BBBBBB"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const AttendanceIconChecked = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.3789 2.01386C12.9756 1.34258 14.0244 1.34258 14.6211 2.01386L15.441 2.93627C16.042 3.61238 16.9614 3.91109 17.845 3.71736L19.0505 3.45305C19.9278 3.2607 20.7763 3.8772 20.8645 4.771L20.9856 5.99919C21.0744 6.89942 21.6426 7.68146 22.4714 8.0441L23.602 8.53885C24.4248 8.8989 24.7489 9.89642 24.2949 10.6713L23.671 11.7362C23.2137 12.5167 23.2137 13.4833 23.671 14.2638L24.2949 15.3287C24.7489 16.1036 24.4248 17.1011 23.602 17.4611L22.4714 17.9559C21.6426 18.3185 21.0744 19.1006 20.9856 20.0008L20.8645 21.229C20.7763 22.1228 19.9278 22.7393 19.0505 22.5469L17.845 22.2826C16.9614 22.0889 16.042 22.3876 15.441 23.0637L14.6211 23.9861C14.0244 24.6574 12.9756 24.6574 12.3789 23.9861L11.559 23.0637C10.958 22.3876 10.0386 22.0889 9.15503 22.2826L7.94951 22.5469C7.07221 22.7393 6.22367 22.1228 6.13551 21.229L6.01436 20.0008C5.92556 19.1006 5.35737 18.3185 4.52864 17.9559L3.398 17.4611C2.5752 17.1011 2.25108 16.1036 2.70511 15.3287L3.32901 14.2638C3.78632 13.4833 3.78632 12.5167 3.32901 11.7362L2.70511 10.6713C2.25108 9.89642 2.5752 8.8989 3.398 8.53885L4.52864 8.0441C5.35737 7.68146 5.92556 6.89942 6.01436 5.99919L6.13551 4.771C6.22367 3.8772 7.07221 3.2607 7.94951 3.45305L9.15502 3.71736C10.0386 3.91109 10.958 3.61238 11.559 2.93627L12.3789 2.01386Z"
                fill="#2073F6"
                stroke="black"
            />
            <path
                d="M9.5 13L12.1667 16L17.5 10"
                stroke="white"
                strokeWidth="3"
            />
        </svg>
    );
};
export const AttendancePointIconBlue = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="path-1-inside-1_3_8676"
                fill="white"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 2H12.5H13.5C18.4706 2 22.5 6.02944 22.5 11C22.5 15.9706 18.4706 20 13.5 20C13.162 20 12.8283 19.9814 12.5 19.9451V24H4.5V11V2ZM13.5 12.4994C14.3284 12.4994 15 11.8278 15 10.9994C15 10.171 14.3284 9.49938 13.5 9.49938C12.6716 9.49938 12 10.171 12 10.9994C12 11.8278 12.6716 12.4994 13.5 12.4994Z"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 2H12.5H13.5C18.4706 2 22.5 6.02944 22.5 11C22.5 15.9706 18.4706 20 13.5 20C13.162 20 12.8283 19.9814 12.5 19.9451V24H4.5V11V2ZM13.5 12.4994C14.3284 12.4994 15 11.8278 15 10.9994C15 10.171 14.3284 9.49938 13.5 9.49938C12.6716 9.49938 12 10.171 12 10.9994C12 11.8278 12.6716 12.4994 13.5 12.4994Z"
                fill="#2073F6"
            />
            <path
                d="M4.5 2V1H3.5V2H4.5ZM12.5 19.9451L12.6099 18.9511L11.5 18.8284V19.9451H12.5ZM12.5 24V25H13.5V24H12.5ZM4.5 24H3.5V25H4.5V24ZM12.5 1H4.5V3H12.5V1ZM13.5 1H12.5V3H13.5V1ZM23.5 11C23.5 5.47715 19.0228 1 13.5 1V3C17.9183 3 21.5 6.58172 21.5 11H23.5ZM13.5 21C19.0228 21 23.5 16.5228 23.5 11H21.5C21.5 15.4183 17.9183 19 13.5 19V21ZM12.3901 20.939C12.7549 20.9793 13.1252 21 13.5 21V19C13.1988 19 12.9018 18.9834 12.6099 18.9511L12.3901 20.939ZM13.5 24V19.9451H11.5V24H13.5ZM4.5 25H12.5V23H4.5V25ZM3.5 11V24H5.5V11H3.5ZM3.5 2V11H5.5V2H3.5ZM14 10.9994C14 11.2755 13.7761 11.4994 13.5 11.4994V13.4994C14.8807 13.4994 16 12.3801 16 10.9994H14ZM13.5 10.4994C13.7761 10.4994 14 10.7232 14 10.9994H16C16 9.61867 14.8807 8.49938 13.5 8.49938V10.4994ZM13 10.9994C13 10.7232 13.2238 10.4994 13.5 10.4994V8.49938C12.1193 8.49938 11 9.61867 11 10.9994H13ZM13.5 11.4994C13.2238 11.4994 13 11.2755 13 10.9994H11C11 12.3801 12.1193 13.4994 13.5 13.4994V11.4994Z"
                fill="black"
                mask="url(#path-1-inside-1_3_8676)"
            />
        </svg>
    );
};

export const AttendancePointIconYellow = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="path-1-inside-1_3_8705"
                fill="white"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 2H12.5H13.5C18.4706 2 22.5 6.02944 22.5 11C22.5 15.9706 18.4706 20 13.5 20C13.162 20 12.8283 19.9814 12.5 19.9451V24H4.5V11V2ZM13.5 12.4994C14.3284 12.4994 15 11.8278 15 10.9994C15 10.171 14.3284 9.49938 13.5 9.49938C12.6716 9.49938 12 10.171 12 10.9994C12 11.8278 12.6716 12.4994 13.5 12.4994Z"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 2H12.5H13.5C18.4706 2 22.5 6.02944 22.5 11C22.5 15.9706 18.4706 20 13.5 20C13.162 20 12.8283 19.9814 12.5 19.9451V24H4.5V11V2ZM13.5 12.4994C14.3284 12.4994 15 11.8278 15 10.9994C15 10.171 14.3284 9.49938 13.5 9.49938C12.6716 9.49938 12 10.171 12 10.9994C12 11.8278 12.6716 12.4994 13.5 12.4994Z"
                fill="#FDD000"
            />
            <path
                d="M4.5 2V1H3.5V2H4.5ZM12.5 19.9451L12.6099 18.9511L11.5 18.8284V19.9451H12.5ZM12.5 24V25H13.5V24H12.5ZM4.5 24H3.5V25H4.5V24ZM12.5 1H4.5V3H12.5V1ZM13.5 1H12.5V3H13.5V1ZM23.5 11C23.5 5.47715 19.0228 1 13.5 1V3C17.9183 3 21.5 6.58172 21.5 11H23.5ZM13.5 21C19.0228 21 23.5 16.5228 23.5 11H21.5C21.5 15.4183 17.9183 19 13.5 19V21ZM12.3901 20.939C12.7549 20.9793 13.1252 21 13.5 21V19C13.1988 19 12.9018 18.9834 12.6099 18.9511L12.3901 20.939ZM13.5 24V19.9451H11.5V24H13.5ZM4.5 25H12.5V23H4.5V25ZM3.5 11V24H5.5V11H3.5ZM3.5 2V11H5.5V2H3.5ZM14 10.9994C14 11.2755 13.7761 11.4994 13.5 11.4994V13.4994C14.8807 13.4994 16 12.3801 16 10.9994H14ZM13.5 10.4994C13.7761 10.4994 14 10.7232 14 10.9994H16C16 9.61867 14.8807 8.49938 13.5 8.49938V10.4994ZM13 10.9994C13 10.7232 13.2238 10.4994 13.5 10.4994V8.49938C12.1193 8.49938 11 9.61867 11 10.9994H13ZM13.5 11.4994C13.2238 11.4994 13 11.2755 13 10.9994H11C11 12.3801 12.1193 13.4994 13.5 13.4994V11.4994Z"
                fill="black"
                mask="url(#path-1-inside-1_3_8705)"
            />
        </svg>
    );
};
export const AttendancePointIconNotActive = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
        >
            <mask
                id="path-1-inside-1_3_8648"
                fill="white"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 2H12.5H13.5C18.4706 2 22.5 6.02944 22.5 11C22.5 15.9706 18.4706 20 13.5 20C13.162 20 12.8283 19.9814 12.5 19.9451V24H4.5V11V2ZM13.5 12.4994C14.3284 12.4994 15 11.8278 15 10.9994C15 10.171 14.3284 9.49938 13.5 9.49938C12.6716 9.49938 12 10.171 12 10.9994C12 11.8278 12.6716 12.4994 13.5 12.4994Z"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 2H12.5H13.5C18.4706 2 22.5 6.02944 22.5 11C22.5 15.9706 18.4706 20 13.5 20C13.162 20 12.8283 19.9814 12.5 19.9451V24H4.5V11V2ZM13.5 12.4994C14.3284 12.4994 15 11.8278 15 10.9994C15 10.171 14.3284 9.49938 13.5 9.49938C12.6716 9.49938 12 10.171 12 10.9994C12 11.8278 12.6716 12.4994 13.5 12.4994Z"
                fill="#EEEEEE"
            />
            <path
                d="M4.5 2V1H3.5V2H4.5ZM12.5 19.9451L12.6099 18.9511L11.5 18.8284V19.9451H12.5ZM12.5 24V25H13.5V24H12.5ZM4.5 24H3.5V25H4.5V24ZM12.5 1H4.5V3H12.5V1ZM13.5 1H12.5V3H13.5V1ZM23.5 11C23.5 5.47715 19.0228 1 13.5 1V3C17.9183 3 21.5 6.58172 21.5 11H23.5ZM13.5 21C19.0228 21 23.5 16.5228 23.5 11H21.5C21.5 15.4183 17.9183 19 13.5 19V21ZM12.3901 20.939C12.7549 20.9793 13.1252 21 13.5 21V19C13.1988 19 12.9018 18.9834 12.6099 18.9511L12.3901 20.939ZM13.5 24V19.9451H11.5V24H13.5ZM4.5 25H12.5V23H4.5V25ZM3.5 11V24H5.5V11H3.5ZM3.5 2V11H5.5V2H3.5ZM14 10.9994C14 11.2755 13.7761 11.4994 13.5 11.4994V13.4994C14.8807 13.4994 16 12.3801 16 10.9994H14ZM13.5 10.4994C13.7761 10.4994 14 10.7232 14 10.9994H16C16 9.61867 14.8807 8.49938 13.5 8.49938V10.4994ZM13 10.9994C13 10.7232 13.2238 10.4994 13.5 10.4994V8.49938C12.1193 8.49938 11 9.61867 11 10.9994H13ZM13.5 11.4994C13.2238 11.4994 13 11.2755 13 10.9994H11C11 12.3801 12.1193 13.4994 13.5 13.4994V11.4994Z"
                fill="#BBBBBB"
                mask="url(#path-1-inside-1_3_8648)"
            />
        </svg>
    );
};

export const GiftPointIcon = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="23.4906"
                cy="22.51"
                r="15.9782"
                transform="rotate(-30 23.4906 22.51)"
                fill="white"
                stroke="#0059E5"
            />
            <circle
                cx="23.4908"
                cy="22.5104"
                r="13.7811"
                transform="rotate(-30 23.4908 22.5104)"
                fill="white"
                stroke="#0059E5"
            />
            <path
                d="M17.0092 31.9829L16.2952 30.7462C17.3674 27.3952 17.9379 24.8834 17.1819 23.574C16.7059 22.7495 15.9862 22.5669 15.2708 22.9799C14.6525 23.3369 14.4055 24.0291 14.2472 24.7349L12.3991 24.2499C12.7452 22.8053 13.3036 21.8686 14.5888 21.1266C16.3347 20.1186 18.1912 20.5341 19.1852 22.2557C20.0812 23.8076 19.7345 26.2872 19.1573 28.4795C19.5709 28.1599 20.1543 27.7422 20.5544 27.5112L22.2154 26.5522L23.2654 28.3709L17.0092 31.9829ZM25.6198 23.0024L24.2898 20.6988L23.3563 21.2378L24.6863 23.5414L25.6198 23.0024ZM23.4218 19.1954L22.0148 16.7584L23.8214 15.7154L28.3154 23.4992L23.7445 26.1382L19.2505 18.3544L21.0813 17.2974L22.4883 19.7344L23.4218 19.1954ZM26.3825 12.9273L28.2375 11.8563L34.8035 23.2289L32.9485 24.2999L29.7355 18.7349L29.0807 19.1129L32.0207 24.2051L30.2021 25.2551L24.0001 14.5129L25.8187 13.4629L28.1847 17.561L28.8395 17.183L26.3825 12.9273Z"
                fill="#0059E5"
            />
        </svg>
    );
};

export const ActiveWheelIcon = ({ width = 36, height = 36, color = 'none' }: { width?: number | string; color?: string; height?: number | string }) => {
    return (
        <svg
            className="active"
            width="55"
            height="63"
            viewBox="0 0 55 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_3_8811)">
                <path
                    d="M49.5005 26.9827C49.5005 44.1027 30.0845 55.2376 26.9309 56.9332C26.6528 57.0827 26.3482 57.0827 26.0701 56.9332C22.9165 55.2376 3.50049 44.1027 3.50049 26.9827C3.50049 12.6886 14.6448 3.15918 26.5005 3.15918C38.7672 3.15918 49.5005 12.6886 49.5005 26.9827Z"
                    fill="#63FFF6"
                />
            </g>
            <circle
                cx="26.5005"
                cy="21.1592"
                r="6"
                fill="white"
            />
            <defs>
                <filter
                    id="filter0_d_3_8811"
                    x="0.500488"
                    y="0.15918"
                    width="54"
                    height="61.8857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset
                        dx="1"
                        dy="1"
                    />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                        in2="hardAlpha"
                        operator="out"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_3_8811"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_3_8811"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};
export const ButtonStartWheel = () => {
    return (
        <svg
            width="109"
            height="110"
            viewBox="0 0 109 110"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_3_8807)">
                <circle
                    cx="53.5005"
                    cy="54.6592"
                    r="50.5"
                    fill="#EEEEEE"
                />
            </g>
            <g filter="url(#filter1_d_3_8807)">
                <circle
                    cx="53.5005"
                    cy="54.6592"
                    r="41.5"
                    fill="white"
                />
            </g>
            <path
                d="M31.7065 62.4112C29.9605 62.4112 28.0885 61.7632 26.7025 60.4852L28.5205 58.2712C29.4745 59.0812 30.7165 59.6392 31.7785 59.6392C32.9665 59.6392 33.5245 59.1892 33.5245 58.4692C33.5245 57.6952 32.7865 57.4432 31.6345 56.9572L29.9245 56.2372C28.5205 55.6792 27.2065 54.5092 27.2065 52.5652C27.2065 50.3152 29.2225 48.5152 32.0665 48.5152C33.6145 48.5152 35.2525 49.1092 36.4225 50.2792L34.8205 52.2952C33.9385 51.6292 33.1105 51.2692 32.0665 51.2692C31.0765 51.2692 30.4645 51.6652 30.4645 52.3852C30.4645 53.1232 31.3105 53.4112 32.4985 53.8792L34.1725 54.5452C35.8285 55.2112 36.8185 56.3272 36.8185 58.2172C36.8185 60.4492 34.9465 62.4112 31.7065 62.4112ZM41.2147 62.1592V51.4312H37.5967V48.7672H48.0727V51.4312H44.4367V62.1592H41.2147ZM52.2802 56.5972H55.0162L54.7282 55.4632C54.3682 54.1312 54.0262 52.5292 53.6662 51.1612H53.5942C53.2702 52.5652 52.9102 54.1312 52.5682 55.4632L52.2802 56.5972ZM56.4022 62.1592L55.6282 59.0812H51.6682L50.8942 62.1592H47.6182L51.7762 48.7672H55.6282L59.7862 62.1592H56.4022ZM64.415 51.3052V54.9052H65.855C67.385 54.9052 68.195 54.2392 68.195 52.9792C68.195 51.7192 67.385 51.3052 65.855 51.3052H64.415ZM72.029 62.1592H68.429L65.963 57.4432H64.415V62.1592H61.193V48.7672H66.107C68.969 48.7672 71.345 49.7392 71.345 52.9792C71.345 54.9412 70.427 56.2012 69.041 56.8492L72.029 62.1592ZM76.1249 62.1592V51.4312H72.5069V48.7672H82.9829V51.4312H79.3469V62.1592H76.1249Z"
                fill="#0059E5"
            />
            <defs>
                <filter
                    id="filter0_d_3_8807"
                    x="0.000488281"
                    y="0.15918"
                    width="109"
                    height="109"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                        in2="hardAlpha"
                        operator="out"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_3_8807"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_3_8807"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_d_3_8807"
                    x="9.00049"
                    y="9.15918"
                    width="91"
                    height="91"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                        in2="hardAlpha"
                        operator="out"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_3_8807"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_3_8807"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const AuthWritingIcon = () => {
    return (
        <svg
            width="36"
            height="14"
            viewBox="0 0 36 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 7C0 3.13401 3.13401 0 7 0H29C32.866 0 36 3.13401 36 7V7C36 10.866 32.866 14 29 14H7C3.13401 14 0 10.866 0 7V7Z"
                fill="#2073F6"
            />
            <path
                d="M10.2712 6.53L9.74117 7.32C8.73117 6.99 8.01117 6.3 7.62117 5.44C7.22117 6.39 6.47117 7.13 5.41117 7.5L4.87117 6.69C6.30117 6.21 7.09117 5.06 7.09117 3.82V3.66H5.17117V2.82H10.0212V3.66H8.13117V3.82C8.13117 4.96 8.89117 6.07 10.2712 6.53ZM6.07117 8.95V8.12H12.0112V11.27H10.9812V8.95H6.07117ZM13.2912 4.54V5.39H12.0112V7.68H10.9812V2.23H12.0112V4.54H13.2912ZM20.3604 7.56V4.88H18.5304V4.04H20.3604V2.23H21.3904V7.56H20.3604ZM19.2704 6.39L18.7204 7.2C17.7504 6.85 17.0504 6.17 16.6604 5.29C16.2604 6.29 15.5004 7.08 14.4104 7.47L13.8704 6.64C15.3204 6.15 16.1104 4.93 16.1104 3.61V2.72H17.1504V3.56C17.1504 4.81 17.9004 5.94 19.2704 6.39ZM18.3804 10.46C19.6604 10.46 20.4004 10.13 20.4004 9.54C20.4004 8.95 19.6604 8.62 18.3804 8.62C17.1004 8.62 16.3704 8.95 16.3704 9.54C16.3704 10.13 17.1004 10.46 18.3804 10.46ZM18.3804 7.81C20.2704 7.81 21.4304 8.45 21.4304 9.54C21.4304 10.63 20.2704 11.27 18.3804 11.27C16.5004 11.27 15.3404 10.63 15.3404 9.54C15.3404 8.45 16.5004 7.81 18.3804 7.81ZM26.0196 3.99V4.86C26.0196 6.26 26.9096 7.86 28.2796 8.51L27.7096 9.32C26.6996 8.84 25.9296 7.84 25.5196 6.7C25.1196 7.96 24.3196 9.04 23.2796 9.55L22.6896 8.73C24.0696 8.07 24.9896 6.36 24.9896 4.86V3.99H23.0196V3.14H27.9296V3.99H26.0196ZM31.2596 5.8V6.65H29.8496V11.27H28.8196V2.24H29.8496V5.8H31.2596Z"
                fill="white"
            />
        </svg>
    );
};

export const StepIconOne = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="#F2F7FF"
            />
            <rect
                x="24"
                y="12"
                width="8"
                height="24"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <circle
                cx="20"
                cy="16"
                r="4"
                fill="#2073F6"
                fillOpacity="0.3"
            />
        </svg>
    );
};

export const StepIconOneActive = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="white"
            />
            <rect
                x="24"
                y="12"
                width="8"
                height="24"
                fill="#AF2DFF"
            />
            <circle
                cx="20"
                cy="16"
                r="4"
                fill="#FDD000"
            />
        </svg>
    );
};

export const StepIconTwo = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="#F2F7FF"
            />
            <path
                d="M24 12C28.4183 12 32 15.5817 32 20H24V12Z"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <path
                d="M24 20H32C32 24.4183 28.4183 28 24 28V20Z"
                fill="#2073F6"
                fillOpacity="0.3"
            />
            <rect
                x="24"
                y="28"
                width="8"
                height="8"
                fill="#2073F6"
                fillOpacity="0.4"
            />
            <path
                d="M16 36C16 31.5817 19.5817 28 24 28V36H16Z"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <circle
                cx="20"
                cy="16"
                r="4"
                fill="#2073F6"
                fillOpacity="0.3"
            />
        </svg>
    );
};

export const StepIconTwoActive = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="white"
            />
            <path
                d="M24 12C28.4183 12 32 15.5817 32 20H24V12Z"
                fill="#AF2DFF"
            />
            <path
                d="M24 20H32C32 24.4183 28.4183 28 24 28V20Z"
                fill="#FF4A6B"
            />
            <rect
                x="24"
                y="28"
                width="8"
                height="8"
                fill="#15C9E2"
            />
            <path
                d="M16 36C16 31.5817 19.5817 28 24 28V36H16Z"
                fill="#7E2CF5"
            />
            <circle
                cx="20"
                cy="16"
                r="4"
                fill="#FDD000"
            />
        </svg>
    );
};

export const StepIconThree = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="#F2F7FF"
            />
            <path
                d="M24 12C28.4183 12 32 15.5817 32 20H24V12Z"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <path
                d="M24 20H32V28H24V20Z"
                fill="#2073F6"
                fillOpacity="0.3"
            />
            <path
                d="M24 28H32C32 32.4183 28.4183 36 24 36V28Z"
                fill="#2073F6"
                fillOpacity="0.4"
            />
            <path
                d="M16 28H24V36C19.5817 36 16 32.4183 16 28Z"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <circle
                cx="20"
                cy="16"
                r="4"
                fill="#2073F6"
                fillOpacity="0.3"
            />
        </svg>
    );
};

export const StepIconThreeActive = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="white"
            />
            <path
                d="M24 12C28.4183 12 32 15.5817 32 20H24V12Z"
                fill="#AF2DFF"
            />
            <path
                d="M24 20H32V28H24V20Z"
                fill="#FF4A6B"
            />
            <path
                d="M24 28H32C32 32.4183 28.4183 36 24 36V28Z"
                fill="#15C9E2"
            />
            <path
                d="M16 28H24V36C19.5817 36 16 32.4183 16 28Z"
                fill="#7E2CF5"
            />
            <circle
                cx="20"
                cy="16"
                r="4"
                fill="#FDD000"
            />
        </svg>
    );
};

export const StepIconFour = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="#F2F7FF"
            />
            <path
                d="M24 12H32V20H24V12Z"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <path
                d="M24 20H32V28H24V20Z"
                fill="#2073F6"
                fillOpacity="0.3"
            />
            <path
                d="M24 28H32C32 32.4183 28.4183 36 24 36V28Z"
                fill="#2073F6"
                fillOpacity="0.4"
            />
            <path
                d="M16 20H24V28C19.5817 28 16 24.4183 16 20Z"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <circle
                cx="20"
                cy="16"
                r="4"
                fill="#2073F6"
                fillOpacity="0.3"
            />
        </svg>
    );
};

export const StepIconFourActive = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="white"
            />
            <path
                d="M24 12H32V20H24V12Z"
                fill="#AF2DFF"
            />
            <path
                d="M24 20H32V28H24V20Z"
                fill="#FF4A6B"
            />
            <path
                d="M24 28H32C32 32.4183 28.4183 36 24 36V28Z"
                fill="#15C9E2"
            />
            <path
                d="M16 20H24V28C19.5817 28 16 24.4183 16 20Z"
                fill="#7E2CF5"
            />
            <circle
                cx="20"
                cy="16"
                r="4"
                fill="#FDD000"
            />
        </svg>
    );
};

export const LineDivider = () => {
    return (
        <svg
            width="100%"
            height="1"
            // viewBox="0 0 full 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.25"
                y="0.25"
                width="100%"
                height="0.5"
                fill="#F9F9F9"
                stroke="#EEEEEE"
                strokeWidth="0.5"
            />
        </svg>
    );
};

export const IconRadioTypeChecked: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="26"
                height="26"
                rx="13"
                fill="black"
            />
            <rect
                x="9"
                y="9"
                width="8"
                height="8"
                rx="4"
                fill="white"
            />
        </svg>
    );
};

export const IconRadioType: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="26"
                height="26"
                rx="13"
                fill="#EEEEEE"
            />
            <rect
                x="9"
                y="9"
                width="8"
                height="8"
                rx="4"
                fill="white"
            />
        </svg>
    );
};
export const CheckedIconRegistration: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="26"
                height="26"
                rx="13"
                fill="black"
            />
            <path
                d="M9 14L12 17L18 10"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CheckedIconRegistrationNotActive: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="26"
                height="26"
                rx="13"
                fill="#EEEEEE"
            />
            <path
                d="M9 14L12 17L18 10"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconPayment: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="30"
                cy="30"
                r="30"
                fill="#2073F6"
                fillOpacity="0.1"
            />
            <path
                d="M16 12.9902C18.2325 12.9902 20.4431 13.4299 22.5056 14.2843C24.5682 15.1386 26.4422 16.3908 28.0208 17.9694C29.5994 19.548 30.8516 21.4221 31.706 23.4846C32.5603 25.5472 33 27.7578 33 29.9902C33 32.2227 32.5603 34.4333 31.706 36.4959C30.8516 38.5584 29.5994 40.4325 28.0208 42.011C26.4422 43.5896 24.5682 44.8419 22.5056 45.6962C20.4431 46.5505 18.2325 46.9902 16 46.9902L16 29.9902L16 12.9902Z"
                fill="#15C9E2"
            />
            <path
                d="M20.9786 42.0101C19.4 40.4315 18.1478 38.5574 17.2934 36.4949C16.4391 34.4323 15.9994 32.2217 15.9994 29.9893C15.9994 27.7568 16.4391 25.5462 17.2934 23.4836C18.1478 21.4211 19.4 19.547 20.9786 17.9684C22.5572 16.3898 24.4312 15.1376 26.4938 14.2833C28.5563 13.429 30.7669 12.9893 32.9994 12.9893C35.2319 12.9893 37.4425 13.429 39.505 14.2833C41.5675 15.1376 43.4416 16.3898 45.0202 17.9684L32.9994 29.9893L20.9786 42.0101Z"
                fill="#7E2CF5"
                fillOpacity="0.7"
            />
            <path
                d="M45.0208 42.0107C43.4422 43.5893 41.5682 44.8415 39.5056 45.6958C37.4431 46.5502 35.2325 46.9899 33 46.9899C30.7675 46.9899 28.5569 46.5502 26.4944 45.6958C24.4318 44.8415 22.5578 43.5893 20.9792 42.0107C19.4006 40.4321 18.1484 38.558 17.294 36.4955C16.4397 34.433 16 32.2223 16 29.9899C16 27.7574 16.4397 25.5468 17.294 23.4843C18.1484 21.4217 19.4006 19.5477 20.9792 17.9691L33 29.9899L45.0208 42.0107Z"
                fill="#FF4A6B"
                fillOpacity="0.7"
            />
            <rect
                x="40"
                y="28"
                width="4"
                height="4"
                rx="2"
                fill="#FF4A6B"
            />
            <rect
                x="46"
                y="29"
                width="2"
                height="2"
                rx="1"
                fill="#FF4A6B"
            />
        </svg>
    );
};

export const IconSubmitSuccess: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="30"
                cy="30"
                r="30"
                fill="#2073F6"
                fillOpacity="0.1"
            />
            <path
                d="M21 19H41V39C29.9543 39 21 30.0457 21 19Z"
                fill="#AF2DFF"
            />
            <path
                d="M18 22H38V42H18V22Z"
                fill="#FF4A6B"
                fillOpacity="0.7"
            />
            <path
                d="M15 25C26.0457 25 35 33.9543 35 45H15V25Z"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <path
                d="M42.8895 13.8891L46.7786 12.8284L41.8289 17.7782L39.0004 14.9497L42.8895 13.8891Z"
                fill="#4C3CFF"
            />
            <path
                d="M46.4244 17.4249L47.485 13.5358L42.5353 18.4856L45.3637 21.314L46.4244 17.4249Z"
                fill="#16D7B4"
            />
        </svg>
    );
};
export const IconLocation: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
        >
            <path
                d="M19.9997 6.66699C13.5526 6.66699 8.33301 11.8866 8.33301 18.3337C8.33301 18.6358 8.34162 18.9385 8.36747 19.232C8.57483 21.9978 9.75006 24.4953 11.5565 26.3793L19.9997 34.8224L28.4514 26.3799C30.2493 24.4958 31.4245 21.9978 31.6319 19.2326C31.6577 18.9391 31.6663 18.6364 31.6663 18.3342C31.6669 11.8866 26.4468 6.66699 19.9997 6.66699Z"
                fill="#F56652"
            />
            <path
                d="M19.9996 23.8254C23.2969 23.8254 25.97 21.1524 25.97 17.8551C25.97 14.5578 23.2969 11.8848 19.9996 11.8848C16.7023 11.8848 14.0293 14.5578 14.0293 17.8551C14.0293 21.1524 16.7023 23.8254 19.9996 23.8254Z"
                fill="white"
            />
        </svg>
    );
};

export const CheckedIconWithOutCircle: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M1 7L5 11L13 3"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const EmptyGift: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3_17600)">
                <circle
                    cx="30"
                    cy="30"
                    r="30"
                    fill="#FF2164"
                    fillOpacity="0.1"
                />
                <circle
                    cx="22"
                    cy="14"
                    r="3"
                    fill="#AF2DFF"
                />
                <circle
                    cx="22"
                    cy="18"
                    r="3"
                    fill="#15C9E2"
                    fillOpacity="0.7"
                />
                <circle
                    cx="38"
                    cy="14"
                    r="3"
                    fill="#AF2DFF"
                />
                <circle
                    cx="38"
                    cy="18"
                    r="3"
                    fill="#15C9E2"
                    fillOpacity="0.7"
                />
                <path
                    d="M50 46C50 40.6957 47.8929 35.6086 44.1421 31.8579C40.3914 28.1071 35.3043 26 30 26C24.6957 26 19.6086 28.1071 15.8579 31.8579C12.1071 35.6086 10 40.6957 10 46L30 46H50Z"
                    fill="#FDD000"
                />
                <path
                    d="M44 51C44 47.287 42.525 43.726 39.8995 41.1005C37.274 38.475 33.713 37 30 37C26.287 37 22.726 38.475 20.1005 41.1005C17.475 43.726 16 47.287 16 51L30 51H44Z"
                    fill="#4C3CFF"
                    fillOpacity="0.7"
                />
            </g>
            <defs>
                <clipPath id="clip0_3_17600">
                    <rect
                        width="60"
                        height="60"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PageNotFoundIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="5"
                y="5"
                width="70"
                height="70"
                fill="#FF2164"
                fillOpacity="0.1"
            />
            <circle
                cx="32"
                cy="23"
                r="3"
                fill="#AF2DFF"
            />
            <circle
                cx="32"
                cy="27"
                r="3"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <circle
                cx="48"
                cy="23"
                r="3"
                fill="#AF2DFF"
            />
            <circle
                cx="48"
                cy="27"
                r="3"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <path
                d="M60 55C60 49.6957 57.8929 44.6086 54.1421 40.8579C50.3914 37.1071 45.3043 35 40 35C34.6957 35 29.6086 37.1071 25.8579 40.8579C22.1071 44.6086 20 49.6957 20 55L40 55H60Z"
                fill="#FDD000"
            />
            <path
                d="M54 60C54 56.287 52.525 52.726 49.8995 50.1005C47.274 47.475 43.713 46 40 46C36.287 46 32.726 47.475 30.1005 50.1005C27.475 52.726 26 56.287 26 60L40 60H54Z"
                fill="#7E2CF5"
                fillOpacity="0.7"
            />
        </svg>
    );
};

export const BannerNull: React.FC<IconProps> = ({ width = '375', height = '205', fill = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 375 205"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M146.632 68H229.313C232.987 68 235.945 70.9576 235.945 74.6318V131.368C235.945 135.042 232.988 138 229.313 138H146.632C142.958 138 140 135.042 140 131.368V74.6318C140.001 70.9576 142.959 68 146.632 68Z"
                fill="white"
            />
            <path
                d="M155.099 76.8513H220.848C223.593 76.8513 225.802 79.0608 225.802 81.8056V124.195C225.802 126.94 223.593 129.149 220.848 129.149H155.099C152.354 129.149 150.144 126.94 150.144 124.195V81.8056C150.144 79.0608 152.354 76.8513 155.099 76.8513Z"
                fill="#F0F0F0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M173.956 91.6423C170.022 91.6423 159.663 97.1895 150.145 102.858V124.198C150.145 126.943 152.353 129.15 155.098 129.15H220.848C223.593 129.15 225.805 126.943 225.805 124.198V105.614C220.077 102.568 214.746 100.306 211.365 100.306C208.707 100.306 204.143 101.732 198.61 103.97C193.195 100.712 179.854 91.6423 173.956 91.6423Z"
                fill="#C8C8C8"
            />
        </svg>
    );
};

export const IconEmptyCommon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="81"
            height="80"
            viewBox="0 0 81 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="5.5"
                y="5"
                width="70"
                height="70"
                fill="#15C9E2"
                fillOpacity="0.1"
            />
            <circle
                cx="32.5"
                cy="23"
                r="3"
                fill="#AF2DFF"
            />
            <circle
                cx="32.5"
                cy="27"
                r="3"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <circle
                cx="48.5"
                cy="23"
                r="3"
                fill="#AF2DFF"
            />
            <circle
                cx="48.5"
                cy="27"
                r="3"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <path
                d="M60.5 45C60.5 50.3043 58.3929 55.3914 54.6421 59.1421C50.8914 62.8929 45.8043 65 40.5 65C35.1957 65 30.1086 62.8929 26.3579 59.1421C22.6071 55.3914 20.5 50.3043 20.5 45L40.5 45H60.5Z"
                fill="#FDD000"
            />
            <path
                d="M54.5 40C54.5 43.713 53.025 47.274 50.3995 49.8995C47.774 52.525 44.213 54 40.5 54C36.787 54 33.226 52.525 30.6005 49.8995C27.975 47.274 26.5 43.713 26.5 40L40.5 40H54.5Z"
                fill="#7E2CF5"
                fillOpacity="0.7"
            />
        </svg>
    );
};
export const IconEmptyCommonForPayment: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
        >
            <rect
                x="5"
                y="5"
                width="70"
                height="70"
                fill="#15C9E2"
                fillOpacity="0.1"
            />
            <circle
                cx="32"
                cy="23"
                r="3"
                fill="#AF2DFF"
            />
            <circle
                cx="32"
                cy="27"
                r="3"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <circle
                cx="48"
                cy="23"
                r="3"
                fill="#AF2DFF"
            />
            <circle
                cx="48"
                cy="27"
                r="3"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <path
                d="M60 45C60 50.3043 57.8929 55.3914 54.1421 59.1421C50.3914 62.8929 45.3043 65 40 65C34.6957 65 29.6086 62.8929 25.8579 59.1421C22.1071 55.3914 20 50.3043 20 45L40 45H60Z"
                fill="#FDD000"
            />
            <path
                d="M54 40C54 43.713 52.525 47.274 49.8995 49.8995C47.274 52.525 43.713 54 40 54C36.287 54 32.726 52.525 30.1005 49.8995C27.475 47.274 26 43.713 26 40L40 40H54Z"
                fill="#7E2CF5"
                fillOpacity="0.7"
            />
        </svg>
    );
};

export const IconEmptyCommonForAddress: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
        >
            <rect
                x="5"
                y="5"
                width="70"
                height="70"
                fill="#FF2164"
                fillOpacity="0.1"
            />
            <circle
                cx="32"
                cy="23"
                r="3"
                fill="#AF2DFF"
            />
            <circle
                cx="32"
                cy="27"
                r="3"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <circle
                cx="48"
                cy="23"
                r="3"
                fill="#AF2DFF"
            />
            <circle
                cx="48"
                cy="27"
                r="3"
                fill="#15C9E2"
                fillOpacity="0.7"
            />
            <path
                d="M60 55C60 49.6957 57.8929 44.6086 54.1421 40.8579C50.3914 37.1071 45.3043 35 40 35C34.6957 35 29.6086 37.1071 25.8579 40.8579C22.1071 44.6086 20 49.6957 20 55L40 55H60Z"
                fill="#FDD000"
            />
            <path
                d="M54 60C54 56.287 52.525 52.726 49.8995 50.1005C47.274 47.475 43.713 46 40 46C36.287 46 32.726 47.475 30.1005 50.1005C27.475 52.726 26 56.287 26 60L40 60H54Z"
                fill="#7E2CF5"
                fillOpacity="0.7"
            />
        </svg>
    );
};

export const GiftIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3_17546)">
                <circle
                    cx="30"
                    cy="30"
                    r="30"
                    fill="#15C9E2"
                    fillOpacity="0.1"
                />
                <path
                    d="M15.6284 54.8987L49.3784 31.9491L18.6284 14.1955L15.6284 54.8987Z"
                    fill="#15C9E2"
                />
                <path
                    d="M38.9496 36.321L14.0567 21.9491L13.5714 28.5337L33.4898 40.0336L38.9496 36.321Z"
                    fill="#7E2CF5"
                    fillOpacity="0.7"
                />
                <path
                    d="M22.6283 14.1954L53.3783 31.9489L46.9497 36.3203L22.0569 21.9484L22.6283 14.1954Z"
                    fill="#E42044"
                    fillOpacity="0.7"
                />
                <rect
                    x="29.4669"
                    y="7.92944"
                    width="4.30954"
                    height="4.30954"
                    fill="#7E2CF5"
                />
                <rect
                    x="48.6893"
                    y="8.63525"
                    width="4.30954"
                    height="4.30954"
                    fill="#FF4A6B"
                />
                <rect
                    x="38.3949"
                    y="10.6001"
                    width="2.17522"
                    height="2.17522"
                    fill="#FF4A6B"
                />
                <rect
                    x="37.5418"
                    y="16"
                    width="2.93505"
                    height="2.93505"
                    transform="rotate(60 37.5418 16)"
                    fill="#16D7B4"
                />
                <rect
                    x="46.5248"
                    y="19.9998"
                    width="4.07028"
                    height="4.07028"
                    transform="rotate(60 46.5248 19.9998)"
                    fill="#15C9E2"
                />
                <rect
                    x="41.0865"
                    y="2.91309"
                    width="3.10939"
                    height="3.10939"
                    transform="rotate(60 41.0865 2.91309)"
                    fill="#15C9E2"
                />
                <rect
                    x="46.9407"
                    y="15.5305"
                    width="2.93505"
                    height="2.93505"
                    transform="rotate(117.99 46.9407 15.5305)"
                    fill="#FDD000"
                />
                <rect
                    x="31.6619"
                    y="15.9238"
                    width="1.9684"
                    height="1.9684"
                    transform="rotate(117.99 31.6619 15.9238)"
                    fill="#FDD000"
                />
                <circle
                    cx="16.7533"
                    cy="52.95"
                    r="3.5"
                    transform="rotate(30 16.7533 52.95)"
                    fill="#FDD000"
                />
            </g>
            <defs>
                <clipPath id="clip0_3_17546">
                    <rect
                        width="60"
                        height="60"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const UnLuckySVG: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="100"
            height="103"
            viewBox="0 0 100 103"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.6">
                <path
                    d="M36.6295 66.5004L18.3459 65.5972L28.9533 55.358L21.1829 52.0544L26.3235 48.6959L22.8073 46.0829L26.3423 44.526L15.4862 34.1853L30.2063 32.0022L30.8093 18.2859L42.1215 25.2715L48.3272 16.1818L48.206 26.7373L53.569 25.6985L52.8237 29.9687L66.6435 26.8364L60.8138 38.5807L79.9732 45.0077L70.5249 53.3399L76.9327 55.4002L72.7332 58.0283L79.6026 64.7568L69.8674 67.8138L73.1024 79.2428L65.6508 72.6689L54.8423 90.6655L48.5894 73.9978L40.2629 78.9536L39.7003 74.2832L30.5915 78.805L36.6295 66.5004Z"
                    fill="white"
                />
            </g>
            <path
                d="M40.2774 66.8429L21.9964 65.9327L32.5988 55.6964L24.8308 52.3969L29.969 49.0343L26.4528 46.4212L29.9902 44.8685L19.1317 34.5237L33.8542 32.3447L34.4548 18.6242L45.7694 25.614L51.9727 16.5202L51.8539 27.0798L57.2145 26.0368L56.4692 30.3071L70.2914 27.1789L64.4593 38.9191L83.6187 45.3461L74.1704 53.6783L80.5782 55.7386L76.3811 58.3708L83.2505 65.0993L73.5203 68.1535L76.7502 79.5853L69.3037 73.0085L58.4901 91.008L52.2373 74.3403L43.9134 79.2891L43.3458 74.6216L34.2394 79.1476L40.2774 66.8429Z"
                fill="white"
            />
            <path
                d="M23.2417 63.6569C23.2322 63.6404 23.2202 63.6198 23.2157 63.6004C23.1787 63.4788 23.2234 63.3374 23.3314 63.2366L33.562 53.358L26.2217 50.2352C26.1068 50.1859 26.0399 50.0815 26.0423 49.9591C26.0448 49.8367 26.1211 49.7156 26.241 49.6354L30.9322 46.5693L27.7802 44.2301C27.6855 44.1583 27.6435 44.0395 27.673 43.9179C27.7026 43.7963 27.7984 43.686 27.9326 43.6305L30.9331 42.3108L20.4325 32.3095C20.3406 32.2195 20.3188 32.078 20.383 31.9475C20.4472 31.8169 20.5846 31.721 20.7305 31.6973L35.0798 29.5742L35.6664 16.1864C35.674 16.05 35.7603 15.9231 35.8973 15.8496C36.0343 15.776 36.1921 15.7729 36.3041 15.8403L47.2876 22.6251L53.2472 13.892C53.3437 13.7483 53.5177 13.6698 53.6824 13.6903C53.8471 13.7107 53.958 13.8337 53.9525 13.9854L53.8386 24.1736L58.7935 23.2108C58.9123 23.1863 59.0226 23.2161 59.1002 23.2813C59.1777 23.3466 59.2102 23.4489 59.1932 23.5577L58.5259 27.3758L71.8531 24.3574C71.9942 24.3255 72.129 24.3632 72.2061 24.4507C72.2856 24.5423 72.2953 24.6743 72.2387 24.795L66.5732 36.2134L85.4045 42.5327C85.5196 42.5708 85.5917 42.6612 85.6042 42.775C85.6167 42.8888 85.5651 43.0067 85.4647 43.0976L76.4704 51.0301L82.3566 52.924C82.4864 52.9646 82.5607 53.0702 82.563 53.2009C82.563 53.3275 82.4864 53.4597 82.3592 53.5387L78.5713 55.9126L85.1507 62.3575C85.2378 62.4392 85.2575 62.5654 85.2082 62.6873C85.159 62.8093 85.051 62.9101 84.9147 62.9503L75.5837 65.8785L78.7195 76.9631C78.7608 77.1153 78.681 77.2879 78.5238 77.3842C78.3667 77.4804 78.1721 77.4772 78.0534 77.3752L70.9579 71.1073L60.4196 88.6508C60.3407 88.7789 60.1935 88.8694 60.0431 88.8737C59.8927 88.878 59.766 88.8082 59.7192 88.6811L53.6045 72.3792L45.682 77.0908C45.5674 77.157 45.4315 77.1749 45.3238 77.1381C45.2137 77.0971 45.1366 77.0096 45.1265 76.8999L44.6142 72.6736L35.9757 76.9624C35.8263 77.0376 35.659 77.0242 35.5499 76.9387C35.4383 76.8491 35.4141 76.7035 35.4859 76.563L41.3133 64.688L23.5073 63.8061C23.3892 63.7973 23.2917 63.7436 23.2417 63.6569ZM34.5471 53.0148C34.5662 53.0478 34.5826 53.0878 34.5867 53.1294C34.5945 53.235 34.5478 53.3499 34.4624 53.4323L24.4102 63.1363L41.9626 64.0051C42.0783 64.0098 42.1758 64.0635 42.2258 64.1502C42.2763 64.2145 42.281 64.3494 42.2272 64.4519L36.6078 75.9042L44.8059 71.8313C44.9203 71.7762 45.0462 71.764 45.1463 71.8107C45.2491 71.8505 45.3188 71.9367 45.3289 72.0464L45.8347 76.2269L53.6624 71.5701C53.7622 71.5125 53.8809 71.4879 53.9888 71.5137C54.0894 71.5381 54.1719 71.6005 54.207 71.6958L60.1977 87.6677L70.5703 70.4014C70.6341 70.293 70.744 70.2186 70.8677 70.1911C70.9915 70.1637 71.1117 70.1878 71.1941 70.2613L77.6019 75.914L74.7446 65.8183C74.7193 65.7284 74.736 65.6307 74.797 65.5405C74.8529 65.4532 74.9455 65.3833 75.0521 65.3492L84.1501 62.4896L77.6868 56.1537C77.6143 56.0856 77.5868 55.9804 77.6135 55.877C77.6378 55.7694 77.7087 55.6735 77.811 55.6089L81.3593 53.3842L75.6029 51.531C75.4878 51.4929 75.4107 51.4054 75.3958 51.2875C75.3833 51.1737 75.4325 51.0517 75.5353 50.9649L84.5322 43.0253L65.8844 36.7706C65.7033 36.7101 65.6331 36.5196 65.7205 36.3371L71.2551 25.1868L58.116 28.1626C57.9972 28.1871 57.8793 28.1672 57.7994 28.0978C57.7195 28.0284 57.682 27.929 57.699 27.8202L58.3691 23.984L53.4836 24.9287C53.3771 24.9516 53.2716 24.9301 53.1938 24.8759C53.1161 24.8218 53.0734 24.7364 53.0778 24.6404L53.1835 15.2326L47.6986 23.2679C47.6377 23.3581 47.5378 23.4268 47.4287 23.4568C47.3197 23.4867 47.2116 23.4721 47.1288 23.4209L36.4029 16.8174L35.8315 29.8169C35.8203 30.0049 35.6543 30.1778 35.4466 30.2096L21.5397 32.2699L31.8806 42.1213C31.9629 42.1948 31.9902 42.3111 31.9509 42.4273C31.9166 42.5406 31.8234 42.6439 31.7016 42.6978L28.7657 43.9912L31.8351 46.268C31.925 46.3317 31.9649 46.4352 31.9479 46.544C31.931 46.6528 31.8598 46.7599 31.7525 46.8273L27.1786 49.8202L34.4041 52.8938C34.4652 52.919 34.5161 52.9611 34.5471 53.0148Z"
                fill="white"
            />
            <path
                d="M45.339 39.2382C45.578 39.1002 45.8057 39.0609 46.022 39.1203C46.2384 39.1796 46.4164 39.3302 46.556 39.572C46.935 40.2284 47.3054 40.8898 47.6673 41.556C48.0463 42.2125 48.4288 42.8553 48.8149 43.4846L51.3349 41.9951C51.0773 41.9826 50.8062 41.9664 50.5216 41.9465C50.1928 41.929 49.9124 41.8375 49.6804 41.6721C49.4753 41.5141 49.3628 41.2797 49.3426 40.9688L49.4244 38.7451C49.4213 38.4244 49.4852 38.1803 49.616 38.0126C49.7568 37.8622 50.0272 37.7983 50.4271 37.8207C51.0404 37.8581 51.6303 37.8746 52.1967 37.87C52.7631 37.8655 53.3999 37.7857 54.107 37.6308L53.1047 35.8947C52.8554 35.4629 52.9441 35.1238 53.3709 34.8774L55.6754 33.5469C56.1022 33.3005 56.4402 33.3932 56.6896 33.825L59.4571 38.6186C59.8284 38.4733 60.1238 38.5907 60.3432 38.9707L63.769 44.9043C64.0283 45.3534 64.1147 45.7987 64.0282 46.2402C63.9587 46.6719 63.6594 47.0405 63.1302 47.346L62.6181 47.6417C61.4402 48.3217 60.3128 48.892 59.2359 49.3526C58.1589 49.8131 56.9844 50.2033 55.7123 50.5232C55.0322 50.6855 54.5831 50.5187 54.3651 50.0227L53.4735 47.9464C53.368 47.6848 53.3522 47.4406 53.4261 47.2137C53.4999 46.9868 53.6834 46.8118 53.9765 46.6887C54.8286 46.3118 55.6417 45.946 56.4156 45.5913C57.1995 45.2539 57.967 44.8684 58.7181 44.4347L57.0277 41.5068C56.4528 41.6544 55.9022 41.765 55.3757 41.8387C54.8762 41.9198 54.3704 41.97 53.8581 41.9894C53.5322 42.0163 53.1964 42.0259 52.8505 42.0183L52.8805 42.0701L54.3166 44.5576C54.6158 45.0758 54.5179 45.4778 54.0228 45.7636L51.125 47.3676C51.6479 48.1943 52.1607 49.0037 52.6636 49.7959C53.1835 50.5782 53.712 51.3556 54.2491 52.1281C54.5596 52.5476 54.4737 52.9311 53.9915 53.2786L52.5449 54.3211C52.3259 54.4936 52.1203 54.5317 51.9281 54.4354C51.7459 54.3563 51.5729 54.2144 51.4091 54.0095C49.9563 52.0845 48.5653 50.0892 47.2362 48.0236C45.907 45.958 44.5707 43.7815 43.2272 41.4939C43.0876 41.252 43.0462 41.0226 43.103 40.8056C43.1597 40.5885 43.3076 40.411 43.5466 40.273L45.339 39.2382ZM38.6035 54.1823C38.7012 53.3659 38.954 52.6211 39.362 51.9479C39.7799 51.292 40.3559 50.7522 41.0899 50.3284C41.824 49.9046 42.588 49.6708 43.3821 49.6269C44.1861 49.6003 44.9746 49.7439 45.7475 50.0577C46.5205 50.3715 47.2594 50.8431 47.9642 51.4726C48.6691 52.1021 49.2908 52.8833 49.8293 53.8161C50.3579 54.7316 50.7186 55.6519 50.9113 56.5771C51.104 57.5023 51.1381 58.3694 51.0134 59.1784C50.8986 60.0047 50.6238 60.7507 50.1887 61.4164C49.7637 62.0994 49.1842 62.6528 48.4501 63.0766C47.7161 63.5004 46.9556 63.7207 46.1686 63.7374C45.3917 63.7714 44.6252 63.6266 43.8693 63.303C43.1234 62.9966 42.4066 62.5237 41.7188 61.8844C41.031 61.245 40.4229 60.4676 39.8943 59.5521C39.3557 58.6193 38.9816 57.6952 38.7717 56.7799C38.5619 55.8646 38.5059 54.9987 38.6035 54.1823ZM52.0261 57.3845C51.7269 56.8663 51.8334 56.4593 52.3455 56.1636L64.8794 48.7199C65.3915 48.4242 65.7922 48.5269 66.0814 49.0278L67.8317 52.0594C68.1309 52.5776 68.0195 52.9759 67.4974 53.2543L63.4174 55.4717L64.3449 57.0782C64.5045 57.3546 64.5438 57.6198 64.4629 57.8738C64.409 58.1352 64.2454 58.3448 63.9723 58.5025L61.8726 59.7147C61.5995 59.8724 61.3277 59.9142 61.0573 59.84C60.8139 59.7732 60.6124 59.6017 60.4528 59.3253L59.4805 57.6411L54.7241 60.2835C54.192 60.5446 53.7864 60.4333 53.5071 59.9497L52.0261 57.3845ZM43.3339 54.2151C42.7876 54.5304 42.4664 55.0384 42.3701 55.7389C42.2837 56.4567 42.4699 57.2128 42.9287 58.0074C43.3775 58.7848 43.9293 59.3069 44.5841 59.5737C45.2489 59.8578 45.8544 59.8422 46.4006 59.5268C46.9469 59.2114 47.2632 58.6949 47.3495 57.9771C47.4629 57.2667 47.2952 56.5229 46.8464 55.7456C46.3677 54.9164 45.7924 54.3733 45.1205 54.1164C44.4757 53.8668 43.8802 53.8997 43.3339 54.2151Z"
                fill="#0048D3"
            />
        </svg>
    );
};

export const BottomRightWheelIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="76"
            height="61"
            viewBox="0 0 76 61"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54 2H62H63C67.9706 2 72 6.02944 72 11C72 15.9706 67.9706 20 63 20C62.662 20 62.3283 19.9814 62 19.9451V24H54V11V2ZM63 12.4994C63.8284 12.4994 64.5 11.8278 64.5 10.9994C64.5 10.171 63.8284 9.49938 63 9.49938C62.1716 9.49938 61.5 10.171 61.5 10.9994C61.5 11.8278 62.1716 12.4994 63 12.4994Z"
                fill="#D2E3FD"
            />
            <path
                d="M63.4408 30.8762C65.6422 34.689 66.5239 39.1217 65.9492 43.4867C65.3745 47.8517 63.3756 51.9051 60.2624 55.0183C57.1493 58.1315 53.0959 60.1304 48.7308 60.7051C44.3658 61.2797 39.9331 60.398 36.1203 58.1967C32.3075 55.9953 29.3276 52.5974 27.6427 48.5298C25.9579 44.4623 25.6623 39.9525 26.8018 35.6998C27.9413 31.4471 30.4522 27.6893 33.9451 25.0091C37.438 22.3289 41.7176 20.8762 46.1203 20.8762L46.1203 40.8762L63.4408 30.8762Z"
                fill="#F4F8FF"
            />
            <path
                d="M63.4408 30.8762C65.6422 34.689 66.5239 39.1217 65.9492 43.4867C65.3745 47.8517 63.3756 51.9051 60.2624 55.0183C57.1493 58.1315 53.0959 60.1304 48.7308 60.7051C44.3658 61.2797 39.9331 60.398 36.1203 58.1967C32.3075 55.9953 29.3276 52.5974 27.6427 48.5298C25.9579 44.4623 25.6623 39.9525 26.8018 35.6998C27.9413 31.4471 30.4522 27.6893 33.9451 25.0091C37.438 22.3289 41.7176 20.8762 46.1203 20.8762L46.1203 40.8762L63.4408 30.8762Z"
                fill="#F4F8FF"
            />
            <path
                d="M63.4408 30.8762C65.6422 34.689 66.5239 39.1217 65.9492 43.4867C65.3745 47.8517 63.3756 51.9051 60.2624 55.0183C57.1493 58.1315 53.0959 60.1304 48.7308 60.7051C44.3658 61.2797 39.9331 60.398 36.1203 58.1967C32.3075 55.9953 29.3276 52.5974 27.6427 48.5298C25.9579 44.4623 25.6623 39.9525 26.8018 35.6998C27.9413 31.4471 30.4522 27.6893 33.9451 25.0091C37.438 22.3289 41.7176 20.8762 46.1203 20.8762L46.1203 40.8762L63.4408 30.8762Z"
                fill="#F4F8FF"
            />
            <path
                d="M63.4408 30.8762C65.6422 34.689 66.5239 39.1217 65.9492 43.4867C65.3745 47.8517 63.3756 51.9051 60.2624 55.0183C57.1493 58.1315 53.0959 60.1304 48.7308 60.7051C44.3658 61.2797 39.9331 60.398 36.1203 58.1967C32.3075 55.9953 29.3276 52.5974 27.6427 48.5298C25.9579 44.4623 25.6623 39.9525 26.8018 35.6998C27.9413 31.4471 30.4522 27.6893 33.9451 25.0091C37.438 22.3289 41.7176 20.8762 46.1203 20.8762L46.1203 40.8762L63.4408 30.8762Z"
                fill="#F4F8FF"
            />
            <path
                d="M13.6186 17.926C16.5044 11.3077 26.4466 13.9717 25.6366 21.1462C25.3268 23.89 26.8424 26.515 29.3734 27.6187C35.9917 30.5045 33.3277 40.4466 26.1532 39.6367C23.4095 39.3269 20.7844 40.8425 19.6808 43.3735C16.795 49.9918 6.85283 47.3278 7.66279 40.1533C7.97254 37.4095 6.45697 34.7845 3.92593 33.6809C-2.69237 30.7951 -0.0283769 20.8529 7.14615 21.6629C9.88991 21.9726 12.5149 20.4571 13.6186 17.926Z"
                fill="#63FFF6"
                fillOpacity="0.5"
            />
        </svg>
    );
};

export const TopRightWheelIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="107"
            height="26"
            viewBox="0 0 107 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M94.2782 8.04541C89.6264 8.04541 89.6264 1.77547 84.9745 1.77547C80.3227 1.77547 80.3227 8.04541 75.6708 8.04541C71.019 8.04541 71.019 1.77547 66.3781 1.77547C61.7261 1.77547 61.7261 8.04541 57.0853 8.04541C52.4333 8.04541 52.4333 1.77547 47.7925 1.77547C43.1406 1.77547 43.1406 8.04541 38.489 8.04541C33.837 8.0454 33.8371 1.77547 29.1851 1.77547C24.5335 1.77547 24.5335 8.0454 19.8816 8.0454C15.2296 8.0454 15.2296 1.77547 10.5777 1.77547C5.92608 1.77546 5.92608 8.0454 1.27413 8.0454"
                stroke="#2073F6"
                strokeWidth="1.79253"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M114.278 24.27C109.626 24.27 109.626 18.0001 104.975 18.0001C100.323 18.0001 100.323 24.27 95.6709 24.27C91.0191 24.27 91.0191 18.0001 86.3781 18.0001C81.7262 18.0001 81.7262 24.27 77.0854 24.27C72.4334 24.27 72.4334 18.0001 67.7926 18.0001C63.1407 18.0001 63.1407 24.27 58.4891 24.27C53.8371 24.27 53.8371 18.0001 49.1852 18.0001C44.5336 18.0001 44.5336 24.27 39.8817 24.27C35.2297 24.27 35.2297 18.0001 30.5778 18.0001C25.9262 18.0001 25.9262 24.27 21.2742 24.27"
                stroke="#EEEEEE"
                strokeWidth="1.79253"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const BottomLeftWheelIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="102"
            height="69"
            viewBox="0 0 102 69"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M71.3205 30.9996C75.1333 28.7983 79.566 27.9166 83.931 28.4912C88.296 29.0659 92.3495 31.0648 95.4626 34.178C98.5758 37.2911 100.575 41.3446 101.149 45.7096C101.724 50.0746 100.842 54.5073 98.641 58.3201C96.4397 62.133 93.0417 65.1129 88.9742 66.7977C84.9066 68.4825 80.3968 68.7781 76.1441 67.6386C71.8915 66.4991 68.1336 63.9882 65.4534 60.4953C62.7733 57.0025 61.3205 52.7228 61.3205 48.3201L81.3205 48.3201L71.3205 30.9996Z"
                fill="#F4F8FF"
            />
            <path
                d="M71.3205 30.9996C75.1333 28.7983 79.566 27.9166 83.931 28.4912C88.296 29.0659 92.3495 31.0648 95.4626 34.178C98.5758 37.2911 100.575 41.3446 101.149 45.7096C101.724 50.0746 100.842 54.5073 98.641 58.3201C96.4397 62.133 93.0417 65.1129 88.9742 66.7977C84.9066 68.4825 80.3968 68.7781 76.1441 67.6386C71.8915 66.4991 68.1336 63.9882 65.4534 60.4953C62.7733 57.0025 61.3205 52.7228 61.3205 48.3201L81.3205 48.3201L71.3205 30.9996Z"
                fill="#F4F8FF"
            />
            <path
                d="M71.3205 30.9996C75.1333 28.7983 79.566 27.9166 83.931 28.4912C88.296 29.0659 92.3495 31.0648 95.4626 34.178C98.5758 37.2911 100.575 41.3446 101.149 45.7096C101.724 50.0746 100.842 54.5073 98.641 58.3201C96.4397 62.133 93.0417 65.1129 88.9742 66.7977C84.9066 68.4825 80.3968 68.7781 76.1441 67.6386C71.8915 66.4991 68.1336 63.9882 65.4534 60.4953C62.7733 57.0025 61.3205 52.7228 61.3205 48.3201L81.3205 48.3201L71.3205 30.9996Z"
                fill="#F4F8FF"
            />
            <path
                d="M71.3205 30.9996C75.1333 28.7983 79.566 27.9166 83.931 28.4912C88.296 29.0659 92.3495 31.0648 95.4626 34.178C98.5758 37.2911 100.575 41.3446 101.149 45.7096C101.724 50.0746 100.842 54.5073 98.641 58.3201C96.4397 62.133 93.0417 65.1129 88.9742 66.7977C84.9066 68.4825 80.3968 68.7781 76.1441 67.6386C71.8915 66.4991 68.1336 63.9882 65.4534 60.4953C62.7733 57.0025 61.3205 52.7228 61.3205 48.3201L81.3205 48.3201L71.3205 30.9996Z"
                fill="#F4F8FF"
            />
            <path
                d="M63.0039 7.26953C58.3521 7.26953 58.3521 0.999593 53.7002 0.999593C49.0484 0.999592 49.0484 7.26953 44.3965 7.26953C39.7447 7.26953 39.7447 0.999592 35.1038 0.999591C30.4518 0.999591 30.4518 7.26953 25.811 7.26953C21.159 7.26953 21.159 0.99959 16.5182 0.999589C11.8663 0.999589 11.8663 7.26953 7.2147 7.26953C2.56276 7.26953 2.56276 0.999588 -2.08919 0.999588C-6.74078 0.999587 -6.74078 7.26953 -11.3927 7.26952C-16.0447 7.26952 -16.0447 0.999587 -20.6966 0.999586C-25.3482 0.999586 -25.3482 7.26952 -30.0002 7.26952"
                stroke="#2073F6"
                strokeWidth="1.79253"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M43.0039 27.2695C38.3521 27.2695 38.3521 20.9996 33.7002 20.9996C29.0484 20.9996 29.0484 27.2695 24.3965 27.2695C19.7447 27.2695 19.7447 20.9996 15.1038 20.9996C10.4518 20.9996 10.4518 27.2695 5.81099 27.2695C1.15904 27.2695 1.15904 20.9996 -3.48176 20.9996C-8.1337 20.9996 -8.1337 27.2695 -12.7853 27.2695C-17.4372 27.2695 -17.4372 20.9996 -22.0892 20.9996C-26.7408 20.9996 -26.7408 27.2695 -31.3927 27.2695C-36.0447 27.2695 -36.0447 20.9996 -40.6966 20.9996C-45.3482 20.9996 -45.3482 27.2695 -50.0002 27.2695"
                stroke="#EEEEEE"
                strokeWidth="1.79253"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const TopLeftWheelIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="85"
            height="81"
            viewBox="0 0 85 81"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M63 57H71H72C76.9706 57 81 61.0294 81 66C81 70.9706 76.9706 75 72 75C71.662 75 71.3283 74.9814 71 74.9451V79H63V66V57ZM72 67.4994C72.8284 67.4994 73.5 66.8278 73.5 65.9994C73.5 65.171 72.8284 64.4994 72 64.4994C71.1716 64.4994 70.5 65.171 70.5 65.9994C70.5 66.8278 71.1716 67.4994 72 67.4994Z"
                fill="#D2E3FD"
            />
            <path
                d="M49.8126 75.0728C43.0701 78.4559 35.3997 79.5197 27.991 78.0991C20.5823 76.6786 13.8493 72.8531 8.83641 67.216C3.82347 61.5788 0.810686 54.4451 0.265321 46.9212C-0.280044 39.3973 1.67249 31.9037 5.82009 25.6025C9.96769 19.3014 16.0786 14.5449 23.205 12.0708C30.3314 9.59671 38.075 9.54321 45.2349 11.9186C52.3948 14.2941 58.5708 18.9657 62.8051 25.2089C67.0393 31.4521 69.0952 38.918 68.6538 46.4488L34.4441 44.4438L49.8126 75.0728Z"
                fill="#F4F8FF"
            />
            <path
                d="M36.0288 3.41144C37.9991 -1.10717 44.787 0.711655 44.234 5.61002C44.0225 7.4833 45.0573 9.27553 46.7853 10.029C51.3039 11.9993 49.4851 18.7872 44.5867 18.2343C42.7135 18.0228 40.9212 19.0575 40.1677 20.7856C38.1975 25.3042 31.4095 23.4853 31.9625 18.587C32.174 16.7137 31.1393 14.9215 29.4112 14.168C24.8926 12.1977 26.7114 5.40975 31.6098 5.96275C33.4831 6.17423 35.2753 5.13949 36.0288 3.41144Z"
                fill="#63FFF6"
                fillOpacity="0.5"
            />
        </svg>
    );
};

export const PointPlusIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="20"
                cy="20"
                r="19.5"
                fill="white"
                stroke="#EEEEEE"
            />
            <g clipPath="url(#clip0_3_15419)">
                <circle
                    cx="20"
                    cy="20"
                    r="18"
                    fill="#2073F6"
                    fillOpacity="0.2"
                />
                <mask
                    id="mask0_3_15419"
                    // style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="2"
                    width="36"
                    height="36"
                >
                    <circle
                        cx="20"
                        cy="20"
                        r="18"
                        fill="#2073F6"
                    />
                </mask>
                <g mask="url(#mask0_3_15419)">
                    <rect
                        x="33.2454"
                        y="7.54199"
                        width="36.8578"
                        height="2.44023"
                        transform="rotate(135 33.2454 7.54199)"
                        fill="white"
                        fillOpacity="0.4"
                    />
                    <rect
                        x="30.3162"
                        y="5.29492"
                        width="35.3834"
                        height="7.3207"
                        transform="rotate(135 30.3162 5.29492)"
                        fill="white"
                        fillOpacity="0.4"
                    />
                </g>
                <mask
                    id="path-6-inside-1_3_15419"
                    fill="white"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.8125 12.6416L19.6307 12.6416H20.358C23.9729 12.6416 26.9034 15.5721 26.9034 19.1871C26.9034 22.802 23.9729 25.7325 20.358 25.7325C20.1121 25.7325 19.8695 25.719 19.6307 25.6926L19.6307 28.6416H13.8125V19.1871L13.8125 12.6416ZM20.358 20.2773C20.9604 20.2773 21.4489 19.7888 21.4489 19.1863C21.4489 18.5839 20.9604 18.0954 20.358 18.0954C19.7555 18.0954 19.267 18.5839 19.267 19.1863C19.267 19.7888 19.7555 20.2773 20.358 20.2773Z"
                    />
                </mask>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.8125 12.6416L19.6307 12.6416H20.358C23.9729 12.6416 26.9034 15.5721 26.9034 19.1871C26.9034 22.802 23.9729 25.7325 20.358 25.7325C20.1121 25.7325 19.8695 25.719 19.6307 25.6926L19.6307 28.6416H13.8125V19.1871L13.8125 12.6416ZM20.358 20.2773C20.9604 20.2773 21.4489 19.7888 21.4489 19.1863C21.4489 18.5839 20.9604 18.0954 20.358 18.0954C19.7555 18.0954 19.267 18.5839 19.267 19.1863C19.267 19.7888 19.7555 20.2773 20.358 20.2773Z"
                    fill="white"
                />
                <path
                    d="M13.8125 12.6416V11.6416H12.8125V12.6416H13.8125ZM19.6307 25.6926L19.7406 24.6986L18.6307 24.5759V25.6926H19.6307ZM19.6307 28.6416V29.6416H20.6307V28.6416H19.6307ZM13.8125 28.6416H12.8125L12.8125 29.6416H13.8125L13.8125 28.6416ZM19.6307 11.6416H13.8125V13.6416H19.6307V11.6416ZM20.358 11.6416L19.6307 11.6416V13.6416L20.358 13.6416V11.6416ZM27.9034 19.1871C27.9034 15.0198 24.5252 11.6416 20.358 11.6416V13.6416C23.4206 13.6416 25.9034 16.1244 25.9034 19.1871L27.9034 19.1871ZM20.358 26.7325C24.5252 26.7325 27.9034 23.3543 27.9034 19.1871L25.9034 19.1871C25.9034 22.2497 23.4206 24.7325 20.358 24.7325L20.358 26.7325ZM19.5208 26.6865C19.796 26.7169 20.0753 26.7325 20.358 26.7325L20.358 24.7325C20.1489 24.7325 19.9429 24.721 19.7406 24.6986L19.5208 26.6865ZM20.6307 28.6416L20.6307 25.6926H18.6307L18.6307 28.6416H20.6307ZM13.8125 29.6416H19.6307V27.6416H13.8125L13.8125 29.6416ZM12.8125 19.1871V28.6416H14.8125L14.8125 19.1871H12.8125ZM12.8125 12.6416L12.8125 19.1871H14.8125L14.8125 12.6416H12.8125ZM20.4489 19.1863C20.4489 19.2366 20.4082 19.2773 20.358 19.2773V21.2773C21.5127 21.2773 22.4489 20.3411 22.4489 19.1863H20.4489ZM20.358 19.0954C20.4082 19.0954 20.4489 19.1361 20.4489 19.1863H22.4489C22.4489 18.0316 21.5127 17.0954 20.358 17.0954V19.0954ZM20.267 19.1863C20.267 19.1361 20.3077 19.0954 20.358 19.0954V17.0954C19.2032 17.0954 18.267 18.0316 18.267 19.1863H20.267ZM20.358 19.2773C20.3077 19.2773 20.267 19.2366 20.267 19.1863H18.267C18.267 20.3411 19.2032 21.2773 20.358 21.2773V19.2773Z"
                    fill="#0059E5"
                    mask="url(#path-6-inside-1_3_15419)"
                />
            </g>
            <defs>
                <clipPath id="clip0_3_15419">
                    <rect
                        width="36"
                        height="36"
                        fill="white"
                        transform="translate(2 2)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PointMinusIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="20"
                cy="20"
                r="19.5"
                fill="white"
                stroke="#EEEEEE"
            />
            <g clipPath="url(#clip0_3_15429)">
                <circle
                    cx="20"
                    cy="20"
                    r="18"
                    fill="#FF2164"
                    fillOpacity="0.2"
                />
                <mask
                    id="mask0_3_15429"
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="2"
                    width="36"
                    height="36"
                >
                    <circle
                        cx="20"
                        cy="20"
                        r="18"
                        fill="#2073F6"
                    />
                </mask>
                <g mask="url(#mask0_3_15429)">
                    <rect
                        x="33.2454"
                        y="7.54199"
                        width="36.8578"
                        height="2.44023"
                        transform="rotate(135 33.2454 7.54199)"
                        fill="white"
                        fillOpacity="0.4"
                    />
                    <rect
                        x="30.3162"
                        y="5.29492"
                        width="35.3834"
                        height="7.3207"
                        transform="rotate(135 30.3162 5.29492)"
                        fill="white"
                        fillOpacity="0.4"
                    />
                </g>
                <mask
                    id="path-6-inside-1_3_15429"
                    fill="white"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.8125 12.6416L19.6307 12.6416H20.358C23.9729 12.6416 26.9034 15.5721 26.9034 19.1871C26.9034 22.802 23.9729 25.7325 20.358 25.7325C20.1121 25.7325 19.8695 25.719 19.6307 25.6926L19.6307 28.6416H13.8125V19.1871L13.8125 12.6416ZM20.358 20.2773C20.9604 20.2773 21.4489 19.7888 21.4489 19.1863C21.4489 18.5839 20.9604 18.0954 20.358 18.0954C19.7555 18.0954 19.267 18.5839 19.267 19.1863C19.267 19.7888 19.7555 20.2773 20.358 20.2773Z"
                    />
                </mask>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.8125 12.6416L19.6307 12.6416H20.358C23.9729 12.6416 26.9034 15.5721 26.9034 19.1871C26.9034 22.802 23.9729 25.7325 20.358 25.7325C20.1121 25.7325 19.8695 25.719 19.6307 25.6926L19.6307 28.6416H13.8125V19.1871L13.8125 12.6416ZM20.358 20.2773C20.9604 20.2773 21.4489 19.7888 21.4489 19.1863C21.4489 18.5839 20.9604 18.0954 20.358 18.0954C19.7555 18.0954 19.267 18.5839 19.267 19.1863C19.267 19.7888 19.7555 20.2773 20.358 20.2773Z"
                    fill="white"
                />
                <path
                    d="M13.8125 12.6416V11.6416H12.8125V12.6416H13.8125ZM19.6307 25.6926L19.7406 24.6986L18.6307 24.5759V25.6926H19.6307ZM19.6307 28.6416V29.6416H20.6307V28.6416H19.6307ZM13.8125 28.6416H12.8125L12.8125 29.6416H13.8125L13.8125 28.6416ZM19.6307 11.6416H13.8125V13.6416H19.6307V11.6416ZM20.358 11.6416L19.6307 11.6416V13.6416L20.358 13.6416V11.6416ZM27.9034 19.1871C27.9034 15.0198 24.5252 11.6416 20.358 11.6416V13.6416C23.4206 13.6416 25.9034 16.1244 25.9034 19.1871L27.9034 19.1871ZM20.358 26.7325C24.5252 26.7325 27.9034 23.3543 27.9034 19.1871L25.9034 19.1871C25.9034 22.2497 23.4206 24.7325 20.358 24.7325L20.358 26.7325ZM19.5208 26.6865C19.796 26.7169 20.0753 26.7325 20.358 26.7325L20.358 24.7325C20.1489 24.7325 19.9429 24.721 19.7406 24.6986L19.5208 26.6865ZM20.6307 28.6416L20.6307 25.6926H18.6307L18.6307 28.6416H20.6307ZM13.8125 29.6416H19.6307V27.6416H13.8125L13.8125 29.6416ZM12.8125 19.1871V28.6416H14.8125L14.8125 19.1871H12.8125ZM12.8125 12.6416L12.8125 19.1871H14.8125L14.8125 12.6416H12.8125ZM20.4489 19.1863C20.4489 19.2366 20.4082 19.2773 20.358 19.2773V21.2773C21.5127 21.2773 22.4489 20.3411 22.4489 19.1863H20.4489ZM20.358 19.0954C20.4082 19.0954 20.4489 19.1361 20.4489 19.1863H22.4489C22.4489 18.0316 21.5127 17.0954 20.358 17.0954V19.0954ZM20.267 19.1863C20.267 19.1361 20.3077 19.0954 20.358 19.0954V17.0954C19.2032 17.0954 18.267 18.0316 18.267 19.1863H20.267ZM20.358 19.2773C20.3077 19.2773 20.267 19.2366 20.267 19.1863H18.267C18.267 20.3411 19.2032 21.2773 20.358 21.2773V19.2773Z"
                    fill="#FF2164"
                    mask="url(#path-6-inside-1_3_15429)"
                />
            </g>
            <defs>
                <clipPath id="clip0_3_15429">
                    <rect
                        width="36"
                        height="36"
                        fill="white"
                        transform="translate(2 2)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DropDownBlackIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                d="M1.5 4.27246L6.95455 9.72701L12.4091 4.27246"
                stroke="black"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const PlayIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="17.5"
                fill="#FDD000"
                stroke="black"
            />
            <g clipPath="">
                <path
                    d="M23.75 16.701C24.75 17.2783 24.75 18.7217 23.75 19.299L16.25 23.6292C15.25 24.2065 14 23.4848 14 22.3301L14 13.6699C14 12.5152 15.25 11.7935 16.25 12.3708L23.75 16.701Z"
                    fill="white"
                    stroke="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_3_19438">
                    <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(9 9)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PauseIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="17.5"
                fill="#FDD000"
                stroke="black"
            />
            <mask
                id="path-2-inside-1_3_19461"
                fill="white"
            >
                <rect
                    x="12.5"
                    y="11.5"
                    width="4.5"
                    height="13"
                    rx="0.5"
                />
            </mask>
            <rect
                x="12.5"
                y="11.5"
                width="4.5"
                height="13"
                rx="0.5"
                fill="white"
                stroke="black"
                strokeWidth="2"
                mask="url(#path-2-inside-1_3_19461)"
            />
            <mask
                id="path-3-inside-2_3_19461"
                fill="white"
            >
                <rect
                    x="19"
                    y="11.5"
                    width="4.5"
                    height="13"
                    rx="0.5"
                />
            </mask>
            <rect
                x="19"
                y="11.5"
                width="4.5"
                height="13"
                rx="0.5"
                fill="white"
                stroke="black"
                strokeWidth="2"
                mask="url(#path-3-inside-2_3_19461)"
            />
        </svg>
    );
};

export const DotIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="2"
            height="2"
            viewBox="0 0 2 2"
            fill="none"
        >
            <circle
                cx="1"
                cy="1"
                r="1"
                fill="black"
            />
        </svg>
    );
};

export const ViewTable: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                d="M0.5 0.5H13.5V5.5H0.5V0.5Z"
                stroke="black"
            />
            <path
                d="M0.5 8.5H13.5V13.5H0.5V8.5Z"
                stroke="black"
            />
        </svg>
    );
};

export const ViewTableActive: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                d="M0 0H14V6H0V0Z"
                fill="black"
            />
            <path
                d="M0 8H14V14H0V8Z"
                fill="black"
            />
        </svg>
    );
};

export const ViewGrid: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                d="M0.5 8.5H5.5V13.5H0.5V8.5Z"
                stroke="black"
            />
            <path
                d="M0.5 0.5H5.5V5.5H0.5V0.5Z"
                stroke="black"
            />
            <path
                d="M8.5 8.5H13.5V13.5H8.5V8.5Z"
                stroke="black"
            />
            <path
                d="M8.5 0.5H13.5V5.5H8.5V0.5Z"
                stroke="black"
            />
        </svg>
    );
};

export const ViewGridActive: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <rect
                width="14"
                height="14"
                fill="white"
            />
            <path
                d="M0 8H6V14H0V8Z"
                fill="black"
            />
            <path
                d="M0 0H6V6H0V0Z"
                fill="black"
            />
            <path
                d="M8 8H14V14H8V8Z"
                fill="black"
            />
            <path
                d="M8 0H14V6H8V0Z"
                fill="black"
            />
        </svg>
    );
};

export const CheckRedIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7 13C8.38813 13 9.73332 12.5187 10.8064 11.6381C11.8794 10.7574 12.6139 9.532 12.8847 8.17054C13.1555 6.80908 12.9459 5.39584 12.2915 4.17162C11.6372 2.9474 10.5786 1.98794 9.2961 1.45672C8.01364 0.925508 6.58665 0.855405 5.25829 1.25836C3.92993 1.66131 2.78239 2.51239 2.01118 3.66658C1.23998 4.82077 0.892831 6.20665 1.02889 7.5881C1.16495 8.96955 1.7758 10.2611 2.75736 11.2426"
                stroke="#FF4A4D"
                strokeLinecap="round"
            />
            <path
                d="M5.18782 12.6076C5.18782 12.9758 4.88935 13.2743 4.52116 13.2743C4.15297 13.2743 3.85449 12.9758 3.85449 12.6076C3.85449 12.2395 4.15297 11.941 4.52116 11.941C4.88935 11.941 5.18782 12.2395 5.18782 12.6076Z"
                fill="#FF4A4D"
            />
            <path
                d="M9.75 5.25L7.81871 7.56755C7.16314 8.35423 6.83535 8.74758 6.39478 8.76756C5.95421 8.78755 5.59216 8.42549 4.86806 7.70139L4.41667 7.25"
                stroke="#FF4A4D"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const ArrowToolTipIcon: React.FC<IconProps> = ({ width = '26', height = '26', fill = 'black' }) => {
    return (
        <svg
            width="32"
            height="23"
            viewBox="0 0 32 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.3124 21.3353C14.5132 22.9035 16.8756 22.9035 18.0763 21.3353L30.6949 4.85506C32.2062 2.88128 30.7988 0.03125 28.3129 0.03125H3.07583C0.589909 0.03125 -0.817419 2.88128 0.693865 4.85506L13.3124 21.3353Z"
                fill="#F9F9F9"
            />
        </svg>
    );
};

export const PaymentSuccessIcon: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="white"
            />
            <path
                d="M24.001 8.66699L34.0005 19.0003L24.0005 29.0003L14.0005 19.0003L24.001 8.66699Z"
                fill="#FDD000"
            />
            <path
                d="M34 19H14L24 8.5L34 19Z"
                fill="#FFBC11"
            />
            <rect
                x="33.2422"
                y="12"
                width="2"
                height="6"
                transform="rotate(45 33.2422 12)"
                fill="#E42044"
            />
            <rect
                x="14"
                y="19"
                width="20"
                height="17"
                fill="#AF2DFF"
            />
        </svg>
    );
};

export const PaymentSuccessIconDisabled: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="#F2F7FF"
            />
            <path
                d="M34 19H14L24 8.5L34 19Z"
                fill="#2073F6"
                fillOpacity="0.3"
            />
            <rect
                x="33.2422"
                y="12"
                width="2"
                height="6"
                transform="rotate(45 33.2422 12)"
                fill="#2073F6"
                fillOpacity="0.2"
            />
            <rect
                x="14"
                y="19"
                width="20"
                height="17"
                fill="#2073F6"
                fillOpacity="0.5"
            />
        </svg>
    );
};

export const PreparingProductIcon: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="white"
            />
            <circle
                cx="24"
                cy="27"
                r="10"
                fill="#FF4A6B"
            />
            <rect
                x="35.2422"
                y="20"
                width="2"
                height="6"
                transform="rotate(45 35.2422 20)"
                fill="#FFBC11"
            />
            <path
                d="M24 15.1111C24 11.1838 27.1838 8 31.1111 8C31.602 8 32 8.39797 32 8.88889C32 12.8162 28.8162 16 24.8889 16C24.398 16 24 15.602 24 15.1111Z"
                fill="#16D7B4"
            />
        </svg>
    );
};

export const PreparingProductIconDisabled: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="#F2F7FF"
            />
            <circle
                cx="24"
                cy="27"
                r="10"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <rect
                x="35.2422"
                y="20"
                width="2"
                height="6"
                transform="rotate(45 35.2422 20)"
                fill="#2073F6"
                fillOpacity="0.2"
            />
            <path
                d="M24 15.1111C24 11.1838 27.1838 8 31.1111 8C31.602 8 32 8.39797 32 8.88889C32 12.8162 28.8162 16 24.8889 16C24.398 16 24 15.602 24 15.1111Z"
                fill="#2073F6"
                fillOpacity="0.3"
            />
        </svg>
    );
};

export const DeliveryBeginIcon: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="white"
            />
            <path
                d="M24 19L35.2583 38.5H12.7417L24 19Z"
                fill="#FFBC11"
            />
            <circle
                cx="24"
                cy="14"
                r="4"
                fill="#FF2164"
            />
            <rect
                x="31.2422"
                y="23"
                width="2"
                height="6"
                transform="rotate(45 31.2422 23)"
                fill="#4C3CFF"
            />
        </svg>
    );
};

export const DeliveryBeginIconDisabled: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="#F2F7FF"
            />
            <path
                d="M24 19L35.2583 38.5H12.7417L24 19Z"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <circle
                cx="24"
                cy="14"
                r="4"
                fill="#2073F6"
                fillOpacity="0.3"
            />
            <rect
                x="31.2422"
                y="23"
                width="2"
                height="6"
                transform="rotate(45 31.2422 23)"
                fill="#2073F6"
                fillOpacity="0.2"
            />
        </svg>
    );
};

export const ShippingIcon: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="white"
            />
            <path
                d="M24 40.5L35.2583 21H12.7417L24 40.5Z"
                fill="#4C3CFF"
            />
            <path
                d="M34 21C34 19.6868 33.7413 18.3864 33.2388 17.1732C32.7362 15.9599 31.9997 14.8575 31.0711 13.9289C30.1425 13.0003 29.0401 12.2638 27.8268 11.7612C26.6136 11.2587 25.3132 11 24 11C22.6868 11 21.3864 11.2587 20.1732 11.7612C18.9599 12.2638 17.8575 13.0003 16.9289 13.9289C16.0003 14.8575 15.2638 15.9599 14.7612 17.1732C14.2587 18.3864 14 19.6868 14 21L24 21H34Z"
                fill="#FFBC11"
            />
            <rect
                x="33.2422"
                y="12"
                width="2"
                height="6"
                transform="rotate(45 33.2422 12)"
                fill="#FF2164"
            />
        </svg>
    );
};

export const ShippingIconDisabled: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="#F2F7FF"
            />
            <path
                d="M24 40.5L35.2583 21H12.7417L24 40.5Z"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <path
                d="M34 21C34 19.6868 33.7413 18.3864 33.2388 17.1732C32.7362 15.9599 31.9997 14.8575 31.0711 13.9289C30.1425 13.0003 29.0401 12.2638 27.8268 11.7612C26.6136 11.2587 25.3132 11 24 11C22.6868 11 21.3864 11.2587 20.1732 11.7612C18.9599 12.2638 17.8575 13.0003 16.9289 13.9289C16.0003 14.8575 15.2638 15.9599 14.7612 17.1732C14.2587 18.3864 14 19.6868 14 21L24 21H34Z"
                fill="#2073F6"
                fillOpacity="0.3"
            />
            <rect
                x="33.2422"
                y="12"
                width="2"
                height="6"
                transform="rotate(45 33.2422 12)"
                fill="#2073F6"
                fillOpacity="0.2"
            />
        </svg>
    );
};

export const DeliverySuccessIcon: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="white"
            />
            <path
                d="M23.5283 17.0283C20.7513 14.2513 20.7513 9.74875 23.5283 6.97169C23.8754 6.62455 24.4383 6.62455 24.7854 6.97169C27.5625 9.74875 27.5625 14.2513 24.7854 17.0283C24.4383 17.3754 23.8754 17.3754 23.5283 17.0283Z"
                fill="#FDD000"
            />
            <path
                d="M23.4004 16.4119C23.4004 12.4845 26.5841 9.30078 30.5115 9.30078C31.0024 9.30078 31.4004 9.69875 31.4004 10.1897C31.4004 14.117 28.2166 17.3008 24.2893 17.3008C23.7984 17.3008 23.4004 16.9028 23.4004 16.4119Z"
                fill="#16D7B4"
            />
            <rect
                x="14"
                y="19"
                width="20"
                height="17"
                fill="#FF4A6B"
            />
            <rect
                x="36.2422"
                y="20"
                width="2"
                height="6"
                transform="rotate(45 36.2422 20)"
                fill="#8DCC21"
            />
        </svg>
    );
};

export const DeliverySuccessIconDisabled: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                fill="#F2F7FF"
            />
            <path
                opacity="0.2"
                d="M23.5283 17.0283C20.7513 14.2513 20.7513 9.74875 23.5283 6.97169C23.8754 6.62455 24.4383 6.62455 24.7854 6.97169C27.5625 9.74875 27.5625 14.2513 24.7854 17.0283C24.4383 17.3754 23.8754 17.3754 23.5283 17.0283Z"
                fill="#2073F6"
            />
            <path
                d="M23.4004 16.4119C23.4004 12.4845 26.5841 9.30078 30.5115 9.30078C31.0024 9.30078 31.4004 9.69875 31.4004 10.1897C31.4004 14.117 28.2166 17.3008 24.2893 17.3008C23.7984 17.3008 23.4004 16.9028 23.4004 16.4119Z"
                fill="#2073F6"
                fillOpacity="0.3"
            />
            <rect
                x="14"
                y="19"
                width="20"
                height="17"
                fill="#2073F6"
                fillOpacity="0.5"
            />
            <rect
                x="36.2422"
                y="20"
                width="2"
                height="6"
                transform="rotate(45 36.2422 20)"
                fill="#2073F6"
                fillOpacity="0.2"
            />
        </svg>
    );
};

export const CancelOrderIcon: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="30"
                cy="30"
                r="30"
                fill="#2073F6"
                fillOpacity="0.1"
            />
            <path
                d="M16 12.9902C18.2325 12.9902 20.4431 13.4299 22.5056 14.2843C24.5682 15.1386 26.4422 16.3908 28.0208 17.9694C29.5994 19.548 30.8516 21.4221 31.706 23.4846C32.5603 25.5472 33 27.7578 33 29.9902C33 32.2227 32.5603 34.4333 31.706 36.4959C30.8516 38.5584 29.5994 40.4325 28.0208 42.011C26.4422 43.5896 24.5682 44.8419 22.5056 45.6962C20.4431 46.5505 18.2325 46.9902 16 46.9902L16 29.9902L16 12.9902Z"
                fill="#15C9E2"
            />
            <path
                d="M20.9786 42.0101C19.4 40.4315 18.1478 38.5574 17.2934 36.4949C16.4391 34.4323 15.9994 32.2217 15.9994 29.9893C15.9994 27.7568 16.4391 25.5462 17.2934 23.4836C18.1478 21.4211 19.4 19.547 20.9786 17.9684C22.5572 16.3898 24.4312 15.1376 26.4938 14.2833C28.5563 13.429 30.7669 12.9893 32.9994 12.9893C35.2319 12.9893 37.4425 13.429 39.505 14.2833C41.5675 15.1376 43.4416 16.3898 45.0202 17.9684L32.9994 29.9893L20.9786 42.0101Z"
                fill="#7E2CF5"
                fillOpacity="0.7"
            />
            <path
                d="M45.0208 42.0107C43.4422 43.5893 41.5682 44.8415 39.5056 45.6958C37.4431 46.5502 35.2325 46.9899 33 46.9899C30.7675 46.9899 28.5569 46.5502 26.4944 45.6958C24.4318 44.8415 22.5578 43.5893 20.9792 42.0107C19.4006 40.4321 18.1484 38.558 17.294 36.4955C16.4397 34.433 16 32.2223 16 29.9899C16 27.7574 16.4397 25.5468 17.294 23.4843C18.1484 21.4217 19.4006 19.5477 20.9792 17.9691L33 29.9899L45.0208 42.0107Z"
                fill="#FF4A6B"
                fillOpacity="0.7"
            />
            <rect
                x="40"
                y="28"
                width="4"
                height="4"
                rx="2"
                fill="#FF4A6B"
            />
            <rect
                x="46"
                y="29"
                width="2"
                height="2"
                rx="1"
                fill="#FF4A6B"
            />
        </svg>
    );
};

export const DotForUL: React.FC<IconProps> = ({ width = '48', height = '48', fill = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="3"
            height="3"
            viewBox="0 0 3 3"
            fill="none"
        >
            <circle
                cx="1.5"
                cy="1.5"
                r="1.5"
                fill="#BBBBBB"
            />
        </svg>
    );
};

export const CircleRed = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
        >
            <circle
                cx="3"
                cy="3"
                r="3"
                fill="#FF2164"
            />
        </svg>
    );
};

export const BellIconYellow = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <circle
                cx="12"
                cy="21"
                r="1"
                fill="black"
            />
            <path
                d="M6.44784 8.96942C6.76219 6.14032 9.15349 4 12 4C14.8465 4 17.2378 6.14032 17.5522 8.96942L17.804 11.2356C17.8072 11.2645 17.8088 11.279 17.8104 11.2933C17.9394 12.417 18.3051 13.5005 18.8836 14.4725C18.8909 14.4849 18.8984 14.4973 18.9133 14.5222L19.4914 15.4856C20.0159 16.3599 20.2782 16.797 20.2216 17.1559C20.1839 17.3946 20.061 17.6117 19.8757 17.7668C19.5971 18 19.0873 18 18.0678 18H5.93223C4.91268 18 4.40291 18 4.12434 17.7668C3.93897 17.6117 3.81609 17.3946 3.77841 17.1559C3.72179 16.797 3.98407 16.3599 4.50862 15.4856L5.08665 14.5222C5.10161 14.4973 5.10909 14.4849 5.11644 14.4725C5.69488 13.5005 6.06064 12.417 6.18959 11.2933C6.19123 11.279 6.19283 11.2645 6.19604 11.2356L6.44784 8.96942Z"
                fill="#FDD000"
                stroke="black"
            />
        </svg>
    );
};

export const BellIconWithNotification = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="12"
                cy="21"
                r="1"
                fill="black"
            />
            <path
                d="M6.44784 8.96942C6.76219 6.14032 9.15349 4 12 4V4C14.8465 4 17.2378 6.14032 17.5522 8.96942L17.804 11.2356C17.8072 11.2645 17.8088 11.279 17.8104 11.2933C17.9394 12.4169 18.3051 13.5005 18.8836 14.4725C18.8909 14.4849 18.8984 14.4973 18.9133 14.5222L19.4914 15.4856C20.0159 16.3599 20.2782 16.797 20.2216 17.1559C20.1839 17.3946 20.061 17.6117 19.8757 17.7668C19.5971 18 19.0873 18 18.0678 18H5.93223C4.91268 18 4.40291 18 4.12434 17.7668C3.93897 17.6117 3.81609 17.3946 3.77841 17.1559C3.72179 16.797 3.98407 16.3599 4.50862 15.4856L5.08665 14.5222C5.10161 14.4973 5.10909 14.4849 5.11644 14.4725C5.69488 13.5005 6.06064 12.4169 6.18959 11.2933C6.19123 11.279 6.19283 11.2645 6.19604 11.2356L6.44784 8.96942Z"
                stroke="black"
            />
            <circle
                cx="18"
                cy="6"
                r="3"
                fill="#FF2164"
            />
        </svg>
    );
};

export const BellIconWithNotificationYellow = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="12"
                cy="21"
                r="1"
                fill="black"
            />
            <path
                d="M6.44784 8.96942C6.76219 6.14032 9.15349 4 12 4C14.8465 4 17.2378 6.14032 17.5522 8.96942L17.804 11.2356C17.8072 11.2645 17.8088 11.279 17.8104 11.2933C17.9394 12.417 18.3051 13.5005 18.8836 14.4725C18.8909 14.4849 18.8984 14.4973 18.9133 14.5222L19.4914 15.4856C20.0159 16.3599 20.2782 16.797 20.2216 17.1559C20.1839 17.3946 20.061 17.6117 19.8757 17.7668C19.5971 18 19.0873 18 18.0678 18H5.93223C4.91268 18 4.40291 18 4.12434 17.7668C3.93897 17.6117 3.81609 17.3946 3.77841 17.1559C3.72179 16.797 3.98407 16.3599 4.50862 15.4856L5.08665 14.5222C5.10161 14.4973 5.10909 14.4849 5.11644 14.4725C5.69488 13.5005 6.06064 12.417 6.18959 11.2933C6.19123 11.279 6.19283 11.2645 6.19604 11.2356L6.44784 8.96942Z"
                fill="#FDD000"
                stroke="black"
            />
            <circle
                cx="18"
                cy="6"
                r="3"
                fill="#FF2164"
            />
        </svg>
    );
};

export const DirectMessage: React.FC<IconProps> = ({ width = '21', height = '19', fill = 'black', color = 'black' }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.5449 6.42773C20.9512 6.42751 21.1886 6.88663 20.9531 7.21777L11.2324 20.8887C10.9615 21.269 10.3627 21.1033 10.3262 20.6377L9.74512 13.1602C9.71374 12.7572 9.52124 12.384 9.21094 12.125L3.45117 7.32129C3.09221 7.02192 3.30408 6.43776 3.77148 6.4375L20.5449 6.42773Z"
                stroke="black"
            />
            <path
                d="M9.5 12.6002L21 6.7002"
                stroke="black"
            />
        </svg>
    );
};

export const SearchIcon: React.FC<IconProps> = ({ width = '20', height = '20', color = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="9"
                cy="9"
                r="7"
                stroke={color}
            />
            <path
                d="M17.6464 18.3536C17.8417 18.5488 18.1583 18.5488 18.3536 18.3536C18.5488 18.1583 18.5488 17.8417 18.3536 17.6464L18 18L17.6464 18.3536ZM14.3536 13.6464L14 13.2929L13.2929 14L13.6464 14.3536L14 14L14.3536 13.6464ZM18 18L18.3536 17.6464L14.3536 13.6464L14 14L13.6464 14.3536L17.6464 18.3536L18 18Z"
                fill={color}
            />
        </svg>
    );
};

export const CommunitySearchIcon: React.FC<IconProps> = ({ width = '20', height = '20', color = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="9"
                cy="9"
                r="7"
                stroke={color}
                strokeWidth="2"
            />
            <path
                d="M17.6262 19.0404C18.0168 19.431 18.6499 19.431 19.0404 19.0404C19.431 18.6499 19.431 18.0168 19.0404 17.6262L18.3333 18.3333L17.6262 19.0404ZM15.7071 14.2929L15 13.5858L13.5858 15L14.2929 15.7071L15 15L15.7071 14.2929ZM18.3333 18.3333L19.0404 17.6262L15.7071 14.2929L15 15L14.2929 15.7071L17.6262 19.0404L18.3333 18.3333Z"
                fill={color}
            />
        </svg>
    );
};

// User Level Icons
export const CollectorIcon: React.FC<IconProps> = ({ width = '26', height = '24' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="5.5293"
                y="8.16797"
                width="9.21569"
                height="9.21569"
                transform="rotate(-62.4097 5.5293 8.16797)"
                fill="#FF464F"
            />
            <rect
                y="6.87695"
                width="9.21569"
                height="9.21569"
                transform="rotate(-14.2482 0 6.87695)"
                fill="#FFB846"
            />
            <rect
                x="16.8843"
                y="1.59961"
                width="9.21569"
                height="9.21569"
                transform="rotate(14.9893 16.8843 1.59961)"
                fill="#29EA89"
            />
            <rect
                x="13.9434"
                y="4.6084"
                width="9.21569"
                height="9.21569"
                transform="rotate(30.8644 13.9434 4.6084)"
                fill="#DA46FF"
            />
            <rect
                x="0.921387"
                y="12.4414"
                width="18.4314"
                height="11.0588"
                fill="#52C5FF"
            />
            <path
                d="M19.353 12.4417L24.8824 7.37305V18.4319L19.353 23.5005V12.4417Z"
                fill="#1C84D9"
            />
        </svg>
    );
};

export const MakerIcon: React.FC<IconProps> = ({ width = '38', height = '28' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 38 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.78082 19.1112L12.3077 14.038L14.2865 17.6552L2.78082 19.1112Z"
                fill="#0F94C4"
            />
            <path
                d="M26.6068 1.5166L25.5394 15.2319L20.9328 15.4021L26.6068 1.5166Z"
                fill="#56D2FF"
            />
            <path
                d="M20.4055 11.4053L24.9295 14.8743L18.3051 19.1892L15.4634 14.247L20.4055 11.4053Z"
                fill="#2AAEDE"
            />
            <path
                d="M20.4056 11.4062L18.4316 19.6738L15.4635 14.248L20.4056 11.4062Z"
                fill="#0F94C4"
            />
            <path
                d="M10.0762 9.45355L7.44827 13.2409L11.0655 11.2622L10.0762 9.45355Z"
                fill="#2AAEDE"
            />
            <path
                d="M10.0762 9.45389L14.7312 25.2915L21.713 20.3665L11.8848 8.46452L10.0762 9.45389Z"
                fill="#56D2FF"
            />
            <path
                d="M15.1497 18.9802L26.6117 13.4014L26.529 17.0405L14.7315 25.2909L15.1497 18.9802Z"
                fill="#2AAEDE"
            />
            <path
                d="M17.442 17.8643L26.6115 13.4012L37.468 19.3499L17.442 17.8643Z"
                fill="#88DFFF"
            />
        </svg>
    );
};

export const LeaderIcon: React.FC<IconProps> = ({ width = '23', height = '30' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 23 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.0294 19.1826C22.0294 25.1568 17.0979 30 11.0147 30C4.93147 30 0 25.1568 0 19.1826C0 8.91516 9.92068 0 9.92068 0C9.92068 0 10.7969 7.23448 14.0449 7.5595C14.8745 7.64255 15.7442 6.77612 14.9352 3.47588C20.6603 9.49576 22.0294 15 22.0294 19.1826Z"
                fill="#FF4516"
            />
            <path
                d="M9.14517 2.53519C9.26515 3.01721 9.41208 3.53724 9.58956 4.06045C10.5873 7.00151 12.0438 8.58789 13.9188 8.77551C13.9959 8.78321 14.0738 8.78712 14.1504 8.78712C14.8248 8.78712 15.4298 8.49603 15.8537 7.96744C16.0669 7.70171 16.2274 7.38611 16.3354 7.01875C17.6875 8.80466 18.7374 10.6271 19.4704 12.4641C20.3426 14.65 20.7848 16.9103 20.7848 19.1826C20.7848 21.7455 19.7685 24.155 17.9232 25.9674C16.0779 27.7797 13.6244 28.7777 11.0147 28.7777C8.40501 28.7777 5.95154 27.7796 4.10617 25.9674C2.26081 24.1551 1.2446 21.7455 1.2446 19.1826C1.2446 17.0061 1.73211 14.703 2.69356 12.3374C3.47635 10.4116 4.57221 8.44194 5.95091 6.48319C7.09762 4.85397 8.25379 3.50094 9.14517 2.53519ZM9.92068 0C9.92068 0 0 8.91516 0 19.1826C0 25.1568 4.93147 30 11.0147 30C17.0979 30 22.0294 25.1568 22.0294 19.1826C22.0294 14.9999 20.6603 9.49576 14.9352 3.47588C15.7099 6.63653 14.9452 7.56481 14.1504 7.56481C14.1153 7.56481 14.0801 7.56304 14.045 7.5595C10.7969 7.23448 9.92068 0 9.92068 0Z"
                fill="#FF962D"
            />
            <path
                d="M11.0148 12.7559C11.0148 12.7559 5.49707 17.8919 5.49707 22.6362C5.49707 25.629 7.96741 28.0551 11.0148 28.0551C14.0622 28.0551 16.5325 25.629 16.5325 22.6362C16.5325 17.8919 11.0148 12.7559 11.0148 12.7559Z"
                fill="#FFB833"
            />
            <path
                d="M11.0147 18.4834C11.0147 18.4834 7.71289 21.5568 7.71289 24.3958C7.71289 26.1866 9.1911 27.6384 11.0147 27.6384C12.8383 27.6384 14.3165 26.1866 14.3165 24.3958C14.3165 21.5568 11.0147 18.4834 11.0147 18.4834Z"
                fill="#FFF832"
            />
        </svg>
    );
};

export const JoyianIcon: React.FC<IconProps> = ({ width = '26', height = '24' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.8672 2.04199C17.4139 -0.680282 21.5431 -0.680282 24.0898 2.04199C26.6365 4.76427 26.6366 9.17815 24.0898 11.9004L13.7061 23C13.5116 23.2078 13.2548 23.3072 13 23.3008C12.7453 23.3071 12.4883 23.2078 12.2939 23L1.91016 11.9004C-0.636534 9.17817 -0.636433 4.76428 1.91016 2.04199C4.4569 -0.680282 8.58607 -0.680282 11.1328 2.04199L13 4.03711L14.8672 2.04199Z"
                fill="#FF45B4"
            />
            <path
                d="M9.00049 9.5L12.0005 14L18.0005 8"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const ComingSoonIcon: React.FC<IconProps> = ({ width = '80', height = '80' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 32L40 15L66 32"
                stroke="#B7BDCA"
            />
            <path
                d="M4.00006 36.0001C4.00003 33.2386 6.23862 31 9.00006 31H71C73.7614 31 76 33.2386 76 36V66C76 68.7614 73.7614 71 71 71H9.00045C6.23905 71 4.00049 68.7615 4.00045 66.0001L4.00006 36.0001Z"
                fill="#2073F6"
            />
            <path
                d="M9 33.25H71C72.5188 33.25 73.75 34.4812 73.75 36V66C73.75 67.5188 72.5188 68.75 71 68.75H9C7.48144 68.7498 6.25002 67.5186 6.25 66V36C6.25 34.5762 7.33212 33.4056 8.71875 33.2646L9 33.25Z"
                stroke="white"
                strokeWidth="0.5"
            />
            <path
                d="M18.3545 48.312C15.7145 48.312 13.8665 46.392 13.8665 43.668C13.8665 40.932 15.7145 39.012 18.3545 39.024C19.6025 39.024 20.7185 39.552 21.5225 40.38L20.3585 41.664C19.9385 41.04 19.1585 40.608 18.3425 40.608C16.7105 40.596 15.6905 41.772 15.6905 43.668C15.6905 45.552 16.7105 46.728 18.3425 46.728C19.3025 46.728 19.9265 46.224 20.2745 45.744L21.5225 46.956C20.7185 47.784 19.7465 48.336 18.3545 48.312ZM27.0183 46.728C28.7343 46.728 29.8023 45.552 29.8023 43.668C29.8023 41.784 28.7343 40.608 27.0183 40.608C25.3023 40.608 24.2343 41.784 24.2343 43.668C24.2343 45.552 25.3023 46.728 27.0183 46.728ZM27.0183 39.024C29.7183 39.024 31.6263 40.944 31.6263 43.668C31.6263 46.392 29.7183 48.312 27.0183 48.312C24.3183 48.312 22.4103 46.392 22.4103 43.668C22.4103 40.944 24.3183 39.024 27.0183 39.024ZM37.2186 46.104L34.7946 42.168V48.216H32.9706V39.12H35.0346L37.9386 43.764L40.8426 39.12H42.9066V48.216H41.0826V42.168L38.6586 46.104H37.2186ZM44.631 39.12H46.455V48.216H44.631V39.12ZM55.8389 39.12V48.216H53.7749L49.9229 42.156V48.216H48.0989V39.12H50.1629L54.0149 45.192V39.12H55.8389ZM66.0361 43.368V44.244C66.0361 46.716 64.4521 48.312 61.7761 48.312C59.0761 48.312 57.1681 46.392 57.1681 43.668C57.1681 40.944 59.0761 39.036 61.7761 39.036C64.6561 39.036 65.7001 41.22 65.7001 41.22L64.1761 42.072C64.1761 42.072 63.4801 40.62 61.7641 40.62C60.0601 40.62 58.9921 41.796 58.9921 43.668C58.9921 45.552 60.0601 46.728 61.7641 46.728C62.9881 46.728 64.1761 46.236 64.2121 44.808H61.8841V43.368H66.0361ZM23.3827 59.372C24.0187 60.548 24.6667 60.776 25.1707 60.776C26.2627 60.776 26.6827 60.296 26.6827 59.636C26.6827 58.052 22.3147 58.76 22.3147 55.58C22.3147 54.008 23.5507 53.024 25.3627 53.024C26.3827 53.024 27.7387 53.648 28.3507 55.244L26.7547 55.832C26.3347 54.776 25.7587 54.572 25.3627 54.572C24.5347 54.572 24.1267 55.028 24.1267 55.58C24.1267 57.152 28.4947 56.684 28.4947 59.636C28.4947 61.22 27.2467 62.324 25.1707 62.324C23.8147 62.324 22.6867 61.508 21.9067 60.212L23.3827 59.372ZM34.1433 60.728C35.8593 60.728 36.9273 59.552 36.9273 57.668C36.9273 55.784 35.8593 54.608 34.1433 54.608C32.4273 54.608 31.3593 55.784 31.3593 57.668C31.3593 59.552 32.4273 60.728 34.1433 60.728ZM34.1433 53.024C36.8433 53.024 38.7513 54.944 38.7513 57.668C38.7513 60.392 36.8433 62.312 34.1433 62.312C31.4433 62.312 29.5353 60.392 29.5353 57.668C29.5353 54.944 31.4433 53.024 34.1433 53.024ZM44.3855 60.728C46.1015 60.728 47.1695 59.552 47.1695 57.668C47.1695 55.784 46.1015 54.608 44.3855 54.608C42.6695 54.608 41.6015 55.784 41.6015 57.668C41.6015 59.552 42.6695 60.728 44.3855 60.728ZM44.3855 53.024C47.0855 53.024 48.9935 54.944 48.9935 57.668C48.9935 60.392 47.0855 62.312 44.3855 62.312C41.6855 62.312 39.7775 60.392 39.7775 57.668C39.7775 54.944 41.6855 53.024 44.3855 53.024ZM58.0538 53.12V62.216H55.9898L52.1378 56.156V62.216H50.3138V53.12H52.3778L56.2298 59.192V53.12H58.0538Z"
                fill="white"
            />
            <circle
                cx="40"
                cy="15"
                r="3"
                fill="#111B48"
            />
        </svg>
    );
};

export const LevelBadgeIcon: React.FC<IconProps> = ({ width = '43', height = '43' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 43 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_2128_18134)">
                <path
                    d="M19.5052 1.68168C20.3008 0.786644 21.6992 0.786644 22.4948 1.68168L25.2183 4.74558C25.6991 5.28647 26.4345 5.52544 27.1414 5.37045L31.1457 4.49251C32.3154 4.23605 33.4468 5.05805 33.5644 6.24978L33.9668 10.3293C34.0378 11.0495 34.4924 11.6752 35.1553 11.9653L38.9109 13.6087C40.008 14.0887 40.4401 15.4187 39.8347 16.452L37.7624 19.9889C37.3965 20.6133 37.3965 21.3867 37.7624 22.0111L39.8347 25.548C40.4401 26.5813 40.008 27.9113 38.9109 28.3913L35.1553 30.0347C34.4924 30.3248 34.0378 30.9505 33.9668 31.6707L33.5644 35.7502C33.4468 36.9419 32.3154 37.764 31.1457 37.5075L27.1414 36.6295C26.4345 36.4746 25.6991 36.7135 25.2183 37.2544L22.4948 40.3183C21.6992 41.2134 20.3008 41.2134 19.5052 40.3183L16.7817 37.2544C16.3009 36.7135 15.5655 36.4746 14.8586 36.6295L10.8543 37.5075C9.68458 37.764 8.55319 36.9419 8.43564 35.7502L8.03323 31.6707C7.96219 30.9505 7.50764 30.3248 6.84466 30.0347L3.08911 28.3913C1.99203 27.9113 1.55988 26.5813 2.16526 25.548L4.23761 22.0111C4.60345 21.3867 4.60345 20.6133 4.23761 19.9889L2.16526 16.452C1.55988 15.4187 1.99203 14.0887 3.08911 13.6087L6.84466 11.9653C7.50764 11.6752 7.96219 11.0495 8.03323 10.3294L8.43564 6.24978C8.55319 5.05805 9.68458 4.23605 10.8543 4.49251L14.8586 5.37045C15.5655 5.52544 16.3009 5.28647 16.7817 4.74558L19.5052 1.68168Z"
                    fill="#FDC200"
                />
            </g>
            <path
                d="M10.9649 21.032H21.0089V22.328H10.9649V21.032ZM12.1769 19.004H19.8689V20.264H12.1769V19.004ZM12.1769 16.244H19.8089V17.528H13.7609V19.628H12.1769V16.244ZM15.9449 22.976C17.1449 22.976 18.0889 23.156 18.7769 23.516C19.4649 23.868 19.8089 24.372 19.8089 25.028C19.8089 25.676 19.4649 26.176 18.7769 26.528C18.0889 26.888 17.1449 27.068 15.9449 27.068C14.7449 27.068 13.8009 26.888 13.1129 26.528C12.4329 26.176 12.0929 25.676 12.0929 25.028C12.0929 24.372 12.4329 23.868 13.1129 23.516C13.8009 23.156 14.7449 22.976 15.9449 22.976ZM15.9449 24.188C15.4489 24.188 15.0329 24.22 14.6969 24.284C14.3689 24.34 14.1209 24.432 13.9529 24.56C13.7849 24.68 13.7009 24.836 13.7009 25.028C13.7009 25.212 13.7849 25.368 13.9529 25.496C14.1209 25.616 14.3689 25.708 14.6969 25.772C15.0329 25.828 15.4489 25.856 15.9449 25.856C16.4409 25.856 16.8529 25.828 17.1809 25.772C17.5169 25.708 17.7689 25.616 17.9369 25.496C18.1049 25.368 18.1889 25.212 18.1889 25.028C18.1889 24.836 18.1049 24.68 17.9369 24.56C17.7689 24.432 17.5169 24.34 17.1809 24.284C16.8529 24.22 16.4409 24.188 15.9449 24.188ZM23.18 22.28H24.752V23.432H29.252V22.28H30.836V26.948H23.18V22.28ZM24.752 24.668V25.676H29.252V24.668H24.752ZM23.228 16.388H30.26V17.66H23.228V16.388ZM21.992 20.276H32.06V21.56H21.992V20.276ZM29.3 16.388H30.872V17.276C30.872 17.74 30.86 18.232 30.836 18.752C30.812 19.264 30.724 19.868 30.572 20.564L28.964 20.672C29.132 19.952 29.228 19.324 29.252 18.788C29.284 18.252 29.3 17.748 29.3 17.276V16.388Z"
                fill="white"
            />
            <defs>
                <filter
                    id="filter0_d_2128_18134"
                    x="1.89014"
                    y="1.0104"
                    width="40.2197"
                    height="41.9792"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset
                        dx="1"
                        dy="1"
                    />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feComposite
                        in2="hardAlpha"
                        operator="out"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.992157 0 0 0 0 0.815686 0 0 0 0 0 0 0 0 0.4 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2128_18134"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2128_18134"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

// Payment Status Icons
export const PaymentCompleteIcon: React.FC<IconProps> = ({ width = '21', height = '28' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 21 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 10.5H0L10 0L20 10.5Z"
                fill="#FFBC11"
            />
            <rect
                x="19.2427"
                y="3.5"
                width="2"
                height="6"
                transform="rotate(45 19.2427 3.5)"
                fill="#E42044"
            />
            <rect
                y="10.5"
                width="20"
                height="17"
                fill="#AF2DFF"
            />
        </svg>
    );
};

export const ProductPrepIcon: React.FC<IconProps> = ({ width = '23', height = '29' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 23 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="10"
                cy="19"
                r="10"
                fill="#FF4A6B"
            />
            <rect
                x="21.2427"
                y="12"
                width="2"
                height="6"
                transform="rotate(45 21.2427 12)"
                fill="#FFBC11"
            />
            <path
                d="M10 7.11111C10 3.18375 13.1838 0 17.1111 0C17.602 0 18 0.397969 18 0.888889C18 4.81625 14.8162 8 10.8889 8C10.398 8 10 7.60203 10 7.11111Z"
                fill="#16D7B4"
            />
        </svg>
    );
};

export const ShippingStartIcon: React.FC<IconProps> = ({ width = '23', height = '29' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 23 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.2583 9L22.5166 28.5H-2.95639e-05L11.2583 9Z"
                fill="#FFBC11"
            />
            <circle
                cx="11.2583"
                cy="4"
                r="4"
                fill="#FF2164"
            />
        </svg>
    );
};

export const ShippingInProgressIcon: React.FC<IconProps> = ({ width = '23', height = '30' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 23 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.2583 29.5L22.5166 10H-2.95639e-05L11.2583 29.5Z"
                fill="#4C3CFF"
            />
            <path
                d="M21.2583 10C21.2583 8.68678 20.9996 7.38642 20.4971 6.17317C19.9945 4.95991 19.258 3.85752 18.3294 2.92893C17.4008 2.00035 16.2984 1.26375 15.0851 0.761204C13.8719 0.258657 12.5715 0 11.2583 0C9.94508 0 8.64472 0.258657 7.43147 0.761206C6.21821 1.26375 5.11582 2.00035 4.18723 2.92893C3.25865 3.85752 2.52205 4.95991 2.01951 6.17317C1.51696 7.38642 1.2583 8.68678 1.2583 10L11.2583 10H21.2583Z"
                fill="#FFBC11"
            />
            <rect
                x="20.501"
                y="1"
                width="2"
                height="6"
                transform="rotate(45 20.501 1)"
                fill="#FF2164"
            />
        </svg>
    );
};

export const ShippingCompleteIcon: React.FC<IconProps> = ({ width = '24', height = '30' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.52831 10.3174C6.75125 7.54032 6.75125 3.03781 9.52831 0.260748C9.87545 -0.0863849 10.4383 -0.086385 10.7854 0.260748C13.5625 3.03781 13.5625 7.54032 10.7854 10.3174C10.4383 10.6645 9.87545 10.6645 9.52831 10.3174Z"
                fill="#FDD000"
            />
            <path
                d="M9.3999 9.70095C9.3999 5.7736 12.5837 2.58984 16.511 2.58984C17.0019 2.58984 17.3999 2.98781 17.3999 3.47873C17.3999 7.40609 14.2161 10.5898 10.2888 10.5898C9.79787 10.5898 9.3999 10.1919 9.3999 9.70095Z"
                fill="#16D7B4"
            />
            <rect
                y="12.2891"
                width="20"
                height="17"
                fill="#FF4A6B"
            />
            <rect
                x="22.2427"
                y="13.2891"
                width="2"
                height="6"
                transform="rotate(45 22.2427 13.2891)"
                fill="#8DCC21"
            />
        </svg>
    );
};

export const StarRatingIcon: React.FC<IconProps> = ({ width = '35', height = '33', fill = '#D9D9D9' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 35 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_i_2679_5043)">
                <path
                    d="M15.2442 1.34298C15.8668 -0.448141 18.3998 -0.448142 19.0224 1.34298L21.8489 9.47428C22.1235 10.2644 22.8609 10.8002 23.6972 10.8172L32.304 10.9926C34.1998 11.0312 34.9826 13.4403 33.4715 14.5859L26.6116 19.7867C25.945 20.2921 25.6634 21.159 25.9056 21.9596L28.3984 30.1993C28.9475 32.0143 26.8982 33.5032 25.3418 32.4202L18.2757 27.5031C17.589 27.0253 16.6776 27.0253 15.9909 27.5031L8.92484 32.4202C7.36836 33.5032 5.31907 32.0143 5.86817 30.1994L8.36099 21.9596C8.60323 21.159 8.32157 20.2921 7.65498 19.7867L0.795065 14.5859C-0.716 13.4403 0.0667605 11.0312 1.96261 10.9926L10.5694 10.8172C11.4057 10.8002 12.1431 10.2644 12.4177 9.47428L15.2442 1.34298Z"
                    fill={fill}
                />
            </g>
            <defs>
                <filter
                    id="filter0_i_2679_5043"
                    x="0"
                    y="-25"
                    width="34.2666"
                    height="57.7871"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="-25" />
                    <feGaussianBlur stdDeviation="50" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.616667 0 0 0 0 0.616667 0 0 0 0 0.616667 0 0 0 0.08 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_2679_5043"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const CopyLinkIcon: React.FC<IconProps> = ({ width = '28', height = '34' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 28 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="1"
                y="1"
                width="18"
                height="24"
                rx="2"
                fill="#CDD0D5"
                stroke="black"
                strokeWidth="2"
            />
            <rect
                x="9"
                y="9"
                width="18"
                height="24"
                rx="2"
                fill="#CDD0D5"
                stroke="black"
                strokeWidth="2"
            />
        </svg>
    );
};

export const MoreShareIcon: React.FC<IconProps> = ({ width = '26', height = '26' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line
                x1="1"
                y1="13"
                x2="25"
                y2="13"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <line
                x1="13"
                y1="1"
                x2="13"
                y2="25"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const PlayButtonYoutube: React.FC<IconProps> = ({ width = '36', height = '36' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="18"
                cy="18"
                r="17.5"
                fill="#FDD000"
                stroke="black"
            />
            <g clipPath="url(#clip0_2279_6356)">
                <path
                    d="M23.75 16.7012C24.7499 17.2785 24.7499 18.7215 23.75 19.2988L16.25 23.6289C15.25 24.2063 14 23.4848 14 22.3301L14 13.6699C14 12.5875 15.0984 11.8855 16.0596 12.2773L16.25 12.3711L23.75 16.7012Z"
                    fill="white"
                    stroke="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_2279_6356">
                    <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(9 9)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const CommunityCartIcon: React.FC<IconProps> = ({ width = '20', height = '20', color = 'black' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.5 5.5H6.2L7.05 12.9C7.12 13.46 7.59 13.88 8.15 13.88H13.76C14.29 13.88 14.74 13.52 14.86 13.01L15.84 8.66C16 7.95 15.46 7.26 14.73 7.26H6.83"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx="8.75"
                cy="16.4"
                r="1"
                fill={color}
            />
            <circle
                cx="13.25"
                cy="16.4"
                r="1"
                fill={color}
            />
        </svg>
    );
};

export { default as EditProfileIcon } from './EditProfileIcon';
export { default as LevelUpIcon } from './LevelUpIcon';
